(function() {
  'use strict';

  angular
    .module('inspinia', ['ngAnimate',
        'ngCookies',
        'ngTouch',
        'ngSanitize',
        'ngMessages',
        'ngAria',
        'ngResource',
        'ui.router', 'ui.bootstrap',
        'datatables', 'datatables.bootstrap', 'datatables.buttons', 'datatables.tabletools',
        'ngMap',
        'angular-growl',
        'mediaPlayer',
        'oc.lazyLoad',
        'angular-peity'
    ])
    .constant('AUTH_EVENTS', {
      notAuthenticated: 'auth-not-authenticated',
      notAuthorized: 'auth-not-authorized'
    })
    .constant('USER_ROLES', {
      admin: 'admin_role',
      customer: 'customer_role'
    });

})();

'use strict';

angular.module('inspinia')
    .controller('CheckIfLoggedController', function () {



    });
'use strict';

angular.module('inspinia')
  .controller('RoutesController', function ($scope, $filter, $state, $http, $compile, DTOptionsBuilder, DTColumnBuilder, AuthService, growl, $interval) {
    var vm = this;
    vm.dataTablesInitialized = false;
    vm.moment = moment;
    vm.campaign_id = $state.params.id;
    if (typeof vm.campaign_id != 'undefined')
      vm.filters = '?filter=[campaign{eq}' + vm.campaign_id + ']&limit=-1';
    else
      vm.filters = '?limit=-1';
    vm.data = {};

    vm.dtOptions = DTOptionsBuilder
      .newOptions()
      .withOption('scrollX', '100%')
      .withOption('stateSave', true)
      .withOption('iDisplayLength', 100)
      .withPaginationType('full_numbers')
      .withBootstrap()
      .withDOM('<"html5buttons"B>lTfgitp')
      .withOption('order', [0, 'desc'])
      .withOption('initComplete', function () {
        var self = this;
        $(self.api().table().container()).find('input').parent().wrap('<form>').parent().attr('autocomplete', 'off');
        $(self.api().table().container()).find('input').attr('autocomplete', 'off');
      })
      .withButtons([
        {extend: 'copy'},
        {extend: 'csv'},
        {
          extend: 'pdfHtml5', //title: },
          customize: function (doc) {
            doc.content.splice(1, 0, {
              margin: [0, 0, 0, 12],
              alignment: 'center',
              text: 'Średni procent skuteczności zakończonych audytów: ' + vm.data.averageRoutesPercent + '% | Skuteczne audyty: ' + vm.data.routeEffectivePercent + '%'
            });
          }
        },
        {
          extend: 'print',
          customize: function (win) {
            $(win.document.body).addClass('white-bg');
            $(win.document.body).css('font-size', '10px');

            $(win.document.body).find('table')
              .addClass('compact')
              .css('font-size', 'inherit');
          }
        }
      ]);

    vm.statuses = {
      N: 'Nowa',
      A: 'Aktywna',
      F: 'Zakończona'
    };

    vm.getTraces = function () {

      $http({
        method: 'GET',
        type: 'json',
        url: AuthService.apiBaseHref() + '/traces' + vm.filters

      }).then(function successCallback(response) {
        var completeRoutes = 0;
        var effectiveRoutes = 0;
        var averageEffective = 0;
        vm.data.routes = response.data.items;

        $.each(vm.data.routes, function (i, route) {
          if (route.status.id == 'f') {
            completeRoutes++;
            averageEffective += route.percent_effectiveness;
          }
          if (route.is_effective)
            effectiveRoutes++;
        });
        vm.data.completeRoutes = completeRoutes;
        vm.data.effectiveRoutes = effectiveRoutes;
        vm.data.averageRoutesPercent = vm.data.routes.length == 0 ? 0 : (averageEffective / vm.data.completeRoutes).toFixed(0);
        vm.data.routeEffectivePercent = vm.data.routes.length == 0 ? 0 : ((effectiveRoutes * 100) / vm.data.routes.length).toFixed(0);

      }, function errorCallback(response) {
        if (response.statusText === "Forbidden") {
          $state.transitionTo('login');
        }
      });
    };

    vm.getCampaign = function () {

      $http({
        method: 'GET',
        type: 'json',
        url: AuthService.apiBaseHref() + '/campaigns?filter=[id{eq}' + vm.campaign_id + ']&limit=-1'

      }).then(function successCallback(response) {
        if (!vm.dataTablesInitialized) {
          vm.dataTablesInitialized = true;
        }
        vm.campaign = response.data.items;

        vm.getTraces();

      }, function errorCallback(response) {
        if (response.statusText === "Forbidden") {
          $state.transitionTo('login');
        }
      });
    };

    vm.getCampaign();

    vm.getCustomers = function () {
      $http({
        method: 'GET',
        type: 'json',
        url: AuthService.apiBaseHref() + '/customers?limit=-1'

      }).then(function successCallback(response) {
        $scope.data.customers = response.data.items;

      }, function errorCallback(response) {
        // called asynchronously if an error occurs
        // or server returns response with an error status.
      });
    };

    vm.getCustomers();

    vm.updateCampaign = function () {
      vm.getCampaign();
    };

    var promiseCamp = $interval(vm.updateCampaign, 60000);

    $scope.stopCamp = function () {

      $interval.cancel(promiseCamp);
    };

    $scope.$on('$destroy', function () {

      $scope.stopCamp();
    });

    vm.addRoute = function () {

      $state.transitionTo('index.routeAdd', {id: vm.campaign_id});
    };

    vm.edit = function (route) {
      var url = $state.href('index.routeEdit', {id:  vm.campaign_id, r_id: route.id});
      window.open(url,'_blank');
    };

    vm.show = function (route) {
      var url = $state.href('index.route-view', {id: route.id});
      window.open(url,'_blank');
    };

    vm.deleteRoute = function (routeId, campaign) {

      $http({
        method: 'DELETE',
        type: 'json',
        url: AuthService.apiBaseHref() + '/traces/' + routeId

      }).then(function successCallback(response) {
        vm.getTraces();
        growl.success("Status Audytu dla Kampanii : " + campaign + " został pomyślnie zmieniony", {ttl: 5000});

      }, function errorCallback(response) {
      });
    };

    vm.changeStatus = function (routeId, status, campaign) {

      $http({
        method: 'PUT',
        type: 'json',
        url: AuthService.apiBaseHref() + '/traces/' + routeId,
        data: {
          'status_id': status
        }

      }).then(function successCallback(response) {
        vm.getTraces();
        growl.success("Status Audytu dla Kampanii : " + campaign + " został pomyślnie zmieniony", {ttl: 5000});

      }, function errorCallback(response) {
      });
    };

    vm.showDelModal = function (visible) {
      vm.showDeleteModal = visible;
    };

    vm.sendParamsToDelModal = function (visible, route) {

      vm.showDeleteModal = visible;
      vm.routeId = route.id;
      vm.routeName = route.campaign.name;
    };

    vm.Modal = function (visible) {
      vm.showModal = visible;
    };

    vm.sendParamsToModal = function (visible, route) {

      vm.showModal = visible;
      vm.routeId = route.id;
      vm.routeName = route.campaign.name;
    };

    vm.cloneCampaign = function (cId, cloneId, campaign) {

      if (cloneId != undefined) {
        $http({
          method: 'POST',
          type: 'json',
          url: AuthService.apiBaseHref() + '/traces/' + cId + '/copy',
          data: {
            'customer_id': cloneId
          }

        }).then(function successCallback(response) {
          growl.success("Audyt: " + campaign + " została sklonowana pomyślnie", {ttl: 5000});

        }, function errorCallback(response) {
          growl.error("Audyt: " + campaign + " nie została sklonowana!", {ttl: 5000});
        });
      } else growl.error("Audyt: " + campaign + " nie została sklonowana!", {ttl: 5000});
    };

    vm.generateReport = function (id, city, date) {
      $http({
        method: 'GET',
        url: AuthService.apiBaseHref() + '/traces/' + id + '/report',

      }).then(function successCallback(response) {
        var blob = new Blob([vm.s2ab(atob(response.data.result))], {
          type: ''
        });

        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        var url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = city + "_" + "raport" + "_" + date + ".xlsx";
        a.click();
        window.URL.revokeObjectURL(url);

        growl.success("Raport dla audytu nr " + id + " został wygenerowany pomyślnie", {ttl: 5000});

      }, function errorCallback(response) {
        growl.error("Raport dla audytu nr " + id + " nie został wygenerowany", {ttl: 5000});
      });
    };

    vm.noteModal = function (visible) {

      vm.showNote = visible;
    };

    vm.showNoteBtn = function (visible, note) {
      vm.note = note;
      vm.showNote = visible;
    };

    vm.s2ab = function (s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }

  });

'use strict';

angular.module('inspinia')
  .controller('RoutesSearchController', function ($scope, $filter, $state, $http, $compile, DTOptionsBuilder, DTColumnBuilder, AuthService, growl, $interval) {
    var vm = this;
    console.log('updated routes search and margins and search!');
    window.abcd = vm;
    vm.dataTablesInitialized = false;
    vm.moment = moment;

    vm.filters = '?limit=40';

    vm.currentFilters = {
        'campaign': [113],
        'city': [],
        'customer': [],
        'distributor': [],
        'advertising_material': [],
        'auditor': [],
        'status': [],
        'start_date': []
    }

    vm.data = {};

    vm.search_campaign = null;
    vm.search_city = null;
    vm.search_customer = null;
    vm.search_distributor = null;
    vm.search_advertising_material = null;
    vm.search_auditor = null;
    vm.search_status = null;
    vm.search_start_date = null;
    vm.search_end_date = null;

    vm.addFilter = function (filter, value, value2) {
        console.log('adding filter for ', filter)
        console.log('adding filter for value', value)
        console.log('adding filter for value2', value2)

        if (filter !== 'start_date') {
            vm.currentFilters[filter].push(value)
        } else {
            vm.currentFilters[filter].push(value.toISOString().split('T')[0])
            vm.currentFilters[filter].push(value2.toISOString().split('T')[0])

        }

        console.log('current filters are ', vm.currentFilters)
    }

    vm.removeFilter = function(filter, value) {
        var indexOfValueToRemove = vm.currentFilters[filter].indexOf(value);
        vm.currentFilters[filter].splice(indexOfValueToRemove, 1)

        console.log('current filters are ', vm.currentFilters)
    }

    vm.search = function() {
        var search_query = '?limit=300&filter=';

        Object.keys(vm.currentFilters).forEach(function(keyName, index) {
            // [customer{in}POST,CTRL]
            var filterValues = vm.currentFilters[keyName];

            if (filterValues.length === 0) {
                return;
            }

            search_query += "["+keyName


            if (keyName === 'start_date') {
                var filterValues = vm.currentFilters[keyName];

                search_query += "{gte}"+filterValues[0]+'][start_date{lte}'+filterValues[1]+']'
            } else {
                search_query += "{in}"
                search_query += filterValues.join(",")
            }



            search_query += ']'
        });

        console.log('search query is ',search_query);
        vm.filters = search_query;
        vm.getTraces();
    }

    console.log('route search with routeEdit transition');
    vm.edit = function (route) {
      var url = $state.href('index.routeEdit', {id: route.campaign.id, r_id: route.id});
      window.open(url,'_blank');
    };

    vm.show = function (route) {
      var url = $state.href('index.route-view', {id: route.id});
      window.open(url,'_blank');
    };

    vm.generateReport = function (id, city, date) {
      $http({
        method: 'GET',
        url: AuthService.apiBaseHref() + '/traces/' + id + '/report',

      }).then(function successCallback(response) {
        var blob = new Blob([vm.s2ab(atob(response.data.result))], {
          type: ''
        });

        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        var url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = city + "_" + "raport" + "_" + date + ".xlsx";
        a.click();
        window.URL.revokeObjectURL(url);

        growl.success("Raport dla audytu nr " + id + " został wygenerowany pomyślnie", {ttl: 5000});

      }, function errorCallback(response) {
        growl.error("Raport dla audytu nr " + id + " nie został wygenerowany", {ttl: 5000});
      });
    };

    vm.showNoteBtn = function (visible, note) {
      vm.note = note;
      vm.showNote = visible;
    };

    vm.showDelModal = function (visible) {
      vm.selectedRouteShowDeleteModal = visible;
    };

    vm.sendParamsToDelModal = function (visible, route) {
      vm.selectedRouteShowDeleteModal = visible;
      vm.selectedRouteRouteId = route.id;
      vm.selectedRouteRouteName = route.campaign.name;
    };

    vm.Modal = function (visible) {
      vm.selectedRouteShowModal = visible;
    };

    vm.sendParamsToModal = function (visible, route) {
      vm.selectedRouteShowModal = visible;
      vm.selectedRouteId = route.id;
      vm.selectedRouteName = route.campaign.name;
    };

    vm.s2ab = function (s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }

    vm.dtOptions = DTOptionsBuilder
      .newOptions()
      .withOption('scrollX', '100%')
      .withOption('stateSave', true)
      .withOption('iDisplayLength', 100)
      .withPaginationType('full_numbers')
      .withBootstrap()
      .withDOM('<"html5buttons"B>lTfgitp')
      .withOption('order', [0, 'desc'])
      .withOption('initComplete', function () {
        var self = this;
        $(self.api().table().container()).find('input').parent().wrap('<form>').parent().attr('autocomplete', 'off');
        $(self.api().table().container()).find('input').attr('autocomplete', 'off');
      })
      .withButtons([
        {extend: 'copy'},
        {extend: 'csv'},
        {
          extend: 'pdfHtml5', //title: },
          orientation: 'landscape',
          customize: function (doc) {
            doc.pageMargins = [5, 5, 5, 5 ];
            doc.content.splice(1, 0, {
              margin: [0, 0, 0, 6],
              alignment: 'center',
              text: 'Średni procent skuteczności zakończonych audytów: ' + vm.data.averageRoutesPercent + '% | Skuteczne audyty: ' + vm.data.routeEffectivePercent + '%'
            });
          },
          exportOptions: {
            columns: [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 11 ]
          }
        },
        {
          extend: 'print',
          customize: function (win) {
            $(win.document.body).addClass('white-bg');
            $(win.document.body).css('font-size', '10px');

            $(win.document.body).find('table')
              .addClass('compact')
              .css('font-size', 'inherit');
          }
        }
      ]);

    vm.statuses = {
      N: 'Nowa',
      A: 'Aktywna',
      F: 'Zakończona'
    };

    vm.getTraces = function () {
      $http({
        method: 'GET',
        type: 'json',
        url: AuthService.apiBaseHref() + '/traces' + vm.filters

      }).then(function successCallback(response) {
        var completeRoutes = 0;
        var effectiveRoutes = 0;
        var averageEffective = 0;
        vm.data.routes = response.data.items;

        $.each(vm.data.routes, function (i, route) {
          if (route.status.id == 'f') {
            completeRoutes++;
            averageEffective += route.percent_effectiveness;
          }
          if (route.is_effective)
            effectiveRoutes++;
        });
        vm.data.completeRoutes = completeRoutes;
        vm.data.effectiveRoutes = effectiveRoutes;
        vm.data.averageRoutesPercent = vm.data.routes.length == 0 ? 0 : (averageEffective / vm.data.completeRoutes).toFixed(0);
        vm.data.routeEffectivePercent = vm.data.routes.length == 0 ? 0 : ((effectiveRoutes * 100) / vm.data.routes.length).toFixed(0);

      }, function errorCallback(response) {
        if (response.statusText === "Forbidden") {
          $state.transitionTo('login');
        }
      });
    };

    vm.getTraces();
  });

'use strict';

angular.module('inspinia')
  .controller('RoutesHistoryController', function ($scope, $filter, $state, $http, $compile, DTOptionsBuilder, DTColumnBuilder, AuthService, growl, $interval) {
    var vm = this;

    window.abcd = vm;
    vm.dataTablesInitialized = false;
    vm.moment = moment;

    vm.filters = '?limit=40';

    vm.currentFilters = {
        'auditor': [],
        'start_date': []
    }

    vm.data = {};

    vm.search_auditor = null;
    vm.search_start_date = null;
    vm.search_end_date = null;
    vm.km_rate = 0.8358;
    vm.route_types = {

    }

    vm.odomoter_edits = {

    }

    vm.odomoter_readings = {

    }

    vm.kmRateChanged = function() {
        vm.distancePointsTotalPay = vm.km_rate * vm.distancePointsTotal;
    }

    vm.changeRouteType = function (routeId) {
        console.log('changing route type '+routeId)
        var routeType = vm.route_types[routeId];
        console.log('route type is '+routeType)

        $("#route_type_"+routeId).text(routeType);
    }

    vm.search = function() {
        var search_query = '';

        if (vm.search_auditor) {
            search_query += '?auditor='+vm.search_auditor
        }

        if (vm.search_start_date) {
            var new_start = new Date(moment(vm.search_start_date).format('YYYY-MM-DD')).toISOString();
            search_query += '&start_date='+new_start
        }

        if (vm.search_end_date) {
            var new_end = new Date(moment(vm.search_end_date).format('YYYY-MM-DD')).toISOString();
            search_query += '&end_date='+new_end
        }

        console.log('created search_query ',search_query);

        if (search_query.substring(0, 1) === '&') {
            search_query = '?'+search_query.substring(1);

        }
        vm.filters = search_query;
        vm.getHistory();
    }

    vm.dtOptions = DTOptionsBuilder
      .newOptions()
      .withOption('scrollX', '100%')
      .withOption('stateSave', true)
      .withOption('iDisplayLength', 100)
      .withPaginationType('full_numbers')
      .withBootstrap()
      .withDOM('<"html5buttons"B>lTfgitp')
      .withOption('order', [0, 'desc'])
      .withOption('initComplete', function () {
        var self = this;
        $(self.api().table().container()).find('input:not(.no-form)').parent().wrap('<form>').parent().attr('autocomplete', 'off');
        $(self.api().table().container()).find('input:not(.no-form)').attr('autocomplete', 'off');
      })
      .withButtons([
        {extend: 'copy'},
        {extend: 'csv'},
        {
          extend: 'pdfHtml5', //title: },
          exportOptions: {
                columns: [ 0, 1, 2, 3, 5, 6, 7, 8, 9 ]
          },
          customize: function (doc) {
              doc.pageMargins = [3, 3, 3,3 ];
              doc.content.splice(0, 1, {
                  text: [{
                      text: '......................................',
                      fontSize: 12,
                      alignment: 'left',
                  }, {
                      text: '                                                               Numer rejestracyjny pojazdu ...............\n',
                      fontSize: 12,
                      alignment: 'right',
                  }, {
                      text: '......................................',
                      fontSize: 12,
                      alignment: 'left',
                  }, {
                      text: '                                                               Pojemność silnika ...............\n',
                      fontSize: 12,
                      alignment: 'right',
                  }, {
                      text: 'Dane podatnika (lub pieczątka)\n',
                      fontSize: 11,
                      alignment: 'left',
                  }, {
                      text: '.....................................\n',
                      fontSize: 12,
                      alignment: 'left',
                  }, {
                      text: '.....................................\n',
                      fontSize: 12,
                      alignment: 'left',
                  }, {
                      text: 'Dane osoby używającej pojazd\n',
                      fontSize: 12,
                      alignment: 'left',
                  }, {
                      text: '(nazwisko, imię, adres zamieszkania)\n\n\n',
                      fontSize: 12,
                      alignment: 'left',
                  }

                  ],
                  margin: [0, 0, 0, 0],
                  alignment: 'center'
              });
          }
        },
        {
          extend: 'print',
          customize: function (win) {
            $(win.document.body).addClass('white-bg');
            $(win.document.body).css('font-size', '10px');

            $(win.document.body).find('table')
              .addClass('compact')
              .css('font-size', 'inherit');
          }
        }
      ]);

    vm.statuses = {
      N: 'Nowa',
      A: 'Aktywna',
      F: 'Zakończona'
    };

    vm.distancePoints = {};
    vm.distancePointsTotal = 0;
    vm.distancePointsTotalPay = 0;

    vm.changeOdometerData = function (id) {
        var odometer = $("#new_odometer_value_"+id).val();
        console.log('track id is', odometer)
        $http({
          method: 'POST',
          data: {
            'history_id': id,
            'odometer_value': odometer
          },
          type: 'json',
          url: AuthService.apiBaseHref() + '/traces-history-update'

        }).then(function successCallback(response) {
          console.log('response', response.data)
          vm.odomoter_edits[response.data.id] = false;
          vm.search();
        });
    }

    vm.getHistory = function () {
      $http({
        method: 'GET',
        type: 'json',
        url: AuthService.apiBaseHref() + '/traces-history' + vm.filters

      }).then(function successCallback(response) {
        //
        var pointsToCount = {};

        vm.odomoter_edits = {}

        for (var i=0; i < response.data.length; i++) {
            var current = response.data[i];
            var currentState = current.state;
            var traceId = current['trace_id'];
            if (!pointsToCount.hasOwnProperty(traceId)) {
                pointsToCount[traceId] = {};
            }
          vm.odomoter_edits[current.id] = false;
          pointsToCount[traceId][currentState] = parseInt(current.odometer);
        }
        //
        var distanceDone = 0;
        var distancePay = 0;

        console.log('points to count are ',pointsToCount);


        Object.keys(pointsToCount).forEach(function (item) {
            var routePoint = pointsToCount[item];
            if (routePoint.hasOwnProperty('started') === true && routePoint.hasOwnProperty('finished') === true) {
                var pointDistance = routePoint['finished'] - routePoint['started'];
                distanceDone += pointDistance;
                console.log('adding distance of '+pointDistance+' from point', routePoint);

                vm.distancePoints[item] = pointDistance;
                vm.distancePointsTotal += pointDistance;
                vm.distancePointsTotalPay += vm.km_rate * pointDistance;

            }
        })

        console.log('distance done is ', distanceDone);
        vm.distancePointsTotal = distanceDone;
        vm.distancePointsTotalPay = distanceDone * vm.km_rate;
        vm.data.routes_history = response.data;


      }, function errorCallback(response) {
        if (response.statusText === "Forbidden") {
          $state.transitionTo('login');
        }
      });
    };

    vm.getHistory();
  });

'use strict';


angular.module('inspinia')
  .config(function ($compileProvider) {
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|data|ftp|mailto|file|javascript):/);
  });

angular.module('inspinia')
  .controller('RouteViewController', function ($scope, $state, $stateParams, $filter, $interval, $http, NgMap, AuthService, DTOptionsBuilder, DTColumnDefBuilder, $document) {
    var vm = this;
    $scope.centered = false;
    $scope.showEffectiveness = true;
    $scope.dataLoaded = false;
    $scope.showPdfLoader = false;
    $scope.stopReload = false;
    $scope.mapBase64 = '';
    $scope.moment = moment;
    $scope.centerMap = [0, 0];
    $scope.imageNumber = 0;
    $scope.zipModel = {
      downloadedCounter: 0,
      auditToDownload: [],
      downloadedPhotos: [],
      error: false,
      inProgress: false,
      downloadText: 'Rozpoczynam pobieranie...'
    };
    $scope.playbackSpeed = 1;

    NgMap.getMap().then(function (map) {
      new google.maps.KmlLayer({
        preserveViewport: true
      });

      vm.map = map;
    });

    $scope.goToPhoto = function (number, maxLength) {
      if (number > -1 && number < maxLength) $scope.imageNumber = number;
    };

    $scope.changeShowEffectiveness = function () {
      $scope.showEffectiveness = !$scope.showEffectiveness;
    };


    // $scope.stressTest = function () {
    //   console.log("WCHODZE");
    //   for(let i = 0; i < 100000; i++) {
    //     console.log("WYSYLAM: " + i);;
    //     $http({
    //       method: 'GET',
    //       type: 'json',
    //       url: AuthService.apiBaseHref() + '/traces/' + $stateParams.id
    //
    //     }).then(function successCallback(response) {
    //       console.log(response);
    //     });
    //   }
    // };
    //
    // $scope.stressTest();
    $scope.downloadAllPhotos = function (route, downloadPoints) {
      if (downloadPoints) {
        $scope.disableScrolling();
        window.scrollTo(0, 0);
        $scope.showPdfLoader = true;
        $scope.zipModel.downloadedPhotos = [];
        $scope.zipModel.downloadedCounter = 0;
        $scope.zipModel.error = false;
        $scope.zipModel.inProgress = true;
        $scope.zipModel.downloadText = 'Rozpoczynam pobieranie...';

        angular.forEach($scope.zipModel.auditToDownload, function (point, key) {
          $scope.getTracePhotosById(point);
        });
      } else {
        var zip = new JSZip();

        angular.forEach($scope.zipModel.downloadedPhotos, function (photo, key) {
          zip.folder(route.campaign.name.replace(/\//g, "_") + "_zdjecia").file(route.city + "_" + photo.street + "_" + photo.building_number + "_KL" + key + "_m_" + photo.flat_number + ".jpg", photo.data, {base64: true});
        });

        zip.generateAsync({type: "blob"})
          .then(function (content) {
            saveAs(content, route.campaign.name + "_zdjecia.zip");
          });
      }
    };

    $scope.dtColumnDefs = [
      DTColumnDefBuilder.newColumnDef(0),
      DTColumnDefBuilder.newColumnDef(1),
      DTColumnDefBuilder.newColumnDef(2),
      DTColumnDefBuilder.newColumnDef(3),
      DTColumnDefBuilder.newColumnDef(4),
      DTColumnDefBuilder.newColumnDef(5)
    ];

    $scope.dtInstance = {};

    $scope.modal = function (visible) {

      $scope.showPhotos = visible;
    };

    $scope.noteModal = function (visible) {
      $scope.showNote = visible;
    };

    $scope.showNoteBtn = function (visible, note) {
      $scope.note = note;
      $scope.showNote = visible;
    };

    $scope.setPlaybackSpeed = function ($event) {
      if ($event.target.value) {
        $scope.playbackSpeed = Number($event.target.value);

        var existingAudios = $('source');

        if (existingAudios.length && ($scope.playbackSpeed >= 0 && $scope.playbackSpeed <= 16)) {
          for (var i = 0; i < existingAudios.length; i++) {
            existingAudios[i].closest('audio').playbackRate = $scope.playbackSpeed;
          }
        }
      }
    };

    $scope.generateMap = function () {
      $scope.showPdfLoader = true;
      $scope.disableScrolling();
      window.scrollTo(0, 0);
      // TODO Odkomentować aby dodać możliwość ustawiania mapy przy kliknięciu Wygeneruj pdf
      var bounds = new google.maps.LatLngBounds();
    console.log('doing map');
      angular.forEach($scope.activeRoute.points, function (point, key) {
        console.log('adding point?');
        if (point.location.longitude) {
          console.log('point added!')
          bounds.extend(new google.maps.LatLng(point.location.latitude, point.location.longitude));
        }
      });

      console.log('getting map...');
      NgMap.getMap().then(function (map) {
        console.log('got map xdd!', map);
        $('#map-container').css("width", 1000);
        map.fitBounds(bounds);

        google.maps.event.addListenerOnce(map, 'idle', function () {
          setTimeout(function () {
            html2canvas($('.gm-style>div:eq(1)')[0], {
              useCORS: true,
              async: false,
              height: 750,
              width: 1000
            }).then(function (canvas) {
              $scope.mapBase64 = $scope.imageToDataUri(canvas, 850, 560);
              $scope.enableScrolling();

              $scope.$apply(function () {
                $scope.showPdfLoader = false;
              });
              $('.buttons-pdf')[0].click();
              setTimeout(function () {
                $('#map-container').css("width", "100%");
              }, 1000);
            });
          }, 2000);
        });
      });
    };

    $scope.disableScrolling = function () {
      $(document.body).css('overflow', 'hidden');
    };

    $scope.enableScrolling = function () {
      $(document.body).css('overflow', 'auto');
    };

    $scope.noWrapSlides = false;
    $scope.active = 0;

    $scope.showPhotosBtn = function (visible) {
      $scope.imageNumber = 0;
      $scope.showPhotos = visible;
    };

    $scope.photos = [];

    $scope.centerOnMap = function (point) {

      if (typeof point.location.latitude != 'undefined') {
        $scope.centered = true;
        $scope.routeView.routeStats.firstPoint = [parseFloat(point.location.latitude), parseFloat(point.location.longitude)];
      }
    };

    $scope.createAudio = function (id, fileId) {
      $http({
        method: 'GET',
        type: 'json',
        url: AuthService.apiBaseHref() + '/audio/' + fileId
      }).then(function successCallback(response) {
        $scope.stopReload = true;
        if (response.data.result.data.includes('data:audio/amr;base64,')) {
          var amr = new BenzAMRRecorder();

          var blob = $scope.b64toBlob(response.data.result.data.split('audio/amr;base64,')[1], 'audio/amr', 512);

          amr.initWithBlob(blob).then(function (test) {
            amr.play()
          });
          return;
        }

        var audio = document.getElementById(id + '_audio');
        var htmlSourceElement = document.createElement('source');

        htmlSourceElement.src = response.data.result.data.replace('amr', 'x-wav');
        audio.playbackRate = $scope.playbackSpeed;
        audio.hidden = false;
        audio.append(htmlSourceElement);
        audio.play();
      }, function errorCallback(response) {
        if (response.statusText === "Forbidden") {
          $state.transitionTo('login');
        }
      });
    };

    $scope.base64ToArrayBuffer = function (base64) {
      var binary_string = window.atob(base64);
      var len = binary_string.length;
      var bytes = new Uint8Array(len);
      for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
      }
      return bytes.buffer;
    };

    $scope.b64toBlob = function (b64Data, contentType, sliceSize) {
      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    };

    $scope.checkSurveyNote = function (surveys) {
      if (surveys.length) {
        for (var i = 0; i < surveys.length; i++) {
          if (surveys[i].description) {
            return true;
          }
        }
      }

      return false;
    };

    $scope.setSurveyDescription = function (note, surveys) {
      var description = '';

      if (note) {
        description += '<h3> Globalna notatka </h3>' + note
      }

      if (surveys.length) {
        for (var i = 0; i < surveys.length; i++) {
          if (surveys[i].description) {
            description += '<br><h3> Notatka dla numeru mieszkania: ' + surveys[i].flat_number + '</h3>'
              + surveys[i].description
          }
        }
      }

      return description;
    };

    $scope.getTracePhotos = function (point) {
      var photosInPoints = [];
      $scope.photos = [];
      $http({
        method: 'GET',
        type: 'json',
        url: AuthService.apiBaseHref() + '/points/' + point.id + '/surveys'
      }).then(function successCallback(response) {
        angular.forEach(response.data.items, function (item, key) {
          if (typeof item.photo != 'undefined') {
            photosInPoints.push({
              flat_number: item.flat_number,
              data: item.photo.data,
              street: point.address.street,
              building_number: point.address.building_number
            });
          }
        });
        $scope.photos = photosInPoints;
        $scope.showPhotosBtn(true);
      }, function errorCallback(response) {
        if (response.statusText === "Forbidden") {
          $state.transitionTo('login');
        }
        $scope.showPhotosBtn(true);
      });
    };

    $scope.getTracePhotosById = function (point) {
      $http({
        method: 'GET',
        type: 'json',
        url: AuthService.apiBaseHref() + '/points/' + point.id + '/surveys'
      }).then(function successCallback(response) {
        angular.forEach(response.data.items, function (item, key) {
          if (typeof item.photo != 'undefined') {
            $scope.zipModel.downloadedPhotos.push({
              flat_number: item.flat_number,
              data: item.photo.data,
              street: point.address.street,
              building_number: point.address.building_number
            });
          }
        });

        $scope.zipModel.downloadedCounter++;
        $scope.zipModel.downloadText = "Pobrano:" + $scope.zipModel.downloadedCounter + ', z: ' + $scope.zipModel.auditToDownload.length;

        if ($scope.zipModel.downloadedCounter === $scope.zipModel.auditToDownload.length) {
          $scope.downloadAllPhotos($scope.activeRoute, false);
          $scope.zipModel.inProgress = false;
          $scope.showPdfLoader = false;
          $scope.enableScrolling();
        } else if ($scope.zipModel.error) {
          $scope.zipModel.downloadText = "Wystąpił błąd podczas pobierania paczki zdjęć. Proszę skontaktować się z administratorem.";
          $scope.zipModel.inProgress = false;
          setTimeout(function () {
            $scope.showPdfLoader = false;
            $scope.enableScrolling();
          }, 4000);
        }
      }, function errorCallback(response) {
        $scope.zipModel.error = true;
        if (response.statusText === "Forbidden") {
          $state.transitionTo('login');
        }
        $scope.showPhotosBtn(true);
      });
    };

    $scope.getRouteStatistics = function () {
      $http({
        method: 'GET',
        type: 'json',
        url: AuthService.apiBaseHref() + '/traces/' + $stateParams.id + '/statistics'

      }).then(function successCallback(response) {
        vm.statisticsRoute = response.data.result;
      });
    };

    $scope.getRouteStatistics();

    $scope.updateMap = function () {
      if ($scope.stopReload || $scope.zipModel.inProgress) {
        return;
      }
      $scope.countIter = 0;
      $scope.zipModel.auditToDownload = [];

      $http({
        method: 'GET',
        type: 'json',
        url: AuthService.apiBaseHref() + '/traces/' + $stateParams.id

      }).then(function successCallback(response) {
        $scope.activeRoute = response.data;
        if ($scope.activeRoute.points && $scope.activeRoute.points.length) {
          for (var i = 0; i < $scope.activeRoute.points.length; i++) {
            if ($scope.activeRoute.points[i].photos_count) {
              $scope.zipModel.auditToDownload.push($scope.activeRoute.points[i]);
            }

            $scope.activeRoute.points[i].description =
              $scope.setSurveyDescription($scope.activeRoute.points[i].note, $scope.activeRoute.points[i].surveys);
          }
        }

        $scope.dtOptions = DTOptionsBuilder
          .newOptions()
          .withOption('scrollX', '100%')
          .withOption('iDisplayLength', 100)
          .withOption('stateSave', true)
          .withOption('initComplete', function () {
            var self = this;
            $(self.api().table().container()).find('input').parent().wrap('<form>').parent().attr('autocomplete', 'off');
            $(self.api().table().container()).find('input').attr('autocomplete', 'off');
          })
          .withPaginationType('full_numbers')
          .withBootstrap()
          .withDOM('<"html5buttons"B>lTfgitp')
          .withButtons([
            {
              extend: 'copy',
              exportOptions: {
                columns: 'thead th:not(.noExport)'
              }
            },
            {
              extend: 'csv',
              exportOptions: {
                columns: 'thead th:not(.noExport)'
              }
            },
            {
              extend: 'pdfHtml5',
              title: $scope.activeRoute.city + '_raport_' + $filter('date')($scope.activeRoute.start_date, "yyyy_MM_dd"),
              orientation: 'landscape',
              pageSize: 'LEGAL',
              exportOptions: {
                columns: 'thead th:not(.noExport)'
              },
              customize: function (doc) {
                removeSpecificText(doc.content[1].table.body, '| Nag.');
                removeTextAfter(doc.content[1].table.body, 3, ' (');
                removeTextAfter(doc.content[1].table.body, 5, ' |     ');
                removeTextAfter(doc.content[1].table.body, 6, ' |     ');
                removeTextAfter(doc.content[1].table.body, 7, ' |     ');
                removeTextAfter(doc.content[1].table.body, 5, ' | Down');
                removeTextAfter(doc.content[1].table.body, 6, ' | Down');
                removeTextAfter(doc.content[1].table.body, 7, ' | Down');
               console.log('adding $scope.activeRoute.advertising_material',$scope.activeRoute.advertising_material);

                doc.content.splice(1, 0, {
                  margin: [0, 0, 0, 12],
                  alignment: 'center',
                  text: $scope.activeRoute.campaign.name + '/' + $scope.activeRoute.city + '/' + $filter('date')($scope.activeRoute.start_date, "dd-MM-yyyy") + '  ' + $scope.activeRoute.advertising_material
                }, {
                  margin: [0, 0, 0, 12],
                  alignment: 'center',
                  text: 'Odwiedzonych punktów: ' + vm.routeStats.visitedPointPercent + '% | Skuteczność: ' + vm.routeStats.effectivePointPercent + '%'
                });
                doc.content.splice(4, 0, {
                  alignment: 'center',
                  image: $scope.mapBase64
                });
              }
            },
            {
              extend: 'print',
              exportOptions: {
                columns: 'thead th:not(.noExport)'
              }, customize: function (win) {
                $(win.document.body).addClass('white-bg');
                $(win.document.body).css('font-size', '10px');

                $(win.document.body).find('table')
                  .addClass('compact')
                  .css('font-size', 'inherit');
              }
            }
          ]);

        var x = ($scope.activeRoute.points.length > 0 && $scope.activeRoute.points[0].location.latitude) ? $scope.activeRoute.points[0].location.latitude : 52.199523;
        var y = ($scope.activeRoute.points.length > 0 && $scope.activeRoute.points[0].location.longitude) ? $scope.activeRoute.points[0].location.longitude : 21.031655;
        var firstPoint = [x, y];

        if ($scope.activeRoute.trace_gsm.length > 0 && $scope.activeRoute.trace_gsm[0].list_points.length > 0) {
          firstPoint = $scope.centered ? $scope.routeView.routeStats.firstPoint : [$scope.activeRoute.trace_gsm[0].list_points[0].lat, $scope.activeRoute.trace_gsm[0].list_points[0].lng];
        }

        vm.routeStats = {
          pointCount: $scope.activeRoute.points.length > 0 ? $scope.activeRoute.points.length : 0,
          requiredEffectiveness: $scope.activeRoute.required_effectiveness ? $scope.activeRoute.required_effectiveness : 0,
          visitedPointCount: $scope.activeRoute.points.length > 0 ? $filter('filter')($scope.activeRoute.points, {status: {id: 'v'}}).length : 0,
          effectivePointCount: $scope.activeRoute.points.length > 0 ? $filter('filter')($scope.activeRoute.points, {
            status: {id: 'v'},
            efficiency: true
          }).length : 0,
          firstPoint: firstPoint
        };

        vm.regionStats = {};
        vm.regionSummary = {
          yes: 0,
          no: 0,
          efficiencyPercent: 0
        };

        angular.forEach($scope.activeRoute.points, function (point, key) {
          var regionName = point.region + '-' + point.subregion;

          // Mock dla pominiecia punktu
          if (point.status.id === 'v' && !point.efficiency && !point.surveys.length) {
            point.surveys.push({flat_number: '0', status: {id: 'o', name: 'Niewidoczna'}});
            point.surveys.push({flat_number: '0', status: {id: 'o', name: 'Niewidoczna'}});
          }

          if (vm.regionStats[regionName] == undefined) {
            vm.regionStats[regionName] = {
              name: regionName,
              yes: 0,
              no: 0,
              efficiencyPercent: 0,
            }
          }

          var isBlock = false;
          var blockReportable = false;
          angular.forEach(point.surveys, function (survey, sKey) {
            if (isBlock && blockReportable) {
              return;
            }

            //breaks after first occurence if there is block
            isBlock = (point.address.type == 'Blok' || point.address.type == 'Budynek wielorodzinny');

            if (isBlock) {
              if (survey.status.id === 'y'
                || survey.status.id === 'v'
                || survey.status.id === 'n'
                || survey.status.id === 'e'
                || survey.status.id === 'kz'
                || survey.status.id === 'kw'
                || survey.status.id === 'ns') {
                blockReportable = true;

                if (point.efficiency === true) {
                  vm.regionStats[regionName].yes++;
                  vm.regionSummary.yes++;
                } else {
                  vm.regionStats[regionName].no++;
                  vm.regionSummary.no++;
                }
              }

            } else {
              if (survey.status.id === 'y' || survey.status.id === 'v' || survey.status.id === 'e' || survey.status.id === 'kz') {
                vm.regionStats[regionName].yes++;
                vm.regionSummary.yes++;

              } else if (survey.status.id === 'n' || survey.status.id === 'kw' || survey.status.id === 'ns') {
                vm.regionStats[regionName].no++;
                vm.regionSummary.no++;
              }
            }


          });

          if (vm.regionStats[regionName].yes + vm.regionStats[regionName].no == 0)
            vm.regionStats[regionName].efficiencyPercent == 0;
          else
            vm.regionStats[regionName].efficiencyPercent = ((vm.regionStats[regionName].yes / (vm.regionStats[regionName].yes + vm.regionStats[regionName].no)) * 100).toFixed(0)


        });


        if (vm.regionSummary.yes + vm.regionSummary.no == 0)
          vm.regionSummary.efficiencyPercent == 0;
        else
          vm.regionSummary.efficiencyPercent = ((vm.regionSummary.yes / (vm.regionSummary.yes + vm.regionSummary.no)) * 100).toFixed(0)

        vm.routeStats.visitedPointPercent = vm.routeStats.pointCount == 0 ? 0 : ((vm.routeStats.visitedPointCount / vm.routeStats.pointCount) * 100).toFixed(0);
        vm.routeStats.effectivePointPercent = vm.routeStats.visitedPointCount == 0 ? 0 : ((vm.routeStats.effectivePointCount / vm.routeStats.visitedPointCount) * 100).toFixed(0);
        updatePoints();
        $scope.filterPoints = [];
        if (!AuthService.isAdmin()) {
          angular.forEach($scope.activeRoute.trace_gsm, function (value, key) {
            var prev_lat = value.list_points[0].lat;
            var prev_lng = value.list_points[0].lng;
            var i = 0;
            angular.forEach(value.list_points, function (value2, key2) {

              if (value2.datetime >= $scope.activeRoute.work_start && (value2.datetime <= $scope.activeRoute.work_end || $scope.activeRoute.work_end == "")) {
                if ((i != 0) && (prev_lat != value2.lat) && (prev_lng.lng != value2.lng)) {
                  $scope.filterPoints.push([value2.lat, value2.lng]);
                } else if (i == 0) {
                  $scope.filterPoints.push([value2.lat, value2.lng]);

                }
                prev_lat = value2.lat;
                prev_lng = value2.lng;
                i++;
              }
            });
          });
        }
        $scope.dataLoaded = true;
      }, function errorCallback(response) {
        if (response.statusText === "Forbidden") {
          $state.transitionTo('login');
        }
      });
    };

    $scope.updateMap();

    var calculateWorkRoute = function (workRoute) {
      var meters = 0;
      $.each(workRoute, function (i, v) {
        var polyline = new google.maps.Polyline({
          path: v,
          strokeColor: "#ff0000",
          strokeOpacity: 0.6,
          strokeWeight: 5
        });

        meters += google.maps.geometry.spherical.computeLength(polyline.getPath());
        // console.log(meters/1000);

      });
      return meters / 1000;
    };


    var removeSpecificText = function (array, textToRemove) {
      array.forEach(function (item) {
        item[5].text = item[5].text.replace(textToRemove, '');
        item[6].text = item[6].text.replace(textToRemove, '');
        item[7].text = item[7].text.replace(textToRemove, '');
      });
    };

    var removeTextAfter = function (array, number, textToRemoveAfter) {
      array.forEach(function (item) {
        item[number].text = item[number].text.split(textToRemoveAfter)[0];
      });
    };


    var calculateWorkPoly = function (trace_date, t_lat, t_lng, index) {
      if (trace_date <= $scope.activeRoute.work_start) {
        $scope.executorPathPolyStart[index].push({lat: t_lat, lng: t_lng});
      } else if (trace_date > $scope.activeRoute.work_start && trace_date < $scope.activeRoute.work_end) {
        $scope.executorPathPolyBeetwen[index].push({lat: t_lat, lng: t_lng});
      } else if (trace_date >= $scope.activeRoute.work_end) {
        $scope.executorPathPolyEnd[index].push({lat: t_lat, lng: t_lng});
      }
    };

    $scope.startDistance = 0;
    $scope.beetweenDistance = 0;
    $scope.endDistance = 0;
    var updatePoints = function () {

      var executorPaths = [];
      var tmpChecker = [];
      $scope.executorPathPolyStart = [];
      $scope.executorPathPolyBeetwen = [];
      $scope.executorPathPolyEnd = [];
      if (AuthService.isAdmin()) {
        $.each($scope.activeRoute.trace_gsm, function (index, trace) {
          if (trace.list_points.length > 0) {
            executorPaths[index] = [];
            $scope.executorPathPolyStart[index] = [];
            $scope.executorPathPolyBeetwen[index] = [];
            $scope.executorPathPolyEnd[index] = [];
            var prev_lat = Number(trace.list_points[0].lat.toFixed(4));
            var prev_lng = Number(trace.list_points[0].lng.toFixed(4));
            var k = 0;
            for (var i in trace.list_points) {
              trace.list_points[i].lat = Number(trace.list_points[i].lat.toFixed(4));
              trace.list_points[i].lng = Number(trace.list_points[i].lng.toFixed(4));

              if ((k != 0) && (prev_lat != trace.list_points[i].lat) && (prev_lng != trace.list_points[i].lng) && !tmpChecker.includes(trace.list_points[i].lat + '' + trace.list_points[i].lng)) {
                tmpChecker.push(trace.list_points[i].lat + '' + trace.list_points[i].lng);
                executorPaths[index].push([trace.list_points[i].lat, trace.list_points[i].lng]);
                calculateWorkPoly(trace.list_points[i].datetime, trace.list_points[i].lat, trace.list_points[i].lng, index);
              } else if (k == 0) {
                tmpChecker.push(trace.list_points[i].lat + '' + trace.list_points[i].lng);
                executorPaths[index].push([trace.list_points[i].lat, trace.list_points[i].lng]);
                calculateWorkPoly(trace.list_points[i].datetime, trace.list_points[i].lat, trace.list_points[i].lng, index);

              }
              prev_lat = trace.list_points[i].lat;
              prev_lng = trace.list_points[i].lng;
              k++;
            }
          }

          if ((index + 1) == $scope.activeRoute.trace_gsm.length) {
            $scope.activeRoute.executorPaths = executorPaths;
            $scope.lastPointOnRoute = $scope.activeRoute.executorPaths[$scope.activeRoute.executorPaths.length - 1][$scope.activeRoute.executorPaths[$scope.activeRoute.executorPaths.length - 1].length - 1];
            $scope.firstPointOnRoute = $scope.activeRoute.executorPaths[0][0];
          }
        });
        $scope.startDistance = calculateWorkRoute($scope.executorPathPolyStart);
        $scope.beetweenDistance = calculateWorkRoute($scope.executorPathPolyBeetwen);
        $scope.endDistance = calculateWorkRoute($scope.executorPathPolyEnd);
      }

      if ($scope.activeRoute.executorPaths === undefined && $scope.activeRoute.points.length === 0) {
        $scope.centerMap = [52.199523, 21.031655];
      } else if ($scope.activeRoute.points.length > 0 && $scope.activeRoute.executorPaths === undefined) {
        $scope.centerMap = [$scope.activeRoute.points[0].location.latitude, $scope.activeRoute.points[0].location.longitude];
      } else {
        $scope.centerMap = AuthService.isAdmin() ?
          $scope.activeRoute.executorPaths[$scope.activeRoute.executorPaths.length - 1][$scope.activeRoute.executorPaths[$scope.activeRoute.executorPaths.length - 1].length - 1] :
          $scope.activeRoute.executorPaths[0][0];
      }
    };


    $scope.range = function (count) {

      var ratings = [];
      for (var i = 0; i < count; i++) {
        ratings.push(i)
      }

      return ratings;
    };

    $scope.filterFunction = function (element) {

      return !(element.status.id.match(/u/) || element.status.id.match(/r/));
    };

    $scope.imageToDataUri = function (datas, wantedWidth, wantedHeight) {
      // We create a canvas and get its context.
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');

      // We set the dimensions at the wanted size.
      canvas.width = wantedWidth;
      canvas.height = wantedHeight;

      // We resize the image with the canvas method drawImage();
      ctx.drawImage(datas, 0, 0, wantedWidth, wantedHeight);

      return canvas.toDataURL();
    };

    var promise = $interval($scope.updateMap, 90000);

    $scope.filterAnswers = function (element, answer) {
      if (answer == 'yes') {
        return element.filter(function (el) {
          return el.status.id == 'y' ||
            el.status.id == 'v' ||
            el.status.id == 'e' ||
            el.status.id == 'kz';
        }).length;
      } else if (answer == 'no') {
        return element.filter(function (el) {
          return el.status.id == 'n' ||
            el.status.id == 'o' ||
            el.status.id == 'kw' ||
            el.status.id == 'ns';
        }).length;
      } else if (answer == 'undefined') {
        return element.filter(function (el) {
          return el.status.id == 'u';
        }).length;
      } else if (answer == 'recipent_missing') {
        return element.filter(function (el) {
          return el.status.id == 'r';
        }).length;
      } else return 0;
    };

    $scope.downloadFile = function (fileId, name) {
      $http({
        method: 'GET',
        type: 'json',
        url: AuthService.apiBaseHref() + '/audio/' + fileId
      }).then(function successCallback(response) {
        var fileData = response.data.result.data.split(';base64,');
        var link = document.createElement('a');
        document.body.appendChild(link);

        link.href = URL.createObjectURL($scope.b64toBlob(fileData[1], fileData[0], 512));
        link.download = name;
        link.target = "_self";

        link.click();
      }, function errorCallback(response) {
        if (response.statusText === "Forbidden") {
          $state.transitionTo('login');
        }
      });
    };

    $scope.stop = function () {

      $interval.cancel(promise);
    };

    $scope.$on('$destroy', function () {

      $scope.stop();
    });

    $scope.showTrace = function (campaignId) {

      $state.transitionTo('index.routesCustomer', {id: campaignId});
    };

  });

angular.module('inspinia')
  .directive('fullScreenToggle', function ($timeout) {
    return {
      link: function (scope, e) {
        var fullScreenClick = function () {
          e.parent().toggleClass('full-screen');
          e.text(e.parent().hasClass('full-screen') ? 'Exit Full Screen' : 'Full Screen');
          google.maps.event.trigger(scope.map, 'resize');
        };
        e.on('click', fullScreenClick);
      }
    }
  });

'use strict';

angular.module('inspinia')
  .controller('RouteEditController', function ($scope, $state, $filter, $http, DTOptionsBuilder, DTColumnDefBuilder, AuthService, growl, NgMap) {
    var vm = this;
    $scope.id = $state.params.r_id;
    $scope.campaign_id = $state.params.id;
    $scope.form = [];
    $scope.campaigns = [];
    $scope.auditors = [];
    $scope.points = [];
    $scope.selectedPoints = [];
    $scope.status = '';
    $scope.mapParser = '';
    $scope.centerMap = [52.199523, 21.031655];
    $scope.geoXmlDoc = '';
    $scope.generatedAddresses = [];
    $scope.kmlVariables = {
      addressCount: 0,
      regionName: '',
      kmlRegion: '',
      kmlSubregion: '',
      kmlMapFile: '',
      minX: 0,
      minY: 0,
      maxX: 0,
      maxY: 0
    };
    $scope.sendingKml = false;
    $scope.dataLoaded = false;
    $scope.edited_point = 0;
    $scope.format = 'yyyy/MM/dd';
    $scope.dp = {
      opened: false
    };

    $scope.dateOptions = {
      dateDisabled: false,
      formatYear: 'yy',
      maxDate: moment(new Date()).add(1, 'year'),
      minDate: new Date(),
      startingDay: 1
    };

    NgMap.getMap().then(function (map) {
      new google.maps.KmlLayer({
        preserveViewport: true
      });
      vm.map = map;
    });

    $scope.openDp = function () {

      $scope.dp.opened = true;
    };

    function useTheData(doc) {
      if (doc.length) {
        $scope.geoXmlDoc = doc[0];
        for (var i = 0; i < $scope.geoXmlDoc.gpolygons.length; i++) {
          highlightPoly($scope.geoXmlDoc.gpolygons[i]);
        }
      }
    }

    function highlightPoly(poly) {
      google.maps.event.addListener(poly, "click", function (evt) {
        var $this = this;
        $scope.kmlVariables.minY = poly.bounds.b.b;
        $scope.kmlVariables.maxY = poly.bounds.b.f;
        $scope.kmlVariables.minX = poly.bounds.f.b;
        $scope.kmlVariables.maxX = poly.bounds.f.f;
        $scope.$apply(function () {
          $scope.kmlVariables.regionName = $this.title;
        });
      });
    }

    $scope.getRoute = function () {

      $http({
        method: 'GET',
        type: 'json',
        url: AuthService.apiBaseHref() + '/traces/' + $scope.id

      }).then(function successCallback(response) {
        $scope.status = response.data.status.id;
        $scope.editRoute.city = response.data.city;
        $scope.editRoute.distributor = response.data.distributor;
        $scope.editRoute.customer = response.data.customer;
        $scope.editRoute.advertising_material = response.data.advertising_material;
        $scope.editRoute.date = new Date(response.data.start_date);
        $scope.getCampaigns();
        $scope.editRoute.auditor = response.data.auditor.id;
        $scope.editRoute.recording_enabled = '' + (response.data.recording_enabled ? 1 : 0);
        $scope.editRoute.show_record_to_customer = '' + (response.data.show_record_to_customer ? 1 : 0);
        $scope.editRoute.show_kml_to_customer = '' + (response.data.show_kml_to_customer ? 1 : 0);
        $scope.editRoute.required_effectiveness = response.data.required_effectiveness;
        $scope.points = response.data.points;
        $scope.dataLoaded = true;
        if ($scope.status == 'a') {
          $scope.style = {'display': 'none'};
        }

      }, function errorCallback(response) {
        $scope.dataLoaded = true;
        // called asynchronously if an error occurs
        // or server returns response with an error status.
      });
    };

    $scope.getRoute();

    $scope.getCampaigns = function () {

      $http({
        method: 'GET',
        type: 'json',
        url: AuthService.apiBaseHref() + '/campaigns?filter=[id{eq}' + $scope.campaign_id + ']'

      }).then(function successCallback(response) {
        $scope.campaigns = response.data.items;
        $scope.editRoute.campaign = parseInt($scope.campaign_id);

      }, function errorCallback(response) {
        if (response.statusText === "Forbidden") {
          $state.transitionTo('login');
        }
      });
    };

    $scope.getAuditors = function () {

      $http({
        method: 'GET',
        type: 'json',
        url: AuthService.apiBaseHref() + '/auditors?limit=-1'

      }).then(function successCallback(response) {
        $scope.auditors = response.data.items;

      }, function errorCallback(response) {
      });
    };

    $scope.getAuditors();

    $scope.removePoint = removePoint;
    $scope.removePoints = removePoints;
    $scope.pointUp = pointUp;
    $scope.pointDown = pointDown;
    $scope.editPoint = editPoint;
    $scope.savePoint = savePoint;
    $scope.cancelEditPoint = cancelEditPoint;
    $scope.drag = drag;
    $scope.allowDrop = allowDrop;
    $scope.drop = drop;
    $scope.dragEnter = dragEnter;
    $scope.dragLeave = dragLeave;
    $scope.pointClicked = pointClicked;

    $scope.addTestPoints = function () {
      for (var i = 0; i < 25; i++) {
        var options = {
          method: 'POST',
          type: 'json',
          url: AuthService.apiBaseHref() + '/points',
          data: {
            region: 'Region ' + i,
            subregion: 'Subregion ' + i,
            note: 'Notka ' + i,
            address: {
              building_number: 'Bn ' + i,
              city: 'Miasto ' + i,
              country_code: 'PL',
              post_code: i,
              street: 'ulicaa' + i
            },
            location: {
              latitude: i,
              longitude: i
            },
            trace_id: $scope.id
          }
        };
        $http(options).then(function successCallback() {
            growl.success("Punkt " + i + " został dodany pomyślnie", {ttl: 5000});
          },
          function errorCallback(response) {
          });
      }
    };

    vm.addPoint = function (form, isAuto) {
      if (isAuto) {
        $http({
          method: 'POST',
          type: 'json',
          url: AuthService.apiBaseHref() + '/points',
          data: {
            region: $scope.kmlVariables.kmlRegion,
            subregion: $scope.kmlVariables.kmlSubregion,
            note: '',
            address: {
              building_number: form.nr_domu,
              city: form.nazwa_miej,
              country_code: 'PL',
              post_code: '',
              street: form.nazwa_ul
            },
            location: {
              latitude: form.y,
              longitude: form.x
            },
            trace_id: $scope.id
          }

        }).then(function successCallback(response) {
            growl.success("Punkty zostały dodane pomyślnie", {ttl: 5000});
          },
          function errorCallback(response) {
          });
      } else if (vm.form_point.$valid) {
        $http({
          method: 'POST',
          type: 'json',
          url: AuthService.apiBaseHref() + '/points',
          data: {
            region: form.region,
            subregion: form.subregion,
            note: form.note,
            address: {
              building_number: form.building_number,
              city: form.city,
              country_code: 'PL',
              post_code: form.post_code,
              street: form.street
            },
            location: {
              latitude: form.x,
              longitude: form.y
            },
            trace_id: $scope.id
          }

        }).then(function successCallback(response) {
            growl.success("Punkt został dodany pomyślnie", {ttl: 5000});
            $scope.getRoute();
          },
          function errorCallback(response) {
          });
      }
    };

    function removePoint(pId) {
      $http({
        method: 'DELETE',
        type: 'json',
        url: AuthService.apiBaseHref() + '/points/' + pId

      }).then(function successCallback(response) {
        growl.success("Punkt został usunięty pomyślnie", {ttl: 5000});
        $scope.getRoute();

      }, function errorCallback(response) {
      });
    }

    function editPoint(pId) {
      $scope.edited_point = pId;
      $(".point_edit_"+pId).attr('type', 'text');
    }

    function savePoint(pId) {
      var new_point_data = {
        'region': $("#point_edit_"+pId+"_region").val(),
        'subregion': $("#point_edit_"+pId+"_subregion").val(),
        'address': {
          'street': $("#point_edit_" + pId + "_address_street").val(),
          'building_number': $("#point_edit_"+pId+"_address_building_number").val(),
          'post_code': $("#point_edit_"+pId+"_address_post_code").val(),
        },
        'location': {
          'latitude': $("#point_edit_"+pId+"_location_latitude").val(),
          'longitude': $("#point_edit_"+pId+"_location_longitude").val(),
        },
        'note': $("#point_edit_"+pId+"_note").val()
      };

      var endpoint_url = AuthService.apiBaseHref() + '/points/' + pId;
      $http({
        method: 'PUT',
        data: new_point_data,
        type: 'json',
        url: endpoint_url

      }).then(function successCallback(response) {
        $scope.edited_point = 0;
        $(".point_edit_"+pId).attr('type', 'hidden');
        growl.success("Punkt został zmieniony pomyślnie", {ttl: 3000});
        $scope.getRoute();

      }, function errorCallback(response) {
      });
    }

    function cancelEditPoint(pId) {
      $scope.edited_point = 0;
      $(".point_edit_"+pId).attr('type', 'hidden');
    }

    function pointClicked (pId) {
      var isPointSelected = $("#point_selection_"+pId).is(':checked');

      if (isPointSelected) {
        if($scope.selectedPoints.indexOf(pId) === -1) {
          $scope.selectedPoints.push(pId);
        }
      } else {
        var pointIndex = $scope.selectedPoints.indexOf(pId);
        if (pointIndex > -1) {
          $scope.selectedPoints.splice(pointIndex, 1);
        }
      }
    }

    vm.toggleAllPoints = function() {
      $.each($scope.points, function (i, point) {
        if (point.selected) {
          point.selected = false;
        } else {
          point.selected = true;
        }
      });

    }

    function allowDrop (ev) {
      ev.preventDefault();
    }

    function drag (ev) {
      if ($scope.selectedPoints.length === 0) {
        $scope.selectedPoints.push(ev.target.dataset.pointId);
      }

      var data = [];
      for(var i=0; i < $scope.selectedPoints.length; i++ ) {
        var pointId = $scope.selectedPoints[i];
        var sort = $("[data-point-id='"+pointId+"']")[0].dataset.pointSort;

        data.push({
          'point': parseInt(pointId),
          'sort': sort
        })
      }
      ev.dataTransfer.setData("text", JSON.stringify(data));
    }

    function drop (ev) {
      ev.preventDefault();
      var draggedPointIds = [];
      var data = JSON.parse(ev.dataTransfer.getData("text"));
      data = data.sort(function (a, b) {  return a['sort'] - b['sort'];  });

      for (var i=0; i < data.length; i++) {
        draggedPointIds.push(data[i]['point'])
      }

      var dropRow = $(ev.target).parent("tr")[0];
      if (!dropRow) {
        dropRow = event.target;
      }

      var insertElementsAt = Array.prototype.indexOf.call(dropRow.parentElement.children, dropRow);

      var new_order = {};
      var sort = 0;
      for (var i=0; i < dropRow.parentElement.children.length; i++) {
        var element = dropRow.parentElement.children[i];
        var elementPointId = parseInt(element.dataset.pointId)

        if (draggedPointIds.indexOf(elementPointId) !== -1) {
          console.log('checking element '+i+" found dragged element on index "+i)
        } else if (i < insertElementsAt) {
          new_order[elementPointId] = sort;
        } else if (i === insertElementsAt) {
          for (var k=0; k < draggedPointIds.length; k++) {
            new_order[draggedPointIds[k]] = sort;
            sort += 1;
          }
          new_order[elementPointId] = sort;
        } else {
          new_order[elementPointId] = sort;
        }

        sort += 1;
      }

      $http({
        method: 'POST',
        type: 'json',
        url: AuthService.apiBaseHref() + '/points-update-sort',
        data: {"new_points_order": new_order   }
      }).then(function successCallback(response) {
        growl.success("Punkt zostały posortowane pomyślnie", {ttl: 5000});
        $scope.selectedPoints = [];
        $scope.getRoute();
      },
      function errorCallback(response) {
        growl.success("Wystąpił problem przy sortowaniu punktów", {ttl: 5000});
        $scope.selectedPoints = [];
        $scope.getRoute();
      })

    }

    function dragEnter (ev) {
      var el = $(ev.target).parent("tr")[0];
      if (el) {
        el.style.borderTop = "2px solid rgba(255,0,0, 0.4)";
      }
    }

    function dragLeave (ev) {
      var el = $(ev.target).parent("tr")[0];
      if (el) {
        el.style.borderTop = "none";
      }
    }

    function removePoints() {
      var pointsToDelete = [];
      var deleteCounter = 0;

      $.each($scope.points, function (i, point) {
        if (point.selected) {
          pointsToDelete.push(point.id);
        }
      });

      if (!pointsToDelete.length) {
        growl.error("Brak zaznaczonych punktów do usunięcia.", {ttl: 5000});
        return;
      }

      $.each(pointsToDelete, function (i, pointId) {
        $http({
          method: 'DELETE',
          type: 'json',
          url: AuthService.apiBaseHref() + '/points/' + pointId

        }).then(function successCallback(response) {
          deleteCounter++;
          growl.success("Punkt " + pointId + " został usunięty pomyślnie", {ttl: 5000});
          if (deleteCounter === pointsToDelete.length) {
            $scope.getRoute();
          }
        }, function errorCallback(response) {
          deleteCounter++;
          if (deleteCounter === pointsToDelete.length) {
            $scope.getRoute();
          }
        });
      });

    }

    function pointUp(pId, prevPId) {

      $http({
        method: 'PUT',
        type: 'json',
        url: AuthService.apiBaseHref() + '/points-swap',
        data: {
          'id1': pId,
          'id2': prevPId
        }

      }).then(function successCallback(response) {
        growl.success("Punkt został przesunięty pomyślnie", {ttl: 5000});
        $scope.getRoute();

      }, function errorCallback(response) {
      });
    }

    function pointDown(pId, nextPId) {

      $http({
        method: 'PUT',
        type: 'json',
        url: AuthService.apiBaseHref() + '/points-swap',
        data: {
          'id1': pId,
          'id2': nextPId
        }

      }).then(function successCallback(response) {
        growl.success("Punkt został przesunięty pomyślnie", {ttl: 5000});
        $scope.getRoute();

      }, function errorCallback(response) {
      });
    }


    $scope.editRoute = function (form) {
      $http({
        method: 'PUT',
        data: {
          'auditor_id': $scope.editRoute.auditor,
          'campaign_id': $scope.editRoute.campaign,
          'advertising_material': $scope.editRoute.advertising_material,
          'distributor': $scope.editRoute.distributor,
          'customer': $scope.editRoute.customer,
          'start_date': new Date(moment($scope.editRoute.date).format('YYYY-MM-DD')).toISOString(),
          'recording_enabled': !!parseInt($scope.editRoute.recording_enabled),
          'show_record_to_customer': !!parseInt($scope.editRoute.show_record_to_customer),
          'show_kml_to_customer': !!parseInt($scope.editRoute.show_kml_to_customer),
          'required_effectiveness': $scope.editRoute.required_effectiveness,
          'city': $scope.editRoute.city
        },
        type: 'json',
        url: AuthService.apiBaseHref() + '/traces/' + $scope.id

      }).then(function successCallback(response) {
        growl.success("Audyt na dzień: " + moment($scope.editRoute.date).format('YYYY/MM/DD') + " został zmieniony pomyślnie", {ttl: 5000});

      }, function errorCallback(response) {
      });
    };

    $scope.generateAddresses = function () {
      $scope.sendingKml = true;

      $http({
        method: 'POST',
        type: 'json',
        url: AuthService.apiBaseHref() + '/traces/generate-address',
        data: {
          'count': $scope.kmlVariables.addressCount,
          'area': {
            'maxy': $scope.kmlVariables.maxY,
            "miny": $scope.kmlVariables.minY,
            "maxx": $scope.kmlVariables.maxX,
            "minx": $scope.kmlVariables.minX
          }
        }
      }).then(function successCallback(response) {
        $scope.kmlVariables.regionName = '';
        $scope.generatedAddresses = [];
        $scope.sendingKml = false;

        JSON.parse(response.data.result).addresses.forEach(function (point) {
          $scope.generatedAddresses.push(Object.assign(point, {status: true}));
        });

        $scope.centerMap = [$scope.generatedAddresses[0].y, $scope.generatedAddresses[0].x]
      }, function errorCallback(response) {
        $scope.sendingKml = false;
      });

    };

    $scope.sendAddresses = function () {
      // var addressesToSend = [];
      $scope.generatedAddresses.forEach(function (point) {
        if (point.status) {
          // addressesToSend.push(point);
          vm.addPoint(point, true);
        }
      });

      setTimeout(function () {
        $scope.generatedAddresses = [];
        $scope.getRoute();
      }, 5000);
    };

    $scope.importPoints = function () {

      document.getElementsByName('importFileButton')[0].disabled = true;
      $http({
        method: 'POST',
        data: {
          "base64_points_file": $scope.pointsCsv

        },
        type: 'json',
        url: AuthService.apiBaseHref() + '/traces/' + $scope.id + '/import-points'

      }).then(function successCallback(response) {
        document.getElementsByName('importFileButton')[0].disabled = false;
        growl.success("Pomyślnie zaimportowano punkty audytu.", {ttl: 5000});
        $scope.getRoute();

      }, function errorCallback(response) {
        document.getElementsByName('importFileButton')[0].disabled = false;
        var errorTxt = "";

        $.each(response.data.details, function (i, detail) {
          errorTxt += "Wiersz: " + detail.field + " - " + detail.message + "</br>";
        });
        growl.error(errorTxt, {ttl: 5000});
      });
    };

    $scope.importKml = function () {

      document.getElementsByName('sendKmlButton')[0].disabled = true;
      $http({
        method: 'PATCH',
        data: {
          "kml": $scope.kmlFile
        },
        type: 'json',
        url: AuthService.apiBaseHref() + '/traces/' + $scope.id

      }).then(function successCallback(response) {
        document.getElementsByName('sendKmlButton')[0].disabled = false;
        growl.success("Pomyślnie zaimportowano plik KML.", {ttl: 5000});
        $scope.getRoute();

      }, function errorCallback(response) {
        document.getElementsByName('sendKmlButton')[0].disabled = false;
        var errorTxt = "";

        $.each(response.data.details, function (i, detail) {
          errorTxt += "Wiersz: " + detail.field + " - " + detail.message + "</br>";
        });
        growl.error(errorTxt, {ttl: 5000});
      });
    };

    $scope.importKmlToMap = function () {
      $scope.mapParser = new geoXML3.parser({
        map: vm.map,
        afterParse: useTheData
      });

      $scope.mapParser.parse($scope.kmlVariables.kmlMapFile);
    };

    $scope.clearMap = function () {
      location.reload();
    };

    $scope.dtOptions = DTOptionsBuilder
      .newOptions()
      .withOption('stateSave', true)
      .withOption('iDisplayLength', 100)
      .withOption('initComplete', function(){
        var self = this;
        // $(self.api().table().container()).find('input').parent().wrap('<form>').parent().attr('autocomplete', 'off');
        $(self.api().table().container()).find('input').attr('autocomplete', 'off');
      })
      .withPaginationType('full_numbers')
      .withBootstrap()
      .withDOM('<"html5buttons"B>lTfgitp')
      .withButtons([
        {extend: 'copy'},
        {extend: 'csv'},
        {
          extend: 'pdfHtml5',
          title: 'Punkty audytu'
        },
        {
          extend: 'print',
          customize: function (win) {
            $(win.document.body).addClass('white-bg');
            $(win.document.body).css('font-size', '10px');

            $(win.document.body).find('table')
              .addClass('compact')
              .css('font-size', 'inherit');
          }
        }
      ]);

    $scope.dtColumnDefs = [
      DTColumnDefBuilder.newColumnDef(0).notSortable(),
      DTColumnDefBuilder.newColumnDef(1),
      DTColumnDefBuilder.newColumnDef(2),
      DTColumnDefBuilder.newColumnDef(3),
      DTColumnDefBuilder.newColumnDef(4),
      DTColumnDefBuilder.newColumnDef(5),
      DTColumnDefBuilder.newColumnDef(6).notSortable(),
      DTColumnDefBuilder.newColumnDef(7).notSortable(),
    ];

    $scope.backToRoutes = function () {

      $state.transitionTo('index.routes', {id: $scope.campaign_id})
    };

    $scope.showTrace = function (campaignId) {

      $state.transitionTo('index.routesCustomer', {id: campaignId});
    };


  });

angular.module('inspinia')
  .directive('fullScreenToggle', function ($timeout) {
    return {
      link: function (scope, e) {
        var fullScreenClick = function () {
          e.parent().toggleClass('full-screen');
          e.text(e.parent().hasClass('full-screen') ? 'Exit Full Screen' : 'Full Screen');
          google.maps.event.trigger(scope.map, 'resize');
        };
        e.on('click', fullScreenClick);
      }
    }
  });

'use strict';

angular.module('inspinia')
    .controller('RouteAddController', function ($scope, $state, $http, $filter, AuthService, growl) {
        $scope.newRoute = {};
        $scope.newRoute.date = Date.now();
        $scope.newRoute.recording_enabled = "0";
        $scope.newRoute.show_record_to_customer = "0";
        $scope.newRoute.show_kml_to_customer = "0";
        $scope.newRoute.kml_file = "";
        $scope.format = 'yyyy/MM/dd';
        $scope.dp = {
            opened: false
        };
        $scope.customers = [];
        $scope.campaigns = [];
        $scope.auditors = [];

        $scope.dateOptions = {
            dateDisabled: false,
            formatYear: 'yy',
            maxDate: moment(new Date()).add(1, 'year'),
            minDate: new Date(),
            startingDay: 1
        };

        $scope.campaign_id = $state.params.id;

        $scope.openDp = function() {

            $scope.dp.opened = true;
        };

        $scope.getCampaigns = function() {

            $http({
                method: 'GET',
                type: 'json',
                url: AuthService.apiBaseHref() + '/campaigns?filter=[id{eq} ' + $scope.campaign_id + ']'

            }).then(function successCallback(response) {
                $scope.campaigns = response.data.items;
                $scope.newRoute.campaign  = response.data.items;
            }, function errorCallback(response) {
                if(response.statusText === "Forbidden") {
                    $state.transitionTo('login');
                }
            });
        };

        $scope.getCampaigns();

        $scope.getCustomers = function() {

            $http({
                method: 'GET',
                type: 'json',
                url: AuthService.apiBaseHref() + '/customers?limit=-1'

            }).then(function successCallback(response) {
                $scope.customers = response.data.items;

            }, function errorCallback(response) {
                if(response.statusText === "Forbidden") {
                    $state.transitionTo('login');
                }
            });
        };

        $scope.getCustomers();

        $scope.getAuditors = function() {

            $http({
                method: 'GET',
                type: 'json',
                url: AuthService.apiBaseHref() + '/auditors?limit=-1'

            }).then(function successCallback(response) {
                $scope.auditors = response.data.items;

            }, function errorCallback(response) {
                if(response.statusText === "Forbidden") {
                    $state.transitionTo('login');
                }
            });
        };

        $scope.getAuditors();

        $scope.addRoute = function(newRoute) {

            $http({
                method: 'POST',
                data: {
                    'auditor_id': $scope.newRoute.auditor.id,
                    'campaign_id':  $scope.newRoute.campaign[0].id,
                    'start_date': new Date(moment(newRoute.date).format('YYYY-MM-DD')).toISOString(),
                    'recording_enabled': !!parseInt($scope.newRoute.recording_enabled),
                    'show_record_to_customer': !!parseInt($scope.newRoute.show_record_to_customer),
                    'show_kml_to_customer':  !!parseInt($scope.newRoute.show_kml_to_customer),
                    'required_effectiveness':  $scope.newRoute.required_effectiveness,
                    'customer':  $scope.newRoute.customer,
                    'distributor':  $scope.newRoute.distributor,
                    'advertising_material':  $scope.newRoute.advertising_material,
                    'city': $scope.newRoute.city,
                    'kml': $scope.newRoute.kml_file
                },
                type: 'json',
                url: AuthService.apiBaseHref() + '/traces'

            }).then(function successCallback(response) {
                growl.success("Audyt na dzień: " + moment(newRoute.date).format('YYYY/MM/DD') + " został dodany pomyślnie", { ttl: 5000 });
                $state.transitionTo('index.routes', {id: $scope.campaign_id});
            }, function errorCallback(response) {});
        };

        $scope.backToRoutes = function () {

            $state.transitionTo('index.routes', {id: $scope.campaign_id})
        };

    });

'use strict';

angular.module('inspinia')
    .controller('PanelController', function ($scope, $filter, $state, $http, $rootScope, AuthService, USER_ROLES) {

      var vm = this;
      var date = new Date();

      $scope.current_date = date;
      $scope.groupedByCampaign = true;

      vm.traces_pushed = [];
      vm.tracesByCampaign = {};
      vm.campaignNamesById = {};
      vm.traceIds = [];
      vm.tracesById = {};
      vm.statisticsRoute = {}

      $scope.getRoutesStatistics = function (traceIds) {
        $http({
          method: 'post',
          data: {'trace_ids': traceIds},
          type: 'json',
          url: AuthService.apiBaseHref() + '/traces/statistics-many'
        }).then(function successCallback(response) {
          var stats = response.data.result;
          var newStatsAll = {};
          angular.forEach(stats, function (point, key) {
            var stats = point;
            var trace = vm.tracesById[key];

            stats.visitedPointPercent = trace.points_count == 0 ? 0 : ((trace.visited_points_count / trace.points_count) * 100).toFixed(0);
            stats.effectivePointPercent = trace.percent_effectiveness;
            stats.pointCount = trace.points_count > 0 ? trace.points_count : 0;
            stats.requiredEffectiveness = trace.required_effectiveness ? trace.required_effectiveness : 0;
            stats.visitedPointCount = trace.visited_points_count > 0 ? stats.status_visited_count : 0;
            stats.effectivePointCount = trace.visited_points_count > 0 ? stats.status_effective_count : 0;

            newStatsAll[key] = point;
          });

          vm.statisticsRoute = newStatsAll;
        });
      };

      vm.toggleGroupByCampaign = function() {
        if ($scope.groupedByCampaign === true) {
          $scope.groupedByCampaign = false;
        } else {
          $scope.groupedByCampaign = true;
        }
      }

      vm.getTracesForDate = function(date) {
        $http({
          method: 'GET',
          type: 'json',
          url: AuthService.apiBaseHref() + '/traces?filter=[start_date{eq}'+$filter('date')(date.setDate(date.getDate()), 'yyyy-MM-dd')+']',
        }).then(function successCallback(response)
        {
          vm.traces = response.data.items;
          vm.traces_pushed = [];
          vm.tracesByCampaign = {};

          response.data.items.forEach(function(trace) {
            if (!vm.tracesByCampaign.hasOwnProperty(trace.campaign.id+" "+trace.campaign.name)) {
              vm.tracesByCampaign[trace.campaign.id+" "+trace.campaign.name] = [];
              vm.campaignNamesById[trace.campaign.id] = trace.campaign;
            }

            if (vm.traces_pushed.indexOf(trace.id) === -1 ){
              console.log('pushing trace '+trace.id);
              vm.traceIds.push(trace.id);
              vm.tracesById[trace.id] = trace;
              vm.traces_pushed.push(trace.id);
              vm.tracesByCampaign[trace.campaign.id+" "+trace.campaign.name].push(trace);
            }
          });

          $scope.getRoutesStatistics(vm.traceIds);
        }, function errorCallback(response) {
          console.log('got error response!', response)
        });
      }

      vm.getTraces = function ()
      {
        vm.getTracesForDate(date);
      };

      vm.getTracesForChoosenDate = function() {
        var choosenDate = $scope.current_date;
        vm.getTracesForDate(choosenDate);
      }

      vm.getTraces();

      vm.showTrace = function(traceId) {
        var url = $state.href('index.route-view', {id: traceId});
        window.open(url,'_blank');
      };

      vm.groupByCampaign = function() {
        vm.traces.sort(function(a, b){return b.campaign.id - a.campaign.id});
      }

      setTimeout(vm.getTraces(), 60000);
});

'use strict';

angular.module('inspinia')
    
    .controller('MainController', function ($rootScope, $scope, $state, $filter, AuthService, AUTH_EVENTS, growl, $http, USER_ROLES) {
        $rootScope.username = AuthService.username();

        $scope.$on(AUTH_EVENTS.notAuthorized, function(event) {
            growl.error("Brak autoryzacji", { ttl: 5000 });

        });
        $scope.$on(AUTH_EVENTS.notAuthenticated, function(event) {
            AuthService.logout();
            $state.go('login');
        });
       
        var vm = this;
        var date = new Date();
        vm.logout = function()
        {
            AuthService.logout();
            $state.go('login');
        };

        vm.isAdmin = function()
        {
            return AuthService.isAdmin();
        };

       
        vm.pieChartOptions = {
            effective: {
                fill: ["#1ab394", '#eeeeee']
            },
            noneffective: {
                fill: ["#ff3333", '#ffcccc']
            }

        };

        
        $scope.date = $filter('date')(date.setDate(date.getDate() - 1), 'yyyy-MM-dd');
        $scope.data = {};
        $scope.data.routes = [];

        $scope.routeStatuses = {
            N: 'Nowa',
            A: 'Aktywna',
            F: 'Zakończona'
        };

        $scope.routePointStatuses = {
            N: 'Nieodwiedzony',
            A: 'Aktywny',
            V: 'Odwiedzony'
        };


    });

'use strict';

angular.module('inspinia')
    .controller('PasswordController', function ($scope, $filter, $state, $http, $rootScope, AuthService, USER_ROLES, growl) {
        var vm = this;
        vm.resetPassword = function(data) {
            AuthService.resetPassword(vm.email);
        };

    });
'use strict';

angular.module('inspinia')
    .controller('LoginController', function ($scope, $filter, $state, $http, $rootScope, AuthService, USER_ROLES) {
        $scope.login = function(data) {
            AuthService.login($scope.loginForm.email, $scope.loginForm.password, USER_ROLES.customer).then(function(authenticated) {
                $state.go('index.campaigns', {}, {reload: true});
                $rootScope.username = AuthService.username();
            }, function(err) {

            });
        };

    });
'use strict';

angular.module('inspinia')
    .controller('AdminLoginController', function ($scope, $filter, $state, $http, $rootScope, AuthService, USER_ROLES) {


        $scope.login = function(data) {
            AuthService.login($scope.loginForm.email, $scope.loginForm.password, USER_ROLES.admin).then(function(authenticated) {
                $state.go('index.campaigns', {}, {reload: true});
                $rootScope.username = AuthService.username();

            }, function(err) {

            });
        };

    });
'use strict';

angular.module('inspinia')
    .controller('EditCustomersController', function ($scope, $filter, $http, $state, AuthService, growl) {

        var vm = this;
        vm.id = $state.params.id;
        vm.form = {};

        vm.getCustomer = function ()
        {
            $http({
                method: 'GET',
                type: 'json',
                url: AuthService.apiBaseHref() + '/customers/' + vm.id
            }).then(function successCallback(response)
            {
                response.data.phone = parseInt(response.data.phone);
                vm.form = response.data;

            }, function errorCallback(response) {
                if(response.statusText === "Forbidden"){
                    $state.transitionTo('login');
                }
            });
        };

        vm.getCustomer();

        vm.saveCustomer = function ()
        {
            if(vm.form_customer.$valid)
            {
                $http({
                    method: 'PUT',
                    data: {
                        name: vm.form.name,
                        email: vm.form.email,
                        phone: vm.form.phone,
                        address: {
                            street: vm.form.address.street,
                            city: vm.form.address.city,
                            post_code: vm.form.address.post_code,
                        }
                    },
                    type: 'json',
                    url: AuthService.apiBaseHref() + '/customers/' + vm.id

                }).then(function successCallback(response)
                {
                    growl.success("Klient: " + vm.form.name + " został zmieniony pomyślnie", { ttl: 5000 });

                    $state.transitionTo('index.customers');

                }, function errorCallback(response)
                {

                });
            }
        }

    });
'use strict';

angular.module('inspinia')
    .controller('CustomersController', function ($scope, $filter, $state, $http, $compile, DTOptionsBuilder, DTColumnBuilder, AuthService) {

        $scope.showModal = false;
        $scope.customerID = null;
        $scope.customerName = null;

        $scope.getCustomers = function () {
            $http({
                method: 'GET',
                type: 'json',
                url: AuthService.apiBaseHref() + '/customers?limit=-1'
            }).then(function successCallback(response) {
                $scope.data.customers = response.data.items;

            }, function errorCallback(response) {
                if(response.statusText === "Forbidden"){
                    $state.transitionTo('login');
                }
            });
        };

        $scope.getCustomers();

        $scope.dtOptions = DTOptionsBuilder
            .newOptions()
            .withOption('scrollX', '100%')
          .withOption('order', [0, 'desc'])
          .withOption('iDisplayLength', 100)
          .withOption('initComplete', function(){
            var self = this;
            $(self.api().table().container()).find('input').parent().wrap('<form>').parent().attr('autocomplete', 'off');
            $(self.api().table().container()).find('input').attr('autocomplete', 'off');
          })
          .withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('<"html5buttons"B>lTfgitp')
            .withButtons([
                {extend: 'copy'},
                {extend: 'csv'},
                {extend: 'pdfHtml5', title: 'Klienci'},
                {
                    extend: 'print',
                    customize: function (win) {
                        $(win.document.body).addClass('white-bg');
                        $(win.document.body).css('font-size', '10px');

                        $(win.document.body).find('table')
                            .addClass('compact')
                            .css('font-size', 'inherit');
                    }
                }
            ]);

        $scope.dtInstance = {};

        $scope.deleteCustomer = function (customer) {
            $http({
                method: 'DELETE',
                type: 'json',
                url: AuthService.apiBaseHref() + '/customers/' + customer

            }).then(function successCallback(response) {
                $state.reload();
            }, function errorCallback(response) {
                //
            });
        };

        $scope.editCustomer = function (customer) {
            $state.transitionTo('index.customers-edit', {id: customer.id});
        }

        $scope.showUsers = function (customer) {
            $state.transitionTo('index.customer-users', {c_id: customer.id});
        }

        $scope.Modal = function(visible){
            $scope.showModal = visible;
        }

        $scope.sendParamsToModal = function(visible, customer){
            $scope.showModal = visible;
            $scope.customerID = customer.id;
            $scope.customerName = customer.name;
        }

    });

'use strict';

angular.module('inspinia')
    .controller('AddCustomerController', function ($scope,$http, $filter, $state, AuthService, growl) {
        $scope.newCustomer = {};

        $scope.addCustomer = function(newCustomer) {
            $http({
                method: 'POST',
                data: {
                    name: $scope.newCustomer.name,
                    email: $scope.newCustomer.email,
                    phone: $scope.newCustomer.phone,
                    address : {
                        street: $scope.newCustomer.address.street,
                        city: $scope.newCustomer.address.city,
                        post_code: $scope.newCustomer.address.postCode,
                    }
                },
                type: 'json',
                url: AuthService.apiBaseHref() + '/customers'

            }).then(function successCallback(response)
            {
                growl.success("Klient: " + $scope.newCustomer.name + " został dodany pomyślnie", { ttl: 5000 });
                $state.transitionTo('index.customers');

            }, function errorCallback(response)
            {

            });
        };

    });
'use strict';

angular.module('inspinia')
    .controller('UsersController', function ($scope, $filter, $state, $compile, $http, DTOptionsBuilder, DTColumnDefBuilder, AuthService, growl) {
        var vm = this;

        vm.users = [];
        vm.customer_id = $state.params.c_id;
        vm.filters = '?filter=[customer{eq}' +  vm.customer_id + ']&limit=-1';

        vm.showModal = false;
        vm.usrId = null;

        vm.getUsers = function ()
        {
            $http({
                method: 'GET',
                type: 'json',
                url: AuthService.apiBaseHref() + '/customer-users' +  vm.filters ,
            }).then(function successCallback(response)
            {
                vm.users = response.data.items;

            }, function errorCallback(response) {
                if(response.statusText === "Forbidden"){
                    $state.transitionTo('login');
                }
            });
        };

        vm.getUsers();

        vm.dtOptions = DTOptionsBuilder
            .newOptions()
            .withPaginationType('full_numbers')
            .withOption('stateSave', true)
            .withOption('iDisplayLength', 100)
            .withOption('scrollX', '100%')
          .withOption('initComplete', function(){
            var self = this;
            $(self.api().table().container()).find('input').parent().wrap('<form>').parent().attr('autocomplete', 'off');
            $(self.api().table().container()).find('input').attr('autocomplete', 'off');
          })
          .withOption('order', [0, 'desc'])
          .withBootstrap()
            .withDOM('<"html5buttons"B>lTfgitp')
            .withButtons([
                {extend: 'copy'},
                {extend: 'csv'},
                {
                    extend: 'pdfHtml5',
                    title: 'Użytkownicy'
                },
                {extend: 'print',
                    customize: function (win)
                    {
                        $(win.document.body).addClass('white-bg');
                        $(win.document.body).css('font-size', '10px');

                        $(win.document.body).find('table')
                            .addClass('compact')
                            .css('font-size', 'inherit');
                    }
                }
            ]);

        vm.dtInstance      = {};
        // Active Buttons extension
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(1),
            DTColumnDefBuilder.newColumnDef(2),
            DTColumnDefBuilder.newColumnDef(3),
            DTColumnDefBuilder.newColumnDef(4),
            DTColumnDefBuilder.newColumnDef(5).notSortable()
        ];

        vm.deleteUser = function (index)
        {
            vm.$parent.users.splice(index, 1);
            vm.dtInstance.rerender();
        }

        vm.editUser = function (user)
        {
            $state.transitionTo('index.customer-users-edit', {c_id: vm.customer_id, id: user.id});
        }

        vm.addUser = function ()
        {
            $state.transitionTo('index.customer-users-add', {c_id: vm.customer_id});
        }

        vm.modalPassword = function(visible){
            vm.showModalPassword = visible;
        }

        vm.changePasswordModal = function(visible, user){
            vm.showModalPassword = visible;
            vm.usrId = user.id;
        }

        vm.changePassword = function (usr)
        {
            $http({
                method: 'PUT',
                type: 'json',
                data: {
                    password: vm.password
                },
                url: AuthService.apiBaseHref() + '/customer-users/' + usr.usrId + '/change_password' ,
            }).then(function successCallback(response)
            {
                growl.success('Hasło zostało zmienione pomyślnie', {ttl: 5000});
                usr.modalPassword(false);

            }, function errorCallback(response) {
                if(response.error == 'validation_failed') {
                    growl.error('Wystąpił błąd - hasło nie spełnia wymagań.', {ttl: 5000});
                } else {
                    growl.error('Wystąpił błąd podczas aktualizacji hasła.', {ttl: 5000});
                }

            });
        }

    });
'use strict';

angular.module('inspinia')
    .controller('EditUserController', function ($scope, $filter, $state, $http, AuthService, growl) {
        var vm = this;
        vm.customer_id = $state.params.c_id;
        vm.user_id = $state.params.id;
        vm.form = {};

        vm.getUser = function ()
        {
            $http({
                method: 'GET',
                type: 'json',
                url: AuthService.apiBaseHref() + '/customer-users/' + vm.user_id ,
            }).then(function successCallback(response)
            {
                response.data.phone = parseInt(response.data.phone);
                vm.form = response.data;

            }, function errorCallback(response) {
                if(response.statusText === "Forbidden"){
                    $state.transitionTo('login');
                }
            });
        };

        vm.getUser();

        vm.saveUser = function ()
        {
            if(vm.form_user.$valid)
            {
                $http({
                    method: 'PUT',
                    data: {
                        first_name: vm.form.first_name,
                        login: vm.form.email,
                        phone: vm.form.phone,
                        last_name: vm.form.last_name,
                        email: vm.form.email,
                    },
                    type: 'json',
                    url: AuthService.apiBaseHref() + '/customer-users/' + vm.user_id

                }).then(function successCallback(response)
                {
                    growl.success("Użytkownik: " + vm.form.first_name + " " + vm.form.last_name + " został zmieniony pomyślnie", { ttl: 5000 });

                    $state.transitionTo('index.customer-users', {c_id: vm.customer_id});

                }, function errorCallback(response)
                {

                });
            }
        }
    });
'use strict';

angular.module('inspinia')
    .controller('AddUserController', function ($scope, $filter, $state, $http, AuthService, growl) {
        var vm = this;
        vm.customer_id = $state.params.c_id;

        vm.saveUser = function (form)
        {
            if(vm.form_user.$valid)
            {
                $http({
                    method: 'POST',
                    data: {
                        first_name: form.name,
                        login: form.email,
                        phone: form.phone,
                        last_name: form.surname,
                        email: form.email,
                        customer_id: vm.customer_id
                    },
                    type: 'json',
                    url: AuthService.apiBaseHref() + '/customer-users'

                }).then(function successCallback(response)
                {
                    growl.success("Użytkownik: " + form.name + " " + form.surname + " został dodany pomyślnie", { ttl: 5000 });
                    $state.transitionTo('index.customer-users', {c_id: vm.customer_id});

                }, function errorCallback(response)
                {

                });
            }
        }
    });
'use strict';

angular.module('inspinia')
  .controller('CampaignController', function ($scope, $filter, $state, $http, $compile, DTOptionsBuilder, DTColumnBuilder, AuthService, growl) {
    var vm = this;
    $scope.moment = moment;

    vm.getCampaigns = function () {
      $http({
        method: 'GET',
        type: 'json',
        url: AuthService.apiBaseHref() + '/campaigns?limit=-1'
      }).then(function successCallback(response) {
        $scope.data.campaigns = response.data.items;

      }, function errorCallback(response) {
        if (response.statusText === "Forbidden") {
          $state.transitionTo('login');
        }
        // called asynchronously if an error occurs
        // or server returns response with an error status.
      });
    };

    vm.getCampaigns();

    vm.dtOptions = DTOptionsBuilder
      .newOptions()
      .withOption('stateSave', true)
      .withOption('scrollX', '100%')
      .withOption('initComplete', function () {
        var self = this;
        $(self.api().table().container()).find('input').parent().wrap('<form>').parent().attr('autocomplete', 'off');
        $(self.api().table().container()).find('input').attr('autocomplete', 'off');
      })
      .withOption('iDisplayLength', 100)
      .withPaginationType('full_numbers')
      .withBootstrap()
      .withDOM('<"html5buttons"B>lTfgitp')
      .withOption('order', [0, 'desc'])
      .withButtons([
        {
          extend: 'copy',
          exportOptions: {
            columns: 'thead th:not(.noExport)'
          }
        },
        {
          extend: 'csv',
          exportOptions: {
            columns: 'thead th:not(.noExport)'
          }
        },
        {
          extend: 'pdfHtml5',
          title: 'Kampanie',
          customize: function (doc) {
            var colCount = new Array();
            $('#campaignTable').find('tbody tr:first-child td').each(function () {
              if ($(this).attr('colspan')) {
                for (var i = 1; i <= $(this).attr('colspan'); $i++) {
                  colCount.push('*');
                }
              } else {
                colCount.push('*');
              }
            });
            doc.content[1].table.widths = colCount;
          },
          exportOptions: {
            columns: 'thead th:not(.noExport)'
          }
        },
        {
          extend: 'print',
          customize: function (win) {
            $(win.document.body).addClass('white-bg');
            $(win.document.body).css('font-size', '10px');

            $(win.document.body).find('table')
              .addClass('compact')
              .css('font-size', 'inherit');
          },
          exportOptions: {
            columns: 'thead th:not(.noExport)'
          }
        }
      ]);

    vm.deleteCampaign = function (cId) {
      $http({
        method: 'DELETE',
        type: 'json',
        url: AuthService.apiBaseHref() + '/campaigns/' + cId,
      }).then(function successCallback(response) {
        vm.getCampaigns();
        growl.success("Kampania: " + vm.campaignName + " została usunięta pomyślnie", {ttl: 5000});


      }, function errorCallback(response) {
        growl.error("Kampania: " + vm.campaignName + " nie została usunięta!", {ttl: 5000});

      });
    };

    vm.showDelModal = function (visible) {
      vm.showDeleteModal = visible;
    };

    vm.sendParamsToDelModal = function (visible, campaign) {
      vm.showDeleteModal = visible;
      vm.cId = campaign.id;
      vm.campaignName = campaign.name;
    }


  });

'use strict';

angular.module('inspinia')
    .controller('CampaignEditController', function ($scope, $state, $filter, $http, DTOptionsBuilder, DTColumnDefBuilder, AuthService, growl) {
        var vm = this;
        vm.customers = [];
        vm.campaign = {};
        vm.campaign_id = $state.params.id;


        vm.getCustomers = function() {
            $http({
                method: 'GET',
                type: 'json',
                url: AuthService.apiBaseHref() + '/customers?limit=-1'

            }).then(function successCallback(response)
            {
                vm.customers = response.data.items;

            }, function errorCallback(response)
            {
                if(response.statusText === "Forbidden"){
                    $state.transitionTo('login');
                }
            });
        };

        vm.getCustomers();

        vm.editCampaign = function() {
            $http({
                method: 'PUT',
                data: {
                    'name': vm.campaign.name,
                    'customer_id': vm.campaign.customer.id,
                },
                type: 'json',
                url: AuthService.apiBaseHref() + '/campaigns/' + vm.campaign_id

            }).then(function successCallback(response)
            {
                growl.success("Kampania o nazwie: " + vm.campaign.name + " została zmieniona pomyślnie", { ttl: 5000 });

                $state.transitionTo('index.campaigns');

            }, function errorCallback(response)
            {

            });
        };

        vm.getCampaign = function() {
            $http({
                method: 'GET',
                type: 'json',
                url: AuthService.apiBaseHref() + '/campaigns?filter=[id{eq}' + vm.campaign_id + ']'

            }).then(function successCallback(response)
            {
                vm.campaign.name = response.data.items[0].name;
                vm.campaign.customer = response.data.items[0].customer.id;

            }, function errorCallback(response)
            {

            });
        };

        vm.getCampaign();
        

    });

'use strict';

angular.module('inspinia')
    .controller('CampaignAddController', function ($scope, $state, $http, $filter, AuthService, growl) {
        var vm = this;
        vm.customers = [];
        vm.newCampaign = {};


        vm.getCustomers = function() {
            $http({
                method: 'GET',
                type: 'json',
                url: AuthService.apiBaseHref() + '/customers?limit=-1'

            }).then(function successCallback(response)
            {
                vm.customers = response.data.items;

            }, function errorCallback(response)
            {
                if(response.statusText === "Forbidden"){
                    $state.transitionTo('login');
                }
            });
        };

        vm.getCustomers();

        vm.addCampaign = function(newCampaign) {
            $http({
                method: 'POST',
                data: {
                    'name': newCampaign.name,
                    'customer_id': newCampaign.customer.id,
                },
                type: 'json',
                url: AuthService.apiBaseHref() + '/campaigns'

            }).then(function successCallback(response)
            {
                $state.transitionTo('index.campaigns');
                growl.success("Kampania o nazwie: " + newCampaign.name + " została dodana pomyślnie", { ttl: 5000 });

            }, function errorCallback(response)
            {

            });
        };
    });

'use strict';

angular.module('inspinia')
    .controller('EditAuditorController', function ($scope, $filter, $state, $http, AuthService, growl) {
        var vm = this;
        vm.auditor_id = $state.params.id;
        vm.form = {};

        vm.getAuditor = function ()
        {
            $http({
                method: 'GET',
                type: 'json',
                url: AuthService.apiBaseHref() + '/auditors/' + vm.auditor_id ,
            }).then(function successCallback(response)
            {
                response.data.phone = parseInt(response.data.phone);
                vm.form = response.data;

            }, function errorCallback(response) {
                if(response.statusText === "Forbidden"){
                    $state.transitionTo('login');
                }
            });
        };

        vm.getAuditor();

        vm.saveAuditor = function ()
        {
            if(vm.form_auditor.$valid)
            {
                vm.form.address.country_code = 'PL';
                $http({
                    method: 'PUT',
                    data: {
                        first_name: vm.form.first_name,
                        login: vm.form.email,
                        phone: vm.form.phone,
                        last_name: vm.form.last_name,
                        email: vm.form.email,
                        address: vm.form.address

                    },
                    type: 'json',
                    url: AuthService.apiBaseHref() + '/auditors/' + vm.auditor_id

                }).then(function successCallback(response)
                {
                    growl.success("Audytor: " + vm.form.first_name + " " + vm.form.last_name + " został zmieniony pomyślnie", { ttl: 5000 });

                    $state.transitionTo('index.auditors');

                }, function errorCallback(response)
                {

                });
            }
        }

        vm.importMobileLogo = function() {
            $http({
                method: 'PUT',
                data: {
                    "photo": $scope.mobileLogo
                },
                type: 'json',
                url: AuthService.apiBaseHref() + '/auditors/' + vm.auditor_id

            }).then(function successCallback(response)
            {
                vm.form.photo = response.data.photo;
                growl.success("Obraz zaimportowany pomyślnie", { ttl: 5000 });
            }, function errorCallback(response)
            {

            });
        };

        vm.deleteMobileLogo = function() {
            $http({
                method: 'PUT',
                data: {
                    "photo": ''
                },
                type: 'json',
                url: AuthService.apiBaseHref() + '/auditors/' + vm.auditor_id

            }).then(function successCallback(response)
            {
                vm.form.photo = response.data.photo;
                growl.success("Przywrócono domyślne logo", { ttl: 5000 });
            }, function errorCallback(response)
            {

            });
        };
    });
'use strict';

angular.module('inspinia')
    .controller('AuditorsController', function ($scope, $filter, $state, $compile, $http, DTOptionsBuilder, DTColumnDefBuilder, AuthService, growl) {
        var vm = this;

        vm.auditors = [];
        vm.filters = '?limit=-1';

        vm.showModal = false;
        vm.audId = null;
        vm.audEmail = null;

        vm.Modal = function(visible){
            vm.showModal = visible;
        }

        vm.modalPassword = function(visible){
            vm.showModalPassword = visible;
        }

        vm.sendParamsToModal = function(visible, auditor){
            vm.showModal = visible;
            vm.audId = auditor.id;
            vm.audEmail = auditor.email;
        }

        vm.changePasswordModal = function(visible, auditor){
            vm.showModalPassword = visible;
            vm.audId = auditor.id;
        }

        vm.changePassword = function (auditor)
        {
            $http({
                method: 'PUT',
                type: 'json',
                data: {
                    password: vm.password
                },
                url: AuthService.apiBaseHref() + '/auditors/' + auditor.audId + '/change_password' ,
            }).then(function successCallback(response)
            {
                growl.success('Hasło zostało zmienione pomyślnie', {ttl: 5000});
                auditor.modalPassword(false);

            }, function errorCallback(response) {
                // called asynchronously if an error occurs
                // or server returns response with an error status.
                if(response.error == 'validation_failed') {
                    growl.error('Wystąpił błąd - hasło nie spełnia wymagań.', {ttl: 5000});
                } else {
                    growl.error('Wystąpił błąd podczas aktualizacji hasła.', {ttl: 5000});
                }

            });
        }

        vm.getAuditors = function ()
        {
            $http({
                method: 'GET',
                type: 'json',
                url: AuthService.apiBaseHref() + '/auditors' +  vm.filters ,
            }).then(function successCallback(response)
            {
                vm.auditors = response.data.items;

            }, function errorCallback(response) {
                if(response.statusText === "Forbidden"){
                    $state.transitionTo('login');
                }
            });
        };

        vm.getAuditors();

        vm.dtOptions = DTOptionsBuilder
            .newOptions()
            .withOption('scrollX', '100%')
            .withOption('autocomplete', 'off')
            .withOption('iDisplayLength', 100)
            .withPaginationType('full_numbers')
            .withOption('stateSave', true)
          .withOption('initComplete', function(){
            var self = this;
            $(self.api().table().container()).find('input').parent().wrap('<form>').parent().attr('autocomplete', 'off');
            $(self.api().table().container()).find('input').attr('autocomplete', 'off');
          })
          .withOption('order', [0, 'desc'])
          .withBootstrap()
            .withDOM('<"html5buttons"B>lTfgitp')
            .withButtons([
                {extend: 'copy'},
                {extend: 'csv'},
                {
                    extend: 'pdfHtml5',
                    title: 'Audytorzy'
                },
                {extend: 'print',
                    customize: function (win)
                    {
                        $(win.document.body).addClass('white-bg');
                        $(win.document.body).css('font-size', '10px');

                        $(win.document.body).find('table')
                            .addClass('compact')
                            .css('font-size', 'inherit');
                    }
                }
            ]);

        vm.dtInstance      = {};
        // Active Buttons extension
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(1),
            DTColumnDefBuilder.newColumnDef(2),
            DTColumnDefBuilder.newColumnDef(3),
            DTColumnDefBuilder.newColumnDef(4),
            DTColumnDefBuilder.newColumnDef(5).notSortable()
        ];

        vm.deleteAuditor = function (audId)
        {
            $http({
                method: 'DELETE',
                type: 'json',
                url: AuthService.apiBaseHref() + '/auditors/' + audId

            }).then(function successCallback(response) {
                $state.reload();
            }, function errorCallback(response) {
                //
            });
        }

        vm.editAuditor = function (auditor)
        {
            $state.transitionTo('index.auditors-edit', { id: auditor.id});
        }

        vm.addAuditor = function ()
        {
            $state.transitionTo('index.auditors-add');
        }

    });

'use strict';

angular.module('inspinia')
    .controller('AddAuditorController', function ($scope, $filter, $state, $http, AuthService, growl) {
        var vm = this;
        vm.customer_id = $state.params.c_id;

        vm.saveAuditor = function (form)
        {
            if(vm.form_auditor.$valid)
            {
                form.address.country_code = 'PL';
                $http({
                    method: 'POST',
                    data: {
                        first_name: form.name,
                        login: form.email,
                        phone: form.phone,
                        last_name: form.surname,
                        email: form.email,
                        address: form.address
                    },
                    type: 'json',
                    url: AuthService.apiBaseHref() + '/auditors'

                }).then(function successCallback(response)
                {
                    growl.success("Audytor: " + form.name + " " + form.surname + " został dodany pomyślnie", { ttl: 5000 });
                    $state.transitionTo('index.auditors');

                }, function errorCallback(response)
                {

                });
            }
        }
    });
angular.module('inspinia')

    .service('AuthService', function($q, $http, USER_ROLES, growl, $state, Config) {
        var username = '';
        var isAuthenticated = false;
        var localrole = '';
        var authToken;
        var api_base_href; 

        function loadUserCredentials() {
            var name = window.localStorage.getItem('LOCAL_NAME');
            var role = window.localStorage.getItem('LOCAL_ROLE');
            var token = window.localStorage.getItem('LOCAL_TOKEN_KEY');
            
            if (token) {
                useCredentials(name, role, token);
            }
        }

        function storeUserCredentials(name, role, token) {
            window.localStorage.setItem('LOCAL_ROLE', role);
            window.localStorage.setItem('LOCAL_NAME', name);
            window.localStorage.setItem('LOCAL_TOKEN_KEY', token);
            useCredentials(name, role, token);
        }

        function useCredentials(name, role, token) {
            username = name;
            isAuthenticated = true;
            authToken = token;
            localrole = role;
            // Set the token as header for your requests!
            $http.defaults.headers.common['X-Auth-Token'] = token;
        }

        function destroyUserCredentials() {
            authToken = undefined;
            username = '';
            localrole = '';
            isAuthenticated = false;
            $http.defaults.headers.common['X-Auth-Token'] = undefined;
            window.localStorage.removeItem('LOCAL_TOKEN_KEY');
            window.localStorage.removeItem('LOCAL_ROLE');
            window.localStorage.removeItem('LOCAL_NAME');
        }

        var login = function(name, pw, role) {
            return $q(function(resolve, reject)
            {
                if (role == USER_ROLES.customer)
                {
                // Make a request and receive your auth token from your server
                    $http({
                        method: 'POST',
                        data: {
                            'login': name,
                            'password': pw
                        },
                        type: 'json',
                        url:  Config.api_host + 'v1/auth/token'
                    }).then(function successCallback(response)
                    {
                        storeUserCredentials(name, role, response.data.token);
                        resolve('Login success.');

                    }, function errorCallback(response)
                    {
                        resolve('Login failed.');
                        
                    });
                }
                if (role == USER_ROLES.admin)
                {
                    $http({
                        method: 'POST',
                        data: {
                            'login': name,
                            'password': pw
                        },
                        type: 'json',
                        url:  Config.api_host + 'admin/v1/auth/token'
                    }).then(function successCallback(response)
                    {
                        storeUserCredentials(name, role, response.data.token);
                        resolve('Login success.');

                    }, function errorCallback(response)
                    {
                        resolve('Login failed.');
                    });
                }
            });
        };

        var logout = function() {
            destroyUserCredentials();
        };

        var isAuthorized = function(authorizedRoles) {
            if (!angular.isArray(authorizedRoles)) {
                authorizedRoles = [authorizedRoles];
            }
            return (isAuthenticated && authorizedRoles.indexOf(localrole) !== -1);
        };

        loadUserCredentials();

        return {
            login: login,
            logout: logout,
            isAuthorized: isAuthorized,
            isAuthenticated: function() {return isAuthenticated;},
            username: function() {return username;},
            role: function() {return localrole;},
            resetPassword: function (email)
            {
                $http({
                    method: 'PUT',
                    data: {
                        'email': email,
                    },
                    type: 'json',
                    url: Config.api_host + 'v1/customer-users/password-reset'
                }).then(function successCallback(response)
                {
                    growl.success('Nowe hasło zostało wysłane na podany adres email', { ttl: 5000});
                    $state.go('login');

                }, function errorCallback(response)
                {
                    growl.error('Wystąpił błąd podczas resetowania hasła', { ttl: 5000});
                });
            },
            apiBaseHref: function ()
            {
                return USER_ROLES.admin == localrole ? Config.api_host + 'admin/v1'  : Config.api_host + 'v1';
            },
            isAdmin: function ()
            {
                if(USER_ROLES.admin == localrole)
                    return true
                return false;
            }
        };
    })

    .factory('AuthInterceptor', function ($rootScope, $q, AUTH_EVENTS, growl) {
        return {
            responseError: function (response) {
                $rootScope.$broadcast({
                    401: AUTH_EVENTS.notAuthenticated,
                    403: AUTH_EVENTS.notAuthorized
                }[response.status], response);

                if(response.status === 500)
                {
                    growl.error("Wystąpił błąd wewnętrzny. Skontaktuj się z administratorem systemu", { ttl: 5000 });
                }

                return $q.reject(response);
            }
        };
    })

    .config(function ($httpProvider) {
        $httpProvider.interceptors.push('AuthInterceptor');
    });
/**
 * INSPINIA - Responsive Admin Theme
 * 2.5
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout) {


  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
    angular.element(".sidebard-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarHeigh = angular.element('nav.navbar-default').height();
    var wrapperHeigh = angular.element('#page-wrapper').height();

    if(navbarHeigh > wrapperHeigh){
      angular.element('#page-wrapper').css("min-height", navbarHeigh + "px");
    }

    if(navbarHeigh < wrapperHeigh){
      angular.element('#page-wrapper').css("min-height", angular.element(window).height()  + "px");
    }

    if (angular.element('body').hasClass('fixed-nav')) {
      if (navbarHeigh > wrapperHeigh) {
        angular.element('#page-wrapper').css("min-height", navbarHeigh - 60 + "px");
      } else {
        angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
      }
    }

  }

  angular.element(window).bind("load resize scroll", function() {
    if(!angular.element("body").hasClass('body-small')) {
      fix_height();
    }
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function(){
    if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav') ) {
      angular.element('#right-sidebar').addClass('sidebar-top');
    } else {
      angular.element('#right-sidebar').removeClass('sidebar-top');
    }
  });

  $timeout(function(){
    fix_height();
  });

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function() {
    if (angular.element(document).width() < 769) {
      angular.element('body').addClass('body-small')
    } else {
      angular.element('body').removeClass('body-small')
    }
  })

});


(function() {
  'use strict';

  angular
    .module('inspinia')
    .run(runBlock)

  /** @ngInject */
  function runBlock($log, $rootScope, $state, AuthService, AUTH_EVENTS, DTDefaultOptions, Config) {


    console.log(Config.api_host) // http://api.host.com
    $rootScope.$on('$stateChangeStart', function (event, next, nextParams, fromState)
    {
      if (!AuthService.isAuthenticated())
      {
        if (next.name !== 'login' && next.name !== 'login-admin' && next.name !== 'password-reset')
        {
          event.preventDefault();
          if(fromState.name === 'login-admin')
            $state.go('login-admin');
          else
            $state.go('login');
        }
      }

      if ('data' in next && 'authorizedRoles' in next.data) {
        var authorizedRoles = next.data.authorizedRoles;
        if (!AuthService.isAuthorized(authorizedRoles)) {
          event.preventDefault();
          $state.go($state.current, {}, {reload: true});
          $rootScope.$broadcast(AUTH_EVENTS.notAuthorized);
        }
      }
      
    });

    DTDefaultOptions.setLanguageSource('assets/i18n/datatablesPolish.json');

    $log.debug('runBlock end');
  }

})();

(function() {
    'use strict';

    angular
        .module('inspinia')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider, USER_ROLES, $ocLazyLoadProvider) {
        $ocLazyLoadProvider.config({
            // Set to true if you want to see what and when is dynamically loaded
            debug: false
        });

        $stateProvider
            .state('login', {
                url: "/login",
                templateUrl: "app/login/login.html"
            })

            .state('login-admin', {
                url: "/admin/login",
                templateUrl: "app/login/admin.login.html"
            })

            .state('password-reset', {
                url: "/password/reset",
                templateUrl: "app/login/password.html"
            })

            .state('index', {
                abstract: true,
                url: "/index",
                templateUrl: "app/components/common/content.html",
            })
            .state('index.main', {
                url: "/main",
                templateUrl: "app/main/main.html",
                data: { pageTitle: 'Example view' }
            })
            .state('index.panel', {
                url: "/panel",
                templateUrl: "app/panel/panel.html",
                data: { pageTitle: 'Panel' }
            })
            .state('index.customer-users', {
                url: "/customer/:c_id/users",
                templateUrl: "app/customer-users/users.html",
                data: { pageTitle: 'Użytkownicy', authorizedRoles: [USER_ROLES.admin] }
            })
            .state('index.customer-users-add', {
                url: "/customer/:c_id/user-add",
                templateUrl: "app/customer-users/add.html",
                data: { pageTitle: 'Dodawanie uzytkowników', authorizedRoles: [USER_ROLES.admin] }
            })
            .state('index.customer-users-edit', {
                url: "/customer/:c_id/user-edit/:id",
                templateUrl: "app/customer-users/edit.html",
                data: { pageTitle: 'Edycja uzytkowników', authorizedRoles: [USER_ROLES.admin] },
            })
            .state('index.auditors', {
                url: "/auditors",
                templateUrl: "app/auditors/auditors.html",
                data: { pageTitle: 'Aydytorzy', authorizedRoles: [USER_ROLES.admin] }
            })
            .state('index.auditors-add', {
                url: "/auditor-add",
                templateUrl: "app/auditors/add.html",
                data: { pageTitle: 'Dodawanie audytorów', authorizedRoles: [USER_ROLES.admin] }
            })
            .state('index.auditors-edit', {
                url: "auditor-edit/:id",
                templateUrl: "app/auditors/edit.html",
                data: { pageTitle: 'Edycja audytorów', authorizedRoles: [USER_ROLES.admin] },
            })
            .state('index.campaigns', {
                url: "/campaigns",
                templateUrl: "app/campaigns/campaign.html",
                data: { pageTitle: 'Kampanie' }
            })
            .state('index.campaignEdit', {
                url: "/campaign/edit/:id",
                templateUrl: "app/campaigns/campaign-edit.html",
                data: { pageTitle: 'Edycja kampanii', authorizedRoles: [USER_ROLES.admin] }
            })
            .state('index.campaignAdd', {
                url: "/campaign/add",
                templateUrl: "app/campaigns/campaign-add.html",
                data: { pageTitle: 'Dodawanie kampanii', authorizedRoles: [USER_ROLES.admin] }
            })
            .state('index.customers', {
                url: "/customers",
                templateUrl: "app/customers/customers.html",
                data: { pageTitle: 'Klienci' }
            })
            .state('index.customers-add', {
                url: "/customer-add",
                templateUrl: "app/customers/add.html",
                data: { pageTitle: 'Dodawanie klientów' }
            })
            .state('index.customers-edit', {
                url: "/customer-edit/:id",
                templateUrl: "app/customers/edit.html",
                data: { pageTitle: 'Edycja klientów' },
                controller: 'EditCustomersController'
            })
            .state('index.routes', {
                url: "/campaign/:id/routes",
                templateUrl: "app/routes/routes.html",
                data: { pageTitle: 'Audyty' }
            })
            .state('index.routes_search', {
                url: "/routes-search",
                templateUrl: "app/routes/routes-search.html",
                data: { pageTitle: 'Audyty2', authorizedRoles: [USER_ROLES.admin] }
            })
            .state('index.routes_history', {
                url: "/routes-history",
                templateUrl: "app/routes/routes-history.html",
                data: { pageTitle: 'Historia', authorizedRoles: [USER_ROLES.admin] }
            })
            .state('index.routesCustomer', {
                url: "/campaign/:id/routes",
                templateUrl: "app/routes/routes.html",
                data: { pageTitle: 'Audyty' }
            })
            .state('index.routeAdd', {
                url: "/campaign/:id/route/add",
                templateUrl: "app/routes/route-add.html",
                data: { pageTitle: 'Dodaj trasę', authorizedRoles: [USER_ROLES.admin] }
            }).state('index.routeEdit', {
                url: "/campaign/:id/route/edit/:r_id",
                templateUrl: "app/routes/route-edit.html",
                data: { pageTitle: 'Edytuj trasę', authorizedRoles: [USER_ROLES.admin] }
            })
            .state('index.route-view', {
                url: "/route/:id/view",
                templateUrl: "app/routes/route-view.html",
                data: { pageTitle: 'Podgląd Audyty' }
            })
            .state('index.surveys', {
                url: "/surveys",
                templateUrl: "app/surveys/surveys.html",
                data: { pageTitle: 'Ankiety' }
            })
            .state('index.reports', {
                url: "/reports",
                templateUrl: "app/reports/reports.html",
                data: { pageTitle: 'Raporty' }
            });

        $urlRouterProvider.otherwise(function ($injector, $location) {
            var $state = $injector.get("$state");
            $state.go("login");
        });
    }

})();

'use strict';

//Directive used to set metisMenu and minimalize button
angular.module('inspinia')
    .directive('sideNavigation', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                // Call metsi to build when user signup
                scope.$watch('authentication.user', function() {
                    $timeout(function() {
                        element.metisMenu();
                    });
                });

            }
        };
    })
    .directive('minimalizaSidebar', function ($timeout) {
        return {
            restrict: 'A',
            template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
            controller: function ($scope) {
                $scope.minimalize = function () {
                    angular.element('body').toggleClass('mini-navbar');
                    if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                        // Hide menu in order to smoothly turn on when maximize menu
                        angular.element('#side-menu').hide();
                        // For smoothly turn on menu
                        $timeout(function () {
                            angular.element('#side-menu').fadeIn(400);
                        }, 200);
                    } else {
                        // Remove all inline style from jquery fadeIn function to reset menu state
                        angular.element('#side-menu').removeAttr('style');
                    }
                };
            }
        };
    }).directive("fileread", [function () {
    return {
        scope: {
            fileread: "="
        },
        link: function (scope, element, attributes) {
            element.bind("change", function (changeEvent) {
                var reader = new FileReader();
                reader.onload = function (loadEvent) {
                    scope.$apply(function () {
                        scope.fileread = loadEvent.target.result;
                    });
                }
                reader.readAsDataURL(changeEvent.target.files[0]);
            });
        }
    }
}]);



angular.module('inspinia')
    .service('Config', function() {
            return {
                api_host: "https://apipam.audytymarketingowe.pl/"
            };
    }
);

angular.module("inspinia").run(["$templateCache", function($templateCache) {$templateCache.put("app/auditors/add.html","<div class=\"wrapper wrapper-content animated fadeInRight\" ng-controller=\"AddAuditorController as addAuditor\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Dodaj audytora</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.main\">Panel</a></li><li><a ui-sref=\"index.auditors\">Audytorzy</a></li><li class=\"active\"><strong>Dodaj Audytora</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Dodawanie Audytorów</h5></div><div class=\"ibox-content\"><form class=\"form-horizontal\" name=\"addAuditor.form_auditor\" ng-submit=\"addAuditor.saveAuditor(form)\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Email</label><div class=\"col-lg-10\"><input type=\"email\" ng-model=\"form.email\" name=\"email\" required=\"\" placeholder=\"Email\" class=\"form-control\"> <span class=\"help-block m-b-none\"></span></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Imię</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"form.name\" name=\"name\" placeholder=\"Imię\" required=\"\" class=\"form-control\"> <span class=\"help-block m-b-none\"></span></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nazwisko</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"form.surname\" name=\"surname\" placeholder=\"Nazwisko\" required=\"\" class=\"form-control\"> <span class=\"help-block m-b-none\"></span></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Telefon</label><div class=\"col-lg-10\"><input type=\"number\" ng-model=\"form.phone\" name=\"phone\" placeholder=\"Telefon\" required=\"\" class=\"form-control\"> <span class=\"help-block m-b-none\"></span></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Ulica</label><div class=\"col-sm-10\"><input class=\"form-control m-b\" type=\"text\" placeholder=\"Ulica\" ng-required=\"true\" ng-model=\"form.address.street\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Numer budynku</label><div class=\"col-sm-10\"><input class=\"form-control m-b\" type=\"text\" placeholder=\"Numer budynku\" ng-required=\"true\" ng-model=\"form.address.building_number\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Miasto</label><div class=\"col-sm-10\"><input class=\"form-control m-b\" type=\"text\" placeholder=\"Miasto\" ng-required=\"true\" ng-model=\"form.address.city\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Kod-pocztowy:</label><div class=\"col-sm-10\"><input class=\"form-control m-b\" type=\"text\" placeholder=\"Kod pocztowy\" ng-required=\"true\" pattern=\"[0-9]{2}-[0-9]{3}\" ng-model=\"form.address.post_code\"></div></div><div class=\"form-group\"><div class=\"col-lg-offset-2 col-lg-10\"><button class=\"btn btn-sm btn-white\" type=\"submit\">Zapisz</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/auditors/auditors.html","<div class=\"wrapper wrapper-content animated fadeInRight\" ng-controller=\"AuditorsController as auditor\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Audytorzy</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.main\">Panel</a></li><li class=\"active\"><strong>Audytorzy</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><table datatable=\"ng\" dt-column-defs=\"auditor.dtColumnDefs\" dt-instance=\"auditor.dtInstance\" dt-options=\"auditor.dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th ng-hide=\"!main.isAdmin()\">id</th><th>Email</th><th>Imię</th><th>Nazwisko</th><th>Telefon</th><th>Akcje</th></tr></thead><tbody><tr ng-repeat=\"aud in auditor.auditors\"><td ng-hide=\"!main.isAdmin()\">{{ aud.id }}</td><td>{{ aud.email }}</td><td>{{ aud.first_name }}</td><td>{{ aud.last_name }}</td><td>{{ aud.phone }}</td><td><button class=\"btn btn-xs btn-primary\" ng-click=\"auditor.editAuditor(aud)\"><i class=\"fa fa-edit\"></i></button> <button class=\"btn btn-xs btn-warning\" data-toggle=\"modal\" data-target=\"#changePwdModal\" ng-click=\"auditor.changePasswordModal(true, aud)\"><i class=\"fa fa-key\"></i></button> <button class=\"btn btn-xs btn-danger\" data-toggle=\"modal\" data-target=\"#deleteModal\" ng-click=\"auditor.sendParamsToModal(true, aud)\"><i class=\"fa fa-trash-o\"></i></button></td></tr></tbody></table></div></div></div><div class=\"modal inmodal fade in\" id=\"deleteModal\" aria-hidden=\"true\" ng-show=\"auditor.showModal\" style=\"display: block; padding-right: 15px;\"><div class=\"modal-dialog modal-sm\"><div class=\"modal-content animated bounceInRight\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\">&times;</button> <b>Kasowanie audytora</b></div><div class=\"modal-body\"><strong>Czy aby na pewno chcesz skasować audytora: {{auditor.audEmail}}?</strong></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" data-dismiss=\"modal\">Cofnij</button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"auditor.deleteAuditor(auditor.audId)\">Skasuj Audytora</button></div></div></div></div><div class=\"modal inmodal fade in\" id=\"changePwdModal\" aria-hidden=\"true\" ng-show=\"auditor.showModalPassword\" style=\"display: block; padding-right: 15px;\"><div class=\"modal-dialog\"><div class=\"modal-content animated bounceInRight\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\">&times;</button> <b>Zmiana hasła</b></div><div class=\"modal-body\"><strong>Podaj nowe hasło. Hasło powinno zawierać co najmniej 8 znaków w tym jedną dużą i małą literę oraz jedną cyfrę.</strong> W przypadku pozostawienia pola pustego hasło zostanie wygenerowane automatycznie i wysłane na adres email Audytora.<br><strong>Wprowadź hasło</strong> <input type=\"password\" ng-model=\"auditor.password\" class=\"form-control\" pattern=\".{0}|.{8,}\" title=\"Puste pole lub 8 znaków(Jedna duża litera i cyfra)!\"> <strong>Potwierdź hasło</strong> <input type=\"password\" ng-model=\"auditor.checkPassword\" class=\"form-control\" pattern=\".{0}|.{8,}\" title=\"Wpisz ponownie te same hasło\"> <strong ng-if=\"(auditor.password.length == auditor.checkPassword.length) && (auditor.password.length < 8 && auditor.password.length > 0)\" style=\"color: red;\">Hasło jest zbyt krótkie!</strong> <strong ng-if=\"(auditor.password != auditor.checkPassword) && (auditor.password.length == auditor.checkPassword.length) && (auditor.password.length >= 8)\" style=\"color: red;\">Wprowadzone hasła nie są takie same!</strong></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" data-dismiss=\"modal\">Cofnij</button> <button ng-if=\"(auditor.password == auditor.checkPassword) && (auditor.password.length >= 8 || auditor.password.length == undefined || auditor.password.length == 0)\" data-dismiss=\"modal\" type=\"button\" class=\"btn btn-primary\" ng-click=\"auditor.changePassword(auditor)\">Zmień hasło</button> <button ng-if=\"(auditor.password != auditor.checkPassword) || (auditor.password.length > 0 && auditor.password.length < 8)\" type=\"button\" class=\"btn btn-primary\" disabled=\"true\">Zmień hasło</button></div></div></div></div><button ng-click=\"auditor.addAuditor()\" class=\"btn btn-warning\" name=\"add\">Dodaj</button></div>");
$templateCache.put("app/auditors/edit.html","<div class=\"wrapper wrapper-content animated fadeInRight\" ng-controller=\"EditAuditorController as editAuditor\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Edytuj Audytora</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.main\">Panel</a></li><li><a ui-sref=\"index.auditors\">Audytorzy</a></li><li class=\"active\"><strong>Edytuj Audytora</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Edycja użytkowników</h5></div><div class=\"ibox-content\"><form class=\"form-horizontal\" name=\"editAuditor.form_auditor\" ng-submit=\"editAuditor.saveAuditor()\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Email</label><div class=\"col-lg-10\"><input type=\"email\" ng-model=\"editAuditor.form.email\" name=\"email\" required=\"\" placeholder=\"Email\" class=\"form-control\"> <span class=\"help-block m-b-none\"></span></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Imię</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"editAuditor.form.last_name\" name=\"name\" placeholder=\"Imię\" required=\"\" class=\"form-control\"> <span class=\"help-block m-b-none\"></span></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nazwisko</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"editAuditor.form.first_name\" name=\"surname\" placeholder=\"Nazwisko\" required=\"\" class=\"form-control\"> <span class=\"help-block m-b-none\"></span></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Telefon</label><div class=\"col-lg-10\"><input type=\"number\" ng-model=\"editAuditor.form.phone\" name=\"surname\" placeholder=\"Telefon\" required=\"\" class=\"form-control\"> <span class=\"help-block m-b-none\"></span></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Ulica</label><div class=\"col-sm-10\"><input class=\"form-control m-b\" type=\"text\" placeholder=\"Ulica\" ng-model=\"editAuditor.form.address.street\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Numer budynku</label><div class=\"col-sm-10\"><input class=\"form-control m-b\" type=\"text\" placeholder=\"Numer budynku\" ng-model=\"editAuditor.form.address.building_number\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Miasto</label><div class=\"col-sm-10\"><input class=\"form-control m-b\" placeholder=\"Miasto\" type=\"text\" ng-required=\"true\" ng-model=\"editAuditor.form.address.city\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Kod-pocztowy:</label><div class=\"col-sm-10\"><input class=\"form-control m-b\" placeholder=\"Kod pocztowy\" type=\"text\" ng-required=\"true\" pattern=\"[0-9]{2}-[0-9]{3}\" ng-model=\"editAuditor.form.address.post_code\"></div></div><div class=\"form-group\"><div class=\"col-lg-offset-2 col-lg-10\"><button class=\"btn btn-sm btn-white\" type=\"submit\">Zapisz</button></div></div></form></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Logo aplikacji</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-8\"><form name=\"importForm\" method=\"post\" class=\"form-horizontal ng-pristine ng-valid\" enctype=\"multipart/form-data\" ng-submit=\"editAuditor.importMobileLogo()\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Logo aplikacji</label><div class=\"col-sm-10\"><input class=\"form-control m-b\" type=\"file\" name=\"mobileLogo\" fileread=\"mobileLogo\"></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><div class=\"col-sm-4 col-sm-offset-2\"><button class=\"btn btn-sm btn-white\" type=\"submit\">Zapisz</button></div></div></form><button class=\"btn btn-sm btn-info pull-right\" ng-click=\"editAuditor.deleteMobileLogo()\">Przywróć domyślne</button></div><div class=\"col-lg-4\"><img src=\"{{ editAuditor.form.photo }}\" class=\"col-xs-12\"></div></div></div></div></div></div></div>");
$templateCache.put("app/campaigns/campaign-add.html","<div class=\"wrapper wrapper-content animated fadeInRight\" ng-controller=\"CampaignAddController as CampaingAdd\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Dodaj kampanię</h5></div><div class=\"ibox-content\"><form name=\"new_campaign_form\" method=\"get\" class=\"form-horizontal ng-pristine ng-valid\" novalidate=\"\" ng-submit=\"new_campaign_form.$valid && CampaingAdd.addCampaign(CampaingAdd.newCampaign)\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Nazwa</label><div class=\"col-sm-10\"><input class=\"form-control m-b\" ng-required=\"true\" ng-model=\"CampaingAdd.newCampaign.name\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Klient</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-options=\"c.name for c in CampaingAdd.customers\" ng-required=\"true\" ng-model=\"CampaingAdd.newCampaign.customer\"></select></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><div class=\"col-sm-4 col-sm-offset-2\"><button class=\"btn btn-white\" ui-sref=\"index.campaigns\">Anuluj</button> <input type=\"submit\" class=\"btn btn-primary\"></div></div></form></div></div></div></div></div></div></div></div>");
$templateCache.put("app/campaigns/campaign-edit.html","<div class=\"wrapper wrapper-content animated fadeInRight\" ng-controller=\"CampaignEditController as CampaignEdit\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Edytuj kampanię</h5></div><div class=\"ibox-content\"><form name=\"edit_campaign_form\" method=\"get\" class=\"form-horizontal ng-pristine ng-valid\" novalidate=\"\" ng-submit=\"edit_campaign_form.$valid && CampaignEdit.editCampaign()\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Nazwa</label><div class=\"col-sm-10\"><input class=\"form-control m-b\" ng-required=\"true\" ng-model=\"CampaignEdit.campaign.name\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Klient</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-options=\"c.id as c.name for c in CampaignEdit.customers\" ng-required=\"true\" ng-model=\"CampaignEdit.campaign.customer\"></select></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><div class=\"col-sm-4 col-sm-offset-2\"><button class=\"btn btn-white\" ui-sref=\"index.campaigns\">Anuluj</button> <input type=\"submit\" class=\"btn btn-primary\"></div></div></form></div></div></div></div></div></div></div></div>");
$templateCache.put("app/campaigns/campaign.html","<div class=\"wrapper wrapper-content animated fadeInRight\" ng-controller=\"CampaignController as campaignCtrl\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Kampanie</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.main\">Panel</a></li><li class=\"active\"><strong>Kampanie</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><table datatable=\"ng\" id=\"campaignTable\" dt-instance=\"campaignCtrl.dtInstance\" dt-options=\"campaignCtrl.dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th ng-hide=\"!main.isAdmin()\">ID</th><th>Nazwa</th><th>Klient</th><th>Zakończone audyty</th><th>Skuteczne audyty</th><th class=\"noExport\">Akcje</th></tr></thead><tbody><tr ng-repeat=\"c in data.campaigns track by $index\"><td ng-hide=\"!main.isAdmin()\">{{ c.id }}</td><td>{{ c.name }}</td><td>{{ c.customer.name }} {{ r.auditor.last_name }}</td><td>{{ c.trace_finished_count }} z {{ c.trace_count }} - {{ ( c.trace_count == 0 ? 0 :((c.trace_finished_count*100)/c.trace_count)).toFixed(0) }}%</td><td>{{ c.trace_effectiveness_count }} z {{ c.trace_count }} - {{ ( c.trace_count == 0 ? 0 :((c.trace_effectiveness_count*100)/c.trace_count)).toFixed(0) }}%</td><td class=\"noExport\"><a class=\"btn btn-xs btn-primary\" ui-sref=\"index.routes({id: c.id})\"><i class=\"fa fa-eye\"></i></a> <a ng-if=\"main.isAdmin()\" class=\"btn btn-xs btn-primary\" ui-sref=\"index.campaignEdit({id: c.id})\"><i class=\"fa fa-edit\"></i></a> <button ng-if=\"main.isAdmin()\" class=\"btn btn-xs btn-danger\" data-toggle=\"modal\" data-target=\"#deleteModal\" ng-click=\"campaignCtrl.sendParamsToDelModal(true, c)\"><i class=\"fa fa-trash-o\"></i></button></td></tr></tbody></table></div></div><div class=\"modal inmodal fade in\" aria-hidden=\"true\" ng-show=\"campaignCtrl.showDeleteModal\" id=\"deleteModal\" style=\"display: block; padding-right: 15px;\"><div class=\"modal-dialog\"><div class=\"modal-content animated bounceInRight\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\">&times;</button> <b>Kasowanie</b></div><div class=\"modal-body\"><strong>Czy aby na pewno chcesz skasować Kampanię: {{campaignCtrl.campaignName}} ?<p style=\"color:red\">Skasowanie Kampanii spowoduje usunięcie wszystkich audytów do niej przypisanych.</p></strong></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" data-dismiss=\"modal\">Zamknij</button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"campaignCtrl.deleteCampaign(campaignCtrl.cId)\">Skasuj kampanie</button></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><button ng-if=\"main.isAdmin()\" class=\"btn btn-info\" ui-sref=\"index.campaignAdd\">Dodaj</button></div></div></div>");
$templateCache.put("app/customer-users/add.html","<div class=\"wrapper wrapper-content animated fadeInRight\" ng-controller=\"AddUserController as add\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Dodaj użytkownika</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.main\">Panel</a></li><li><a ui-sref=\"index.customers\">Klienci</a></li><li><a ui-sref=\"index.customer-users({c_id: add.customer_id})\">Uzytkownicy klienta</a></li><li class=\"active\"><strong>Dodaj użytkownika</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Dodawanie użytkowników</h5></div><div class=\"ibox-content\"><form class=\"form-horizontal\" name=\"add.form_user\" ng-submit=\"add.saveUser(form)\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Email</label><div class=\"col-lg-10\"><input type=\"email\" ng-model=\"form.email\" name=\"email\" required=\"\" placeholder=\"Email\" class=\"form-control\"> <span class=\"help-block m-b-none\"></span></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Imię</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"form.name\" name=\"name\" placeholder=\"Imię\" required=\"\" class=\"form-control\"> <span class=\"help-block m-b-none\"></span></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nazwisko</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"form.surname\" name=\"surname\" placeholder=\"Nazwisko\" required=\"\" class=\"form-control\"> <span class=\"help-block m-b-none\"></span></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Telefon</label><div class=\"col-lg-10\"><input type=\"number\" ng-model=\"form.phone\" name=\"phone\" placeholder=\"Telefon\" required=\"\" class=\"form-control\"> <span class=\"help-block m-b-none\"></span></div></div><div class=\"form-group\"><div class=\"col-lg-offset-2 col-lg-10\"><button class=\"btn btn-sm btn-white\" type=\"submit\">Zapisz</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/customer-users/edit.html","<div class=\"wrapper wrapper-content animated fadeInRight\" ng-controller=\"EditUserController as edit\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Edytuj użytkownika</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.main\">Panel</a></li><li><a ui-sref=\"index.customers\">Klienci</a></li><li><a ui-sref=\"index.customer-users({c_id: edit.customer_id})\">Użytkownicy klienta</a></li><li class=\"active\"><strong>Edytuj użytkownika</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Edycja użytkowników</h5></div><div class=\"ibox-content\"><form class=\"form-horizontal\" name=\"edit.form_user\" ng-submit=\"edit.saveUser()\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Email</label><div class=\"col-lg-10\"><input type=\"email\" ng-model=\"edit.form.email\" name=\"email\" required=\"\" placeholder=\"Email\" class=\"form-control\"> <span class=\"help-block m-b-none\"></span></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Imię</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"edit.form.last_name\" name=\"name\" placeholder=\"Imię\" required=\"\" class=\"form-control\"> <span class=\"help-block m-b-none\"></span></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nazwisko</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"edit.form.first_name\" name=\"surname\" placeholder=\"Nazwisko\" required=\"\" class=\"form-control\"> <span class=\"help-block m-b-none\"></span></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Telefon</label><div class=\"col-lg-10\"><input type=\"number\" ng-model=\"edit.form.phone\" name=\"surname\" placeholder=\"Telefon\" required=\"\" class=\"form-control\"> <span class=\"help-block m-b-none\"></span></div></div><div class=\"form-group\"><div class=\"col-lg-offset-2 col-lg-10\"><button class=\"btn btn-sm btn-white\" type=\"submit\">Zapisz</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/customer-users/users.html","<div class=\"wrapper wrapper-content animated fadeInRight\" ng-controller=\"UsersController as usr\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Użytkownicy</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.main\">Panel</a></li><li><a ui-sref=\"index.customers\">Klienci</a></li><li class=\"active\"><strong>Użytkownicy klienta</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"table-responsive\"><table datatable=\"ng\" dt-column-defs=\"usr.dtColumnDefs\" dt-instance=\"usr.dtInstance\" dt-options=\"usr.dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th ng-hide=\"!main.isAdmin()\">id</th><th>Klient</th><th>Email</th><th>Imię</th><th>Nazwisko</th><th>Telefon</th><th>Rola</th><th>Akcje</th></tr></thead><tbody><tr ng-repeat=\"user in usr.users\"><td ng-hide=\"!main.isAdmin()\">{{ user.id }}</td><td>{{ user.customer.name }}</td><td>{{ user.email }}</td><td>{{ user.first_name }}</td><td>{{ user.last_name }}</td><td>{{ user.phone }}</td><td>{{ user.role }}</td><td><button class=\"btn btn-xs btn-warning\" ng-click=\"usr.editUser(user)\"><i class=\"fa fa-edit\"></i></button> <button class=\"btn btn-xs btn-warning\" data-toggle=\"modal\" data-target=\"#changePwdModal\" ng-click=\"usr.changePasswordModal(true, user)\"><i class=\"fa fa-key\"></i></button> <button class=\"btn btn-xs btn-danger\" ng-click=\"usr.deleteUser($index)\"><i class=\"fa fa-trash-o\"></i></button></td></tr></tbody></table><button ng-click=\"usr.addUser()\" class=\"btn btn-warning\" name=\"add\">Dodaj</button></div></div></div></div></div><div class=\"modal inmodal fade in\" aria-hidden=\"true\" id=\"changePwdModal\" ng-show=\"usr.showModalPassword\" style=\"display: block; padding-right: 15px;\"><div class=\"modal-dialog modal-sm\"><div class=\"modal-content animated bounceInRight\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\">&times;</button> <b>Zmiana hasła</b></div><div class=\"modal-body\"><strong>Podaj nowe hasło. Hasło powinno zawierać co najmniej 8 znaków w tym jedną dużą i małą literę oraz jedną cyfrę.</strong> W przypadku pozostawienia pola pustego hasło zostanie wygenerowane automatycznie i wysłane na adres email klienta.<br><strong>Wprowadź hasło</strong> <input type=\"password\" ng-model=\"usr.password\" class=\"form-control\" pattern=\".{0}|.{8,}\" title=\"Puste pole lub 8 znaków(Jedna duża litera i cyfra)!\"> <strong>Potwierdź hasło</strong> <input type=\"password\" ng-model=\"usr.checkPassword\" class=\"form-control\" pattern=\".{0}|.{8,}\" title=\"Wpisz ponownie te same hasło\"> <strong ng-if=\"(usr.password.length == usr.checkPassword.length) && (usr.password.length < 8 && usr.password.length > 0)\" style=\"color: red;\">Hasło jest zbyt krótkie!</strong> <strong ng-if=\"(usr.password != usr.checkPassword) && (usr.password.length == usr.checkPassword.length) && (usr.password.length >= 8)\" style=\"color: red;\">Wprowadzone hasła nie są takie same!</strong></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" data-dismiss=\"modal\" ng-click=\"usr.modalPassword(false)\">Cofnij</button> <button ng-if=\"(usr.password == usr.checkPassword) && (usr.password.length >= 8 || usr.password.length == undefined || usr.password.length == 0)\" data-dismiss=\"modal\" type=\"button\" class=\"btn btn-primary\" ng-click=\"usr.changePassword(usr)\">Zmień hasło</button> <button ng-if=\"(usr.password != usr.checkPassword) || (usr.password.length > 0 && usr.password.length < 8)\" type=\"button\" class=\"btn btn-primary\" disabled=\"true\">Zmień hasło</button></div></div></div></div></div>");
$templateCache.put("app/customers/add.html","<div class=\"wrapper wrapper-content animated fadeInRight\" ng-controller=\"AddCustomerController as add\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Dodaj klienta</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.main\">Panel</a></li><li><a ui-sref=\"index.customers\">Klienci</a></li><li class=\"active\"><strong>Dodaj klienta</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Dodawanie klientów</h5><div class=\"ibox-tools\"><a class=\"collapse-link\"><i class=\"fa fa-chevron-up\"></i></a> <a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"#\"><i class=\"fa fa-wrench\"></i></a> <a class=\"close-link\"><i class=\"fa fa-times\"></i></a></div></div><div class=\"ibox-content\"><form class=\"form-horizontal\" name=\"form_customer\" ng-submit=\"addCustomer(newCustomer)\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Nazwa klienta</label><div class=\"col-sm-10\"><input class=\"form-control m-b\" type=\"text\" ng-required=\"true\" ng-model=\"newCustomer.name\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Email</label><div class=\"col-sm-10\"><input class=\"form-control m-b\" type=\"email\" ng-required=\"true\" ng-model=\"newCustomer.email\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Telefon</label><div class=\"col-sm-10\"><input class=\"form-control m-b\" type=\"text\" ng-required=\"true\" ng-model=\"newCustomer.phone\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Ulica</label><div class=\"col-sm-10\"><input class=\"form-control m-b\" type=\"text\" ng-required=\"true\" ng-model=\"newCustomer.address.street\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Miasto</label><div class=\"col-sm-10\"><input class=\"form-control m-b\" type=\"text\" ng-required=\"true\" ng-model=\"newCustomer.address.city\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Kod-pocztowy:</label><div class=\"col-sm-10\"><input class=\"form-control m-b\" type=\"text\" ng-required=\"true\" pattern=\"[0-9]{2}-[0-9]{3}\" ng-model=\"newCustomer.address.postCode\"></div></div><div class=\"form-group\"><div class=\"col-sm-4 col-sm-offset-2\"><button class=\"btn btn-white\" ui-sref=\"index.customers\">Anuluj</button> <input type=\"submit\" class=\"btn btn-primary\"></div></div></form></div></div></div></div></div>");
$templateCache.put("app/customers/customers.html","<div class=\"wrapper wrapper-content animated fadeInRight\" ng-controller=\"CustomersController as cust\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Klienci</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.main\">Panel</a></li><li class=\"active\"><strong>Klienci</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><table datatable=\"ng\" dt-column-defs=\"dtColumnDefs\" dt-instance=\"dtInstance\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th ng-hide=\"!main.isAdmin()\">id</th><th>Nazwa Klienta</th><th>Email</th><th>Telefon</th><th>Adres</th><th>Akcje</th></tr></thead><tbody><tr ng-repeat=\"customer in data.customers\"><td ng-hide=\"!main.isAdmin()\">{{ customer.id }}</td><td>{{ customer.name }}</td><td>{{ customer.email }}</td><td>{{ customer.phone }}</td><td>{{ customer.address.street }}, {{ customer.address.city }}, {{customer.address.post_code}}</td><td><div class=\"text-center\"><button class=\"btn btn-xs btn-warning\" ng-click=\"editCustomer(customer)\"><i class=\"fa fa-edit\"></i></button> <button class=\"btn btn-xs btn-primary\" ng-click=\"showUsers(customer)\"><i class=\"fa fa-users\"></i></button> <button class=\"btn btn-xs btn-danger\" data-toggle=\"modal\" data-target=\"#deleteModal\" ng-click=\"sendParamsToModal(true,customer)\"><i class=\"fa fa-trash-o\"></i></button></div></td></tr></tbody></table></div></div></div><div class=\"modal inmodal fade in\" id=\"deleteModal\" aria-hidden=\"true\" ng-show=\"showModal\" style=\"display: block; padding-right: 15px;\"><div class=\"modal-dialog modal-sm\"><div class=\"modal-content animated bounceInRight\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\">&times;</button> <b>Kasowanie klienta</b></div><div class=\"modal-body\"><strong>Czy aby na pewno chcesz skasować klienta {{customerName}}?</strong></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" data-dismiss=\"modal\">Cofnij</button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"deleteCustomer(customerID)\">Skasuj klienta</button></div></div></div></div><div class=\"col-lg-12\"><button class=\"btn btn-info\" ui-sref=\"index.customers-add\">Dodaj</button></div></div>");
$templateCache.put("app/customers/edit.html","<div class=\"wrapper wrapper-content animated fadeInRight\" ng-controller=\"EditCustomersController as edit\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Edytuj klienta</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.main\">Panel</a></li><li><a ui-sref=\"index.customers\">Klienci</a></li><li class=\"active\"><strong>Edytuj klienta</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Edycja klientów</h5><div class=\"ibox-tools\"><a class=\"collapse-link\"><i class=\"fa fa-chevron-up\"></i></a> <a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"#\"><i class=\"fa fa-wrench\"></i></a> <a class=\"close-link\"><i class=\"fa fa-times\"></i></a></div></div><div class=\"ibox-content\"><form class=\"form-horizontal\" name=\"edit.form_customer\" ng-submit=\"edit.saveCustomer()\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nazwa klienta</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"edit.form.name\" name=\"name\" placeholder=\"Nazwa klienta\" required=\"\" class=\"form-control\"> <span class=\"help-block m-b-none\"></span></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Email</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"edit.form.email\" name=\"email\" placeholder=\"Email\" required=\"\" class=\"form-control\"> <span class=\"help-block m-b-none\"></span></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Telefon</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"edit.form.phone\" name=\"phone\" placeholder=\"Telefon\" required=\"\" class=\"form-control\"> <span class=\"help-block m-b-none\"></span></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Ulica</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"edit.form.address.street\" name=\"street\" placeholder=\"Ulica\" required=\"\" class=\"form-control\"> <span class=\"help-block m-b-none\"></span></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Miasto</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"edit.form.address.city\" name=\"city\" placeholder=\"Miasto\" required=\"\" class=\"form-control\"> <span class=\"help-block m-b-none\"></span></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Kod pocztowy</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"edit.form.address.post_code\" name=\"postCode\" placeholder=\"Kod pocztowy\" required=\"\" class=\"form-control\"> <span class=\"help-block m-b-none\"></span></div></div><div class=\"form-group\"><div class=\"col-lg-offset-2 col-lg-10\"><button class=\"btn btn-sm btn-white\" type=\"submit\">Zapisz</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/login/admin.login.html","<div class=\"middle-box text-center loginscreen animated fadeInDown\" ng-controller=\"AdminLoginController as alogin\"><div><div><h1 class=\"logo-name\" style=\"font-size: 145px\">PAM</h1></div><p>Logowanie do systemu</p><form class=\"m-t\" role=\"form\" ng-submit=\"login()\" autocomplete=\"on\"><div class=\"form-group\"><input type=\"email\" class=\"form-control\" placeholder=\"Adres email\" required=\"\" ng-model=\"loginForm.email\"></div><div class=\"form-group\"><input type=\"password\" class=\"form-control\" placeholder=\"Hasło\" required=\"\" ng-model=\"loginForm.password\"></div><button type=\"submit\" class=\"btn btn-primary block full-width m-b\">Zaloguj</button></form><p class=\"m-t\"><small>Profesjonalne Audyty Marketingowe Sp.z o.o</small></p></div></div>");
$templateCache.put("app/login/login.html","<div class=\"middle-box text-center loginscreen animated fadeInDown\" ng-controller=\"LoginController as login\"><div><div><h1 class=\"logo-name\" style=\"font-size: 145px\">PAM</h1></div><p>Logowanie do systemu</p><form class=\"m-t\" role=\"form\" ng-submit=\"login()\" autocomplete=\"on\"><div class=\"form-group\"><input type=\"email\" class=\"form-control\" placeholder=\"Adres email\" required=\"\" ng-model=\"loginForm.email\"></div><div class=\"form-group\"><input type=\"password\" class=\"form-control\" placeholder=\"Hasło\" required=\"\" ng-model=\"loginForm.password\"></div><button type=\"submit\" class=\"btn btn-primary block full-width m-b\">Zaloguj</button> <a ui-sref=\"password-reset\"><small>Zapomniane hasło?</small></a></form><p class=\"m-t\"><small>Profesjonalne Audyty Marketingowe Sp.z o.o</small></p></div></div>");
$templateCache.put("app/login/password.html","<div class=\"middle-box text-center loginscreen animated fadeInDown\" ng-controller=\"PasswordController as password\"><div><div><h1 class=\"logo-name\" style=\"font-size: 145px\">PAM</h1></div><h3>Kontroler</h3><p>Resetowanie hasła</p><form class=\"m-t\" role=\"form\" ng-submit=\"password.resetPassword()\"><div class=\"form-group\"><input type=\"email\" class=\"form-control\" placeholder=\"Adres email\" required=\"\" ng-model=\"password.email\"></div><button type=\"submit\" class=\"btn btn-primary block full-width m-b\">Zaloguj</button></form><p class=\"m-t\"><small>Profesjonalne Audyty Marketingowe Sp.z o.o</small></p></div></div>");
$templateCache.put("app/main/main.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Audyty dzisiaj</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th>#</th><th>Kampania</th><th>Audytor</th><th>Efektywność</th><th>Wymagana efektywność</th><th>Akcja</th></tr></thead><tbody><tr ng-repeat=\"t in traces track by $index\"><td>{{ $index+1 }}</td><td>{{ t.campaign.name }}</td><td>{{ t.auditor.first_name }} {{ t.auditor.last_name }}</td><td><pie-chart ng-if=\"t.is_effective\" data=\"[t.percent_effectiveness, 100]\" options=\"main.pieChartOptions.effective\"></pie-chart><pie-chart ng-if=\"!t.is_effective\" data=\"[t.percent_effectiveness, 100]\" options=\"main.pieChartOptions.noneffective\"></pie-chart></td><td>{{ t.required_effectiveness }}%</td><td><button class=\"btn btn-xs btn-primary\" ng-click=\"main.showTrace(t.id)\"><i class=\"fa fa-eye\"></i></button></td></tr></tbody></table></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Audyty dzisiaj</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th>#</th><th>Kampania</th><th>Audytor</th><th>Efektywność</th><th>Wymagana efektywność</th><th>Akcja</th></tr></thead><tbody><tr ng-repeat=\"t in traces track by $index\"><td>{{ $index+1 }}</td><td>{{ t.campaign.name }}</td><td>{{ t.auditor.first_name }} {{ t.auditor.last_name }}</td><td><pie-chart ng-if=\"t.is_effective\" data=\"[t.percent_effectiveness, 100]\" options=\"main.pieChartOptions.effective\"></pie-chart><pie-chart ng-if=\"!t.is_effective\" data=\"[t.percent_effectiveness, 100]\" options=\"main.pieChartOptions.noneffective\"></pie-chart></td><td>{{ t.required_effectiveness }}%</td><td><button class=\"btn btn-xs btn-primary\" ng-click=\"main.showTrace(t.id)\"><i class=\"fa fa-eye\"></i></button></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/minor/minor.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><h1>Simple example of second view</h1><small>Configure in app.js as index.minor state.</small></div></div></div></div>");
$templateCache.put("app/panel/panel.html","<div class=\"wrapper wrapper-content animated fadeInRight\" ng-controller=\"PanelController as panel\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Audyty - aktywne</h5><span style=\"float: right;\"><input type=\"date\" ng-model=\"current_date\" ng-change=\"panel.getTracesForChoosenDate()\"></span></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr ng-if=\"groupedByCampaign === false\" ng-include=\"\" src=\"\'panel_table_header.html\'\"></tr></thead><tbody><tr class=\"test1_tr\" ng-repeat=\"(key, value) in panel.tracesByCampaign\" ng-if=\"groupedByCampaign === true\"><td colspan=\"10\" ng-include=\"\" src=\"\'campaign_row.html\'\"></td></tr><tr class=\"test2_tr\" ng-repeat=\"t in panel.traces track by $index\" ng-if=\"t.status.id == \'a\' && groupedByCampaign === false\" ng-include=\"\" src=\"\'trace_row.html\'\"></tr></tbody></table></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Audyty - zakończone</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr ng-if=\"groupedByCampaign === false\" ng-include=\"\" src=\"\'panel_table_header.html\'\"></tr></thead><tbody><tr ng-repeat=\"(key, value) in panel.tracesByCampaign\" ng-if=\"groupedByCampaign === true\"><td colspan=\"10\" ng-include=\"\" src=\"\'campaign_row_finished.html\'\"></td></tr><tr ng-repeat=\"t in panel.traces track by $index\" ng-if=\"t.status.id == \'f\' && groupedByCampaign === false\" ng-include=\"\" src=\"\'trace_row.html\'\"></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/panel/panel_table_header.html","<tr><th>#</th><th ng-click=\"panel.toggleGroupByCampaign()\">Kampania</th><th>Miasto</th><th>Materiał reklamowy</th><th>Odwiedzone punkty</th><th>Skuteczność (niepoprawne %)</th><th>Skuteczność (poprawne %)</th><th>Wymagana skuteczność</th><th>Prognoza</th><th>Akcja</th></tr>");
$templateCache.put("app/partials/panel_table_header.html","<tr><th>#</th><th>Kampania</th><th>Miasto</th><th>Materiał reklamowy</th><th>Odwiedzone punkty</th><th>Skuteczność (niepoprawne %)</th><th>Skuteczność (poprawne %)</th><th>Wymagana skuteczność</th><th>Prognoza</th><th>Akcja</th></tr>");
$templateCache.put("app/partials/track_row.html","<td>{{ $index+1 }}</td><td>{{ t.campaign.name }}</td><td>{{ t.city }}</td><td>{{ t.advertising_material }}</td><td>{{ t.visited_points_count }} / {{ t.points_count }}</td><td>{{ t.percent_effectiveness }}%</td><td ng-if=\"t.is_effective\" class=\"btn-primary\">{{ t.percent_effectiveness }}%</td><td ng-if=\"!t.is_effective\" class=\"btn-danger\">{{ t.percent_effectiveness }}%</td><td>{{ t.required_effectiveness }}%</td><td></td><td><button class=\"btn btn-xs btn-primary\" ng-click=\"panel.showTrace(t.id)\"><i class=\"fa fa-eye\"></i></button></td>");
$templateCache.put("app/reports/reports.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><h1>Raporty</h1><small>TEST BARDZO</small></div></div></div></div>");
$templateCache.put("app/routes/route-add.html","<div class=\"wrapper wrapper-content animated fadeInRight\" ng-controller=\"RouteAddController as routeAdd\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Dodaj audyt</h5></div><div class=\"ibox-content\"><form name=\"new_route_form\" method=\"get\" class=\"form-horizontal ng-pristine ng-valid\" ng-submit=\"new_route_form.$valid && addRoute(newRoute)\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Kampania</label><div class=\"col-sm-10\"><input type=\"text\" readonly=\"\" class=\"form-control\" ng-model=\"newRoute.campaign[0].name\" ng-required=\"true\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Data realizacji</label><div class=\"col-sm-10\"><p class=\"input-group\"><input type=\"text\" readonly=\"\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"newRoute.date\" is-open=\"dp.opened\" datepicker-options=\"dateOptions\" ng-required=\"true\" close-text=\"Close\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openDp()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Wykonawca</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-options=\"a as (a.first_name + \' \' + a.last_name) for a in auditors | orderBy: \'id\'\" ng-required=\"true\" ng-model=\"newRoute.auditor\"></select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Miasto</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" autocomplete=\"on\" ng-model=\"newRoute.city\" ng-required=\"true\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Klient</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" autocomplete=\"on\" ng-model=\"newRoute.customer\" ng-required=\"false\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Dystrybutor</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" autocomplete=\"on\" ng-model=\"newRoute.distributor\" ng-required=\"false\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Materiał reklamowy</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" autocomplete=\"on\" ng-model=\"newRoute.advertising_material\" ng-required=\"false\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Wymagana skuteczność w %</label><div class=\"col-sm-10\"><input type=\"number\" maxlength=\"3\" min=\"0\" max=\"100\" class=\"form-control\" ng-model=\"newRoute.required_effectiveness\" ng-required=\"true\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Nagrywanie dozwolone?</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-required=\"true\" ng-model=\"newRoute.recording_enabled\"><option selected=\"\" value=\"0\">NIE</option><option value=\"1\">TAK</option></select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Pokazać nagranie dla klienta?</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-required=\"true\" ng-model=\"newRoute.show_record_to_customer\"><option selected=\"\" value=\"0\">NIE</option><option value=\"1\">TAK</option></select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Pokazać KML dla klienta?</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-required=\"true\" ng-model=\"newRoute.show_kml_to_customer\"><option selected=\"\" value=\"0\">NIE</option><option value=\"1\">TAK</option></select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Plik Kml</label><div class=\"col-sm-10\"><input class=\"form-control m-b\" type=\"file\" ng-model=\"newRoute.kml_file\" name=\"newRoute.kml_file\" fileread=\"newRoute.kml_file\"></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><div class=\"col-sm-4 col-sm-offset-2\"><button class=\"btn btn-white\" ng-click=\"backToRoutes()\">Anuluj</button> <input type=\"submit\" class=\"btn btn-primary\"></div></div></form></div></div></div></div></div></div></div></div>");
$templateCache.put("app/routes/route-edit.html","<div class=\"wrapper wrapper-content animated fadeInRight\" ng-controller=\"RouteEditController as routeEdit\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Edycja audytu</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.main\">Panel</a></li><li><a ng-click=\"showTrace(campaign_id)\">Audyty</a></li><li class=\"active\"><strong>Podgląd audytu</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Edytuj audyt</h5></div><div class=\"ibox-content\"><form method=\"get\" class=\"form-horizontal ng-pristine ng-valid\" ng-submit=\"editRoute()\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Kampania</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-options=\"c.id as c.name for c in campaigns\" ng-required=\"true\" ng-model=\"editRoute.campaign\"></select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Data realizacji</label><div class=\"col-sm-10\"><p class=\"input-group\"><input type=\"text\" readonly=\"\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"editRoute.date\" is-open=\"dp.opened\" datepicker-options=\"dateOptions\" ng-required=\"true\" close-text=\"Close\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openDp()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Wykonawca</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-options=\"a.id as (a.first_name + \' \' + a.last_name) for a in auditors\" ng-required=\"true\" ng-model=\"editRoute.auditor\"></select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Miasto</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"editRoute.city\" ng-required=\"true\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Klient</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"editRoute.customer\" ng-required=\"false\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Dystrybutor</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"editRoute.distributor\" ng-required=\"false\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Materiał reklamowy</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"editRoute.advertising_material\" ng-required=\"false\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Wymagana skuteczność w %</label><div class=\"col-sm-10\"><input type=\"number\" maxlength=\"3\" min=\"0\" max=\"100\" class=\"form-control\" ng-model=\"editRoute.required_effectiveness\" ng-required=\"true\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Nagrywanie dozwolone?</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-required=\"true\" ng-model=\"editRoute.recording_enabled\"><option selected=\"\" value=\"0\">NIE</option><option value=\"1\">TAK</option></select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Pokazać nagranie dla klienta?</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-required=\"true\" ng-model=\"editRoute.show_record_to_customer\"><option selected=\"\" value=\"0\">NIE</option><option value=\"1\">TAK</option></select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Pokazać KML dla klienta?</label><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-required=\"true\" ng-model=\"editRoute.show_kml_to_customer\"><option selected=\"\" value=\"0\">NIE</option><option value=\"1\">TAK</option></select></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><div class=\"col-sm-4 col-sm-offset-2\"><button class=\"btn btn-white\" ng-click=\"backToRoutes()\">Anuluj</button> <input type=\"submit\" class=\"btn btn-primary\" value=\"Zapisz\"></div></div></form></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Import punktów audytu</h5></div><div class=\"ibox-content\"><form name=\"importForm\" method=\"post\" class=\"form-horizontal ng-pristine ng-valid\" enctype=\"multipart/form-data\" ng-submit=\"importPoints()\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Plik</label><div class=\"col-sm-10\"><input class=\"form-control m-b\" type=\"file\" name=\"pointsCsv\" fileread=\"pointsCsv\"></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><div class=\"col-sm-4 col-sm-offset-2\"><button class=\"btn btn-white\" ng-click=\"backToRoutes()\">Anuluj</button> <button type=\"submit\" name=\"importFileButton\" class=\"btn btn-primary\">Zapisz</button></div></div></form></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Import pliku KML audytu</h5></div><div class=\"ibox-content\"><form name=\"importForm\" method=\"post\" class=\"form-horizontal ng-pristine ng-valid\" enctype=\"multipart/form-data\" ng-submit=\"importKml()\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Plik</label><div class=\"col-sm-10\"><input class=\"form-control m-b\" type=\"file\" name=\"kmlFile\" fileread=\"kmlFile\"></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><div class=\"col-sm-4 col-sm-offset-2\"><button class=\"btn btn-white\" ng-click=\"backToRoutes()\">Anuluj</button> <button type=\"submit\" name=\"sendKmlButton\" class=\"btn btn-primary\">Zapisz</button></div></div></form></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Punkty audytu</h5></div><div class=\"ibox-content\"><button ng-if=\"status != \'a\'\" type=\"button\" ng-click=\"removePoints()\" class=\"btn btn-danger\">Usuń zaznaczone punkty</button><form class=\"form-inline\" name=\"routeEdit.form_point\" ng-submit=\"routeEdit.addPoint(form)\"><div class=\"table-responsive\"><table datatable=\"ng\" dt-options=\"dtOptions\" dt-column-defs=\"dtColumnDefs\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr ng-style=\"style\"><th ng-if=\"status != \'a\'\">All <input type=\"checkbox\" ng-click=\"routeEdit.toggleAllPoints()\"></th><th><div class=\"form-group\"><label><input class=\"form-control\" placeholder=\"Region\" name=\"region\" ng-model=\"form.region\" value=\"\"></label></div></th><th><div class=\"form-group\"><label><input class=\"form-control\" placeholder=\"Subregion\" name=\"name\" ng-model=\"form.subregion\" value=\"\"></label></div></th><th><div class=\"form-group\"><label><input class=\"form-control\" placeholder=\"Ulica\" name=\"street\" ng-model=\"form.street\" style=\"width: 45%\" value=\"\" required=\"\"> <input class=\"form-control\" placeholder=\"Nr domu\" name=\"adress\" ng-model=\"form.building_number\" style=\"width: 45%\" value=\"\" required=\"\"> <input class=\"form-control\" placeholder=\"Kod pocztowy\" name=\"adress\" ng-model=\"form.post_code\" style=\"width: 45%\" value=\"\" required=\"\"> <input class=\"form-control\" placeholder=\"Miasto\" ng-model=\"form.city\" style=\"width: 45%\" value=\"\" required=\"\"></label></div></th><th><div class=\"form-group\"><label><input type=\"text\" class=\"form-control\" placeholder=\"Lat\" name=\"x\" ng-model=\"form.x\" value=\"\" style=\"max-width: 70px\"></label></div></th><th><div class=\"form-group\"><label><input type=\"text\" class=\"form-control\" placeholder=\"Lng\" name=\"y\" ng-model=\"form.y\" value=\"\" style=\"max-width: 70px\"></label></div></th><th><div class=\"form-group\"><label><textarea class=\"form-control\" placeholder=\"Notatka\" name=\"note\" ng-model=\"form.note\"></textarea></label></div></th><th ng-if=\"status != \'a\'\"><div class=\"form-group\"><button type=\"submit\" class=\"btn btn-success\"><i class=\"fa fa-plus\"></i></button></div></th></tr><tr><th class=\"hidden\">Sort</th><th ng-if=\"status != \'a\'\"></th><th>Region</th><th>Subregion</th><th>Adres</th><th>X</th><th>Y</th><th>Notatka</th><th width=\"12%\" ng-if=\"status != \'a\'\"></th></tr></thead><tbody><tr ng-repeat=\"point in points | orderBy:\'sort\' track by $index\" data-point-id=\"{{point.id}}\" data-point-sort=\"{{point.sort}}\" ondragstart=\"angular.element(this).scope().drag(event)\" draggable=\"true\" ondrop=\"angular.element(this).scope().drop(event)\" ondragover=\"angular.element(this).scope().allowDrop(event)\" ondragenter=\"angular.element(this).scope().dragEnter(event)\" ondragleave=\"angular.element(this).scope().dragLeave(event)\"><td class=\"hidden\" id=\"point_sort_{{point.id}}\">{{ point.sort }}</td><td ng-if=\"status != \'a\'\"><input type=\"checkbox\" id=\"point_selection_{{point.id}}\" ng-model=\"point.selected\" ng-change=\"pointClicked(point.id)\"></td><td><span ng-if=\"edited_point != point.id\">{{ point.region }}</span> <input type=\"hidden\" value=\"{{ point.region }}\" id=\"point_edit_{{point.id}}_region\" class=\"point_edit_{{point.id}}\"></td><td><span ng-if=\"edited_point != point.id\">{{ point.subregion }}</span> <input type=\"hidden\" value=\"{{ point.subregion }}\" id=\"point_edit_{{point.id}}_subregion\" class=\"point_edit_{{point.id}}\"></td><td><span ng-if=\"edited_point != point.id\">{{ point.address.street }} {{ point.address.building_number }} {{ point.address.post_code }} {{ point.address.city }}</span> <input type=\"hidden\" value=\"{{ point.address.street }}\" class=\"point_edit_{{point.id}}\" id=\"point_edit_{{point.id}}_address_street\"> <input type=\"hidden\" value=\"{{ point.address.building_number }}\" class=\"point_edit_{{point.id}}\" id=\"point_edit_{{point.id}}_address_building_number\"> <input type=\"hidden\" ng-if=\"point.address.post_code != \'\'\" value=\"{{ point.address.post_code }}\" id=\"point_edit_{{point.id}}_address_post_code\" class=\"point_edit_{{point.id}}\"></td><td><span ng-if=\"edited_point != point.id\">{{ point.location.latitude }}</span> <input type=\"hidden\" value=\"{{ point.location.latitude }}\" id=\"point_edit_{{point.id}}_location_latitude\" class=\"point_edit_{{point.id}}\"></td><td><span ng-if=\"edited_point != point.id\">{{ point.location.longitude }}</span> <input type=\"hidden\" value=\"{{ point.location.longitude }}\" id=\"point_edit_{{point.id}}_location_longitude\" class=\"point_edit_{{point.id}}\"></td><td><span ng-if=\"edited_point != point.id\">{{ point.note }}</span> <input type=\"hidden\" value=\"{{ point.note }}\" class=\"point_edit_{{point.id}}\" id=\"point_edit_{{point.id}}_note\"></td><td ng-if=\"status != \'a\'\"><span ng-if=\"edited_point != point.id\"><button type=\"button\" ng-if=\"$index != 0\" ng-click=\"pointUp(point.id, points[$index - 1].id)\" class=\"btn btn-sm btn-success\"><i class=\"fa fa-arrow-up\"></i></button> <button type=\"button\" ng-if=\"($index + 1 ) != points.length\" ng-click=\"pointDown(point.id, points[$index + 1].id)\" class=\"btn btn-sm btn-success\"><i class=\"fa fa-arrow-down\"></i></button> <button type=\"button\" ng-click=\"removePoint(point.id)\" class=\"btn btn-sm btn-danger\"><i class=\"fa fa-trash-o\"></i></button> <button type=\"button\" ng-click=\"editPoint(point.id)\" class=\"btn btn-sm btn-primary\"><i class=\"fa fa-edit\"></i></button></span> <span ng-if=\"edited_point == point.id\"><button type=\"button\" ng-click=\"savePoint(point.id)\" class=\"btn btn-sm btn-primary\"><i class=\"fa fa-save\"></i></button> <button type=\"button\" ng-click=\"cancelEditPoint(point.id)\" class=\"btn btn-sm btn-danger\"><i class=\"fa fa-ban\"></i></button></span></td></tr></tbody></table></div></form></div></div></div></div><div ng-if=\"dataLoaded\" class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>KML Geocoding</h5></div><div class=\"ibox-content\"><div id=\"map-container\"><ng-map center=\"{{ centerMap }}\" style=\"min-height: 100%\"><p ng-if=\"generatedAddresses.length && point.status\" ng-repeat=\"point in generatedAddresses\"><marker ng-if=\"point.status\" title=\"{{point.nazwa_ul}} {{ point.nr_domu }}\" position=\"{{ [ point.y, point.x] }}\"></marker></p></ng-map></div><form name=\"importForm\" method=\"post\" class=\"form-horizontal ng-pristine ng-valid\" enctype=\"multipart/form-data\" ng-submit=\"importKmlToMap()\"><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Plik kml</label><div class=\"col-sm-4\"><input class=\"form-control m-b\" type=\"file\" name=\"kmlVariables.kmlMapFile\" fileread=\"kmlVariables.kmlMapFile\" accept=\".kml\"></div><label class=\"col-sm-2 control-label\">Liczba adresów</label><div class=\"col-sm-4\"><input class=\"form-control m-b\" type=\"number\" ng-model=\"kmlVariables.addressCount\" placeholder=\"Liczba adresów do wylosowania\"></div><div class=\"form-group\"><div class=\"col-sm-12\"><label ng-if=\"kmlVariables.regionName\" class=\"col-sm-12\">Wybrany region: {{ kmlVariables.regionName }}</label></div></div></div><div ng-if=\"!kmlVariables.kmlMapFile || !kmlVariables.addressCount || !kmlVariables.regionName\"><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><span ng-if=\"!kmlVariables.kmlMapFile\" class=\"text-danger\">* Wybierz plik KML<br></span> <span ng-if=\"!kmlVariables.addressCount\" class=\"text-danger\">* Wpisz liczbę adresów<br></span> <span ng-if=\"!kmlVariables.regionName\" class=\"text-danger\">* Wybierz region, z którego mają zostać wylosowane adresy</span></div></div><div class=\"hr-line-dashed\"></div><div ng-if=\"!sendingKml\" class=\"form-group\"><div class=\"col-sm-12\"><button ng-disabled=\"!kmlVariables.kmlMapFile\" ng-click=\"clearMap()\" type=\"button\" class=\"btn btn-primary\">Zresetuj mapę</button> <button ng-disabled=\"!kmlVariables.kmlMapFile\" type=\"submit\" class=\"btn btn-primary\">Pokaż na mapie plik kml</button> <button ng-disabled=\"!kmlVariables.kmlMapFile || !kmlVariables.addressCount || !kmlVariables.regionName\" ng-click=\"generateAddresses()\" type=\"button\" name=\"sendKmlButton\" class=\"btn btn-primary\">Wyślij kml</button></div></div><div ng-if=\"sendingKml\" class=\"sk-fading-circle\"><div class=\"sk-circle1 sk-circle\"></div><div class=\"sk-circle2 sk-circle\"></div><div class=\"sk-circle3 sk-circle\"></div><div class=\"sk-circle4 sk-circle\"></div><div class=\"sk-circle5 sk-circle\"></div><div class=\"sk-circle6 sk-circle\"></div><div class=\"sk-circle7 sk-circle\"></div><div class=\"sk-circle8 sk-circle\"></div><div class=\"sk-circle9 sk-circle\"></div><div class=\"sk-circle10 sk-circle\"></div><div class=\"sk-circle11 sk-circle\"></div><div class=\"sk-circle12 sk-circle\"></div></div></form><div ng-hide=\"!generatedAddresses.length\" class=\"table-responsive\"><table ng-if=\"generatedAddresses.length\" datatable=\"ng\" dt-options=\"dtOptions\" class=\"table table-striped table-bordered table-hover dataTables-example\"><thead><tr><th>Checkbox</th><th>Nazwa miejscowości</th><th>Nazwa ulicy</th><th>Długość geograficzna</th><th>Szerokość geograficzna</th></tr></thead><tbody><tr ng-repeat=\"point in generatedAddresses | orderBy:\'sort\' track by $index\"><td><input type=\"checkbox\" ng-model=\"point.status\"></td><td>{{ point.nazwa_miej }}</td><td>{{ point.nazwa_ul }} {{ point.nr_domu }}</td><td>{{ point.y }}</td><td>{{ point.x }}</td></tr></tbody></table><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Region</label><div class=\"col-sm-4\"><input class=\"form-control m-b\" type=\"text\" name=\"kmlVariables.kmlRegion\" ng-model=\"kmlVariables.kmlRegion\" placeholder=\"Wpisz region\"></div><label class=\"col-sm-2 control-label\">Subregion</label><div class=\"col-sm-4\"><input class=\"form-control m-b\" type=\"text\" name=\"kmlVariables.kmlSubregion\" ng-model=\"kmlVariables.kmlSubregion\" placeholder=\"Wpisz subregion\"></div></div><div class=\"form-group\"><div class=\"col-sm-12\"><button ng-click=\"sendAddresses()\" type=\"button\" class=\"btn btn-primary\">Wyślij zaznaczone adresy</button></div></div></div></div></div></div></div></div></div></div></div><style type=\"text/css\">\r\n    .sk-fading-circle {\r\n        margin: 100px auto;\r\n        width: 40px;\r\n        height: 40px;\r\n        position: relative;\r\n    }\r\n\r\n    .sk-fading-circle .sk-circle {\r\n        width: 100%;\r\n        height: 100%;\r\n        position: absolute;\r\n        left: 0;\r\n        top: 0;\r\n    }\r\n\r\n    .sk-fading-circle .sk-circle:before {\r\n        content: \'\';\r\n        display: block;\r\n        margin: 0 auto;\r\n        width: 15%;\r\n        height: 15%;\r\n        background-color: #333;\r\n        border-radius: 100%;\r\n        -webkit-animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;\r\n        animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;\r\n    }\r\n    .sk-fading-circle .sk-circle2 {\r\n        -webkit-transform: rotate(30deg);\r\n        -ms-transform: rotate(30deg);\r\n        transform: rotate(30deg);\r\n    }\r\n    .sk-fading-circle .sk-circle3 {\r\n        -webkit-transform: rotate(60deg);\r\n        -ms-transform: rotate(60deg);\r\n        transform: rotate(60deg);\r\n    }\r\n    .sk-fading-circle .sk-circle4 {\r\n        -webkit-transform: rotate(90deg);\r\n        -ms-transform: rotate(90deg);\r\n        transform: rotate(90deg);\r\n    }\r\n    .sk-fading-circle .sk-circle5 {\r\n        -webkit-transform: rotate(120deg);\r\n        -ms-transform: rotate(120deg);\r\n        transform: rotate(120deg);\r\n    }\r\n    .sk-fading-circle .sk-circle6 {\r\n        -webkit-transform: rotate(150deg);\r\n        -ms-transform: rotate(150deg);\r\n        transform: rotate(150deg);\r\n    }\r\n    .sk-fading-circle .sk-circle7 {\r\n        -webkit-transform: rotate(180deg);\r\n        -ms-transform: rotate(180deg);\r\n        transform: rotate(180deg);\r\n    }\r\n    .sk-fading-circle .sk-circle8 {\r\n        -webkit-transform: rotate(210deg);\r\n        -ms-transform: rotate(210deg);\r\n        transform: rotate(210deg);\r\n    }\r\n    .sk-fading-circle .sk-circle9 {\r\n        -webkit-transform: rotate(240deg);\r\n        -ms-transform: rotate(240deg);\r\n        transform: rotate(240deg);\r\n    }\r\n    .sk-fading-circle .sk-circle10 {\r\n        -webkit-transform: rotate(270deg);\r\n        -ms-transform: rotate(270deg);\r\n        transform: rotate(270deg);\r\n    }\r\n    .sk-fading-circle .sk-circle11 {\r\n        -webkit-transform: rotate(300deg);\r\n        -ms-transform: rotate(300deg);\r\n        transform: rotate(300deg);\r\n    }\r\n    .sk-fading-circle .sk-circle12 {\r\n        -webkit-transform: rotate(330deg);\r\n        -ms-transform: rotate(330deg);\r\n        transform: rotate(330deg);\r\n    }\r\n    .sk-fading-circle .sk-circle2:before {\r\n        -webkit-animation-delay: -1.1s;\r\n        animation-delay: -1.1s;\r\n    }\r\n    .sk-fading-circle .sk-circle3:before {\r\n        -webkit-animation-delay: -1s;\r\n        animation-delay: -1s;\r\n    }\r\n    .sk-fading-circle .sk-circle4:before {\r\n        -webkit-animation-delay: -0.9s;\r\n        animation-delay: -0.9s;\r\n    }\r\n    .sk-fading-circle .sk-circle5:before {\r\n        -webkit-animation-delay: -0.8s;\r\n        animation-delay: -0.8s;\r\n    }\r\n    .sk-fading-circle .sk-circle6:before {\r\n        -webkit-animation-delay: -0.7s;\r\n        animation-delay: -0.7s;\r\n    }\r\n    .sk-fading-circle .sk-circle7:before {\r\n        -webkit-animation-delay: -0.6s;\r\n        animation-delay: -0.6s;\r\n    }\r\n    .sk-fading-circle .sk-circle8:before {\r\n        -webkit-animation-delay: -0.5s;\r\n        animation-delay: -0.5s;\r\n    }\r\n    .sk-fading-circle .sk-circle9:before {\r\n        -webkit-animation-delay: -0.4s;\r\n        animation-delay: -0.4s;\r\n    }\r\n    .sk-fading-circle .sk-circle10:before {\r\n        -webkit-animation-delay: -0.3s;\r\n        animation-delay: -0.3s;\r\n    }\r\n    .sk-fading-circle .sk-circle11:before {\r\n        -webkit-animation-delay: -0.2s;\r\n        animation-delay: -0.2s;\r\n    }\r\n    .sk-fading-circle .sk-circle12:before {\r\n        -webkit-animation-delay: -0.1s;\r\n        animation-delay: -0.1s;\r\n    }\r\n\r\n    @-webkit-keyframes sk-circleFadeDelay {\r\n        0%, 39%, 100% { opacity: 0; }\r\n        40% { opacity: 1; }\r\n    }\r\n\r\n    @keyframes sk-circleFadeDelay {\r\n        0%, 39%, 100% { opacity: 0; }\r\n        40% { opacity: 1; }\r\n    }\r\n</style>");
$templateCache.put("app/routes/route-view.html","<div class=\"wrapper wrapper-content animated fadeInRight\" ng-controller=\"RouteViewController as routeView\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Podgląd audytu</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.main\">Panel</a></li><li><a ng-click=\"showTrace(activeRoute.campaign.id)\">Audyty</a></li><li class=\"active\"><strong>Podgląd audytu</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div ng-hide=\"!showPdfLoader\" class=\"loader\"><h2 class=\"animate\">{{ zipModel.inProgress ? zipModel.downloadText : \'Trwa generowanie raportu...\'}}</h2></div><div ng-if=\"!dataLoaded\" class=\"sk-fading-circle\"><div class=\"sk-circle1 sk-circle\"></div><div class=\"sk-circle2 sk-circle\"></div><div class=\"sk-circle3 sk-circle\"></div><div class=\"sk-circle4 sk-circle\"></div><div class=\"sk-circle5 sk-circle\"></div><div class=\"sk-circle6 sk-circle\"></div><div class=\"sk-circle7 sk-circle\"></div><div class=\"sk-circle8 sk-circle\"></div><div class=\"sk-circle9 sk-circle\"></div><div class=\"sk-circle10 sk-circle\"></div><div class=\"sk-circle11 sk-circle\"></div><div class=\"sk-circle12 sk-circle\"></div></div><div ng-if=\"dataLoaded\" class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><div class=\"row\"><div class=\"col-lg-6\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Ogólne</h5><span style=\"float: right\" ng-if=\"main.isAdmin()\" ng-click=\"changeShowEffectiveness()\"><i class=\"fa {{showEffectiveness ? \'fa-eye\' : \'fa-eye-slash\'}}\"></i></span></div><div class=\"ibox-content\"><table class=\"table table-striped table-hover\"><tbody><tr><td><strong>Miasto:</strong></td><td>{{ activeRoute.city }}</td></tr><tr ng-if=\"main.isAdmin()\"><td><strong>Materiał reklamowy:</strong></td><td>{{ activeRoute.advertising_material || \'---\' }}</td></tr><tr ng-if=\"main.isAdmin()\"><td><strong>Klient:</strong></td><td>{{ activeRoute.customer || \'---\' }}</td></tr><tr ng-if=\"main.isAdmin()\"><td><strong>Dystrybutor:</strong></td><td>{{ activeRoute.distributor || \'---\' }}</td></tr><tr><td><strong>Wykonawca:</strong></td><td>{{ activeRoute.auditor.first_name }} {{ activeRoute.auditor.last_name }}</td></tr><tr><td><strong>Data:</strong></td><td>{{ moment(activeRoute.start_date).format(\'YYYY/MM/DD\') }}</td></tr><tr><td><strong>Status:</strong></td><td>{{ activeRoute.status.name }}</td></tr><tr><td><strong>Kampania:</strong></td><td>{{ activeRoute.campaign.name }}</td></tr><tr ng-if=\"main.isAdmin()\"><td><strong>Długość trasy(Z-ST/ST-ZA/ZA-W):</strong></td><td>{{ startDistance | number:2 }} km/ {{ beetweenDistance | number:2 }} km/ {{ endDistance | number:2 }} km</td></tr><tr ng-if=\"main.isAdmin()\"><td><strong>Predkość odtwarzania (0 - 16)</strong></td><td><input type=\"number\" ng-keyup=\"setPlaybackSpeed($event)\" value=\"1\"></td></tr></tbody></table></div></div></div><div class=\"col-lg-6\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"modal inmodal in\" id=\"photoModal\" aria-hidden=\"true\" role=\"dialog\" ng-show=\"showPhotos\" style=\"display: block; z-index: 9999\"><div class=\"modal-dialog\"><div class=\"modal-content animated bounceInRight\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\">&times;</button> <b>Lista zdjęć</b></div><div class=\"modal-body\"><b ng-if=\"!photos.length\">Wczytywanie zdjęć...</b><div ng-if=\"photos.length\"><span></span> <img width=\"50%\" height=\"50%\" ng-src=\"data:image/png;base64,{{photos[imageNumber].data}}\" style=\"margin:auto;\"><div class=\"carousel-caption\"><h4>Nr domu: {{ photos[imageNumber].flat_number }}</h4><h4>Ulica: {{ photos[imageNumber].street + \" \" + photos[imageNumber].building_number }}</h4></div></div></div><div class=\"modal-footer\"><div ng-if=\"photos.length > 1\" class=\"pagination\"><a ng-click=\"goToPhoto(imageNumber - 1, photos.length)\">&laquo;</a> <a ng-click=\"goToPhoto(imageNumber + 1, photos.length)\">&raquo;</a></div><a ng-if=\"photos.length > 0\" class=\"btn btn-white\" download=\"{{ activeRoute.city }}_{{ photos[imageNumber].street }}_{{ photos[imageNumber].building_number }}_KL{{ imageNumber + 1 }}_m_{{ photos[imageNumber].flat_number }}.jpg\" href=\"data:image/png;base64,{{photos[imageNumber].data}}\">Pobierz</a> <button type=\"button\" class=\"btn btn-white\" data-dismiss=\"modal\">Zamknij</button></div></div></div></div><div class=\"modal inmodal in\" id=\"noteModal\" aria-hidden=\"true\" role=\"dialog\" ng-show=\"showNote\" style=\"display: block; z-index: 9999\"><div class=\"modal-dialog\"><div class=\"modal-content animated bounceInRight\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\">&times;</button> <b>Notatka</b></div><div ng-bind-html=\"note\" class=\"modal-body\"></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" data-dismiss=\"modal\">Zamknij</button></div></div></div></div><div class=\"row\"><uib-tabset><uib-tab heading=\"Statystyki\" active=\"tab.active\"><div class=\"col-lg-6\"><h5>Odwiedzonych punktów</h5><h2>{{ routeView.routeStats.visitedPointPercent }}%</h2><div class=\"progress progress-mini\"><div style=\"width: {{ routeView.routeStats.visitedPointPercent }}%;\" class=\"progress-bar\"></div></div><div class=\"m-t-sm small\" ng-if=\"showEffectiveness\">Odwiedzono {{ routeView.routeStats.visitedPointCount }}/{{ routeView.routeStats.pointCount }} punktów</div></div><div ng-class=\"{ \'bg-success\' : activeRoute.is_effective, \'bg-danger\' : !activeRoute.is_effective }\" class=\"col-lg-6\"><h5>Skuteczność</h5><h2>{{ routeView.routeStats.effectivePointPercent }}%</h2><div class=\"progress progress-mini\"><div style=\"width: {{ routeView.routeStats.effectivePointPercent }}%;\" class=\"progress-bar\" ng-class=\"{\'progress-bar-warning\': routeView.routeStats.effectivePointPercent < routeView.routeStats.requiredEffectiveness, }\"></div></div><div class=\"m-t-sm small\" ng-if=\"showEffectiveness\">Skuteczność w {{ routeView.routeStats.effectivePointCount}} z {{ routeView.routeStats.visitedPointCount }} punktów</div></div></uib-tab><uib-tab heading=\"Tereny\" ng-if=\"main.isAdmin()\"><table class=\"table table-striped\"><thead><tr><th>Teren</th><th>TAK</th><th>NIE</th><th>Suma</th><th>Jakość: Otrzymane</th></tr></thead><tbody><tr ng-repeat=\"region in routeView.regionStats\"><td>{{ region.name }}</td><td>{{ region.yes }}</td><td>{{ region.no }}</td><td>{{ region.yes + region.no }}</td><td>{{ region.efficiencyPercent }}%</td></tr><tr><td><p style=\"text-align: right\">SUMA:</p></td><td>{{ routeView.regionSummary.yes }}</td><td>{{ routeView.regionSummary.no }}</td><td>{{ routeView.regionSummary.yes + routeView.regionSummary.no }}</td><td>{{ routeView.regionSummary.efficiencyPercent }}%</td></tr></tbody></table></uib-tab><uib-tab ng-if=\"main.isAdmin()\" heading=\"Wykresy\"><div class=\"col-lg-4\"><h5>Odwiedzonych punktów</h5><h2>{{ routeView.routeStats.visitedPointPercent }}%</h2><div class=\"progress\"><div style=\"width: {{ routeView.routeStats.visitedPointPercent }}%;\" class=\"progress-bar\"></div></div><div class=\"m-t-sm small\" ng-if=\"showEffectiveness\">Odwiedzono {{ routeView.routeStats.visitedPointCount }}/{{ routeView.routeStats.pointCount }} punktów</div></div><div ng-if=\"main.isAdmin()\" ng-class=\"{ \'bg-success\' : activeRoute.is_effective, \'bg-danger\' : !activeRoute.is_effective }\" class=\"col-lg-4\"><h5>Skuteczność (dystr. niepr.)</h5><h2>{{ (((routeView.statisticsRoute.status_yes_count + routeView.statisticsRoute.status_visible_count + routeView.statisticsRoute.status_euro_box_count + routeView.statisticsRoute.status_trash_outside_count + routeView.statisticsRoute.status_on_box_count + routeView.statisticsRoute.status_trash_inside_count) / routeView.routeStats.visitedPointCount) * 100).toFixed(0) }}%</h2><div class=\"progress\"><div style=\"width: {{ (((routeView.statisticsRoute.status_yes_count + routeView.statisticsRoute.status_visible_count + routeView.statisticsRoute.status_euro_box_count + routeView.statisticsRoute.status_trash_outside_count + routeView.statisticsRoute.status_on_box_count + routeView.statisticsRoute.status_trash_inside_count) / routeView.routeStats.visitedPointCount) * 100).toFixed(0) }}%;\" class=\"progress-bar\" ng-class=\"{\'progress-bar-danger\': (((routeView.statisticsRoute.status_yes_count + routeView.statisticsRoute.status_visible_count + routeView.statisticsRoute.status_euro_box_count + routeView.statisticsRoute.status_trash_outside_count + routeView.statisticsRoute.status_on_box_count + routeView.statisticsRoute.status_trash_inside_count) / routeView.routeStats.visitedPointCount) * 100).toFixed(0) < routeView.routeStats.requiredEffectiveness}\"></div><div style=\"width: {{ ((routeView.statisticsRoute.status_trash_inside_count + routeView.statisticsRoute.status_on_box_count)/routeView.routeStats.visitedPointCount) * 100 }}%;\" class=\"progress-bar absolute-left\" ng-class=\"{\'progress-bar-warning\': true }\">{{(((routeView.statisticsRoute.status_trash_inside_count + routeView.statisticsRoute.status_on_box_count) /routeView.routeStats.visitedPointCount) * 100).toFixed(0)}}%</div></div><div class=\"m-t-sm small\" ng-if=\"showEffectiveness\">Skuteczność w {{ routeView.statisticsRoute.status_yes_count + routeView.statisticsRoute.status_visible_count + routeView.statisticsRoute.status_euro_box_count + routeView.statisticsRoute.status_trash_outside_count + routeView.statisticsRoute.status_on_box_count + routeView.statisticsRoute.status_trash_inside_count }} z {{ routeView.routeStats.visitedPointCount }} punktów</div></div><div ng-if=\"main.isAdmin()\" ng-class=\"{ \'bg-success\' : activeRoute.is_effective, \'bg-danger\' : !activeRoute.is_effective }\" class=\"col-lg-4\"><h5>Skuteczność (kosze zewn.)</h5><h2>{{ (((routeView.statisticsRoute.status_yes_count + routeView.statisticsRoute.status_visible_count + routeView.statisticsRoute.status_euro_box_count + routeView.statisticsRoute.status_trash_outside_count) / routeView.routeStats.visitedPointCount) * 100).toFixed(0) }}%</h2><div class=\"progress\"><div style=\"width: {{ (((routeView.statisticsRoute.status_yes_count + routeView.statisticsRoute.status_visible_count + routeView.statisticsRoute.status_euro_box_count + routeView.statisticsRoute.status_trash_outside_count) /routeView.routeStats.visitedPointCount) * 100).toFixed(0) }}%;\" class=\"progress-bar\" ng-class=\"{\'progress-bar-danger\': (((routeView.statisticsRoute.status_yes_count + routeView.statisticsRoute.status_visible_count + routeView.statisticsRoute.status_euro_box_count + routeView.statisticsRoute.status_trash_outside_count) /routeView.routeStats.visitedPointCount) * 100).toFixed(0) < routeView.routeStats.requiredEffectiveness}\"></div><div style=\"width: {{ (routeView.statisticsRoute.status_trash_outside_count / routeView.routeStats.visitedPointCount) * 100 }}%;\" class=\"progress-bar absolute-left\" ng-class=\"{\'progress-bar-warning\': true }\">{{((routeView.statisticsRoute.status_trash_outside_count / routeView.routeStats.visitedPointCount) * 100).toFixed(0) }}%</div></div><div class=\"m-t-sm small\" ng-if=\"showEffectiveness\">Skuteczność w {{ routeView.statisticsRoute.status_yes_count + routeView.statisticsRoute.status_visible_count + routeView.statisticsRoute.status_euro_box_count + routeView.statisticsRoute.status_trash_outside_count }} z {{ routeView.routeStats.visitedPointCount }}</div></div></uib-tab></uib-tabset></div></div></div></div></div><div class=\"row\" ng-if=\"activeRoute\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Audyt</h5></div><div class=\"ibox-content\"><button class=\"custom-pdf-button\" ng-click=\"generateMap()\">Wygeneruj pdf</button> <button ng-if=\"zipModel.auditToDownload.length\" class=\"custom-pdf-button\" ng-click=\"downloadAllPhotos(activeRoute, true)\">Pobierz wszystkie zdjęcia</button><table id=\"example\" datatable=\"ng\" dt-options=\"dtOptions\" dt-column-defs=\"dtColumnDefs\" dt-instance=\"dtInstance\" class=\"table table-striped table-hover\"><thead><th>L.P.</th><th>Region</th><th>Subregion</th><th>Adres</th><th>Typ adresu/Domofon</th><th class=\"noExport\">Zdjęcia</th><th class=\"text-left\" ng-if=\"!activeRoute.show_record_to_customer && !main.isAdmin()\" ng-repeat=\"i in [1, 2, 3]\">Nr domu | Odp.</th><th class=\"text-left\" ng-if=\"activeRoute.show_record_to_customer || main.isAdmin()\" ng-repeat=\"i in [1, 2, 3]\">Nr domu | Odp. | Nag.</th><th>T/N/NW/BR</th><th>Data zatwierdzenia</th><th>Skuteczne</th><th class=\"noExport\">Opis</th></thead><tbody><tr ng-repeat=\"p in activeRoute.points track by $index\"><td ng-click=\"centerOnMap(p)\"><span class=\"label\" ng-class=\"{\'label-primary\': p.status.id == \'v\', \'label-success\': p.status.id == \'a\', \'label-danger\': p.status.id == \'e\', \'label-default\': p.status.id == \'n\'}\">{{ $index+1 }}</span></td><td>{{ p.region }}</td><td>{{ p.subregion }}</td><td>{{ p.address.street }} {{ p.address.building_number }} <span ng-if=\"p.address.stairwell_number\">kl. {{p.address.stairwell_number}}</span> {{ p.address.post_code }} {{ p.address.city }} <b ng-if=\"main.isAdmin()\">({{p.address.original_street}} - {{p.address.original_building_number}})</b></td><td ng-if=\"p.address.type\">{{ p.address.type }} <span ng-if=\"p.address.intercom\">{{ \" / Tak\" }}</span> <span ng-if=\"!p.address.intercom\">{{ \" / Nie\" }}</span></td><td ng-if=\"!p.address.type\">{{ \"Brak danych\" }} <span ng-if=\"p.address.intercom\">{{ \" / Tak\" }}</span> <span ng-if=\"!p.address.intercom\">{{ \" / Nie\" }}</span></td><td class=\"noExport\"><button ng-if=\"p.photos_count\" data-toggle=\"modal\" data-target=\"#photoModal\" class=\"btn btn-xs btn-primary\" ng-click=\"getTracePhotos(p)\"><i class=\"fa fa-photo\"></i></button></td><td class=\"text-left\" ng-repeat=\"s in p.surveys | filter: filterFunction | limitTo: 3 track by $index\">{{ s.flat_number }} <b ng-if=\"s\">| {{ s.status.name }}</b> <b ng-if=\"s.audio && (main.isAdmin() || activeRoute.show_record_to_customer) && s.audio.id\">|</b> <a ng-if=\"s.audio && (main.isAdmin() || activeRoute.show_record_to_customer) && s.audio.id\" ng-click=\"downloadFile( s.audio.id, activeRoute.city + \'_\' + p.address.street + \'_\' + p.address.building_number + \'_m_\' + s.flat_number + \'.wav\')\">Download</a><div ng-if=\"s.audio && (main.isAdmin() || activeRoute.show_record_to_customer) && s.audio.id\"><a id=\"{{ activeRoute.city }}_{{p.address.street}}_{{ p.address.building_number }}_m_{{ s.flat_number }}\" ng-click=\"createAudio(activeRoute.city + \'_\' + p.address.street + \'_\' + p.address.building_number + \'_m_\' + s.flat_number + \'_\' + $index, s.audio.id)\">Odtwórz nagranie</a><audio hidden=\"true\" id=\"{{ activeRoute.city }}_{{p.address.street}}_{{ p.address.building_number }}_m_{{ s.flat_number }}_{{$index}}_audio\" controls=\"controls\" autobuffer=\"autobuffer\" type=\"audio/amr\"></audio></div></td><td ng-if=\"(p.surveys | filter: filterFunction).length < 3\" ng-repeat=\"s in range( 3 - (p.surveys | filter: filterFunction).length )\"></td><td>T: {{filterAnswers(p.surveys,\'yes\')}} / N: {{filterAnswers(p.surveys,\'no\')}} / NW: {{filterAnswers(p.surveys,\'undefined\')}} / BR: {{filterAnswers(p.surveys,\'recipent_missing\')}}</td><td><span ng-if=\"p.status.id == \'v\'\">{{ moment(p.updated_at).format(\'YYYY/MM/DD HH:mm\') }}</span> <span ng-if=\"p.status.id != \'v\'\">Brak</span></td><td><span class=\"label label-primary\" ng-if=\"p.status.id == \'v\' && p.efficiency\">TAK</span> <span class=\"label label-danger\" ng-if=\"p.status.id == \'v\' && !p.efficiency\">NIE</span></td><td class=\"noExport\"><button class=\"btn btn-xs btn-warning\" data-toggle=\"modal\" data-target=\"#noteModal\" ng-if=\"(p.note != undefined) || checkSurveyNote(p.surveys)\" ng-click=\"showNoteBtn(true, p.description)\"><i class=\"fa fa-envelope-o\"></i></button></td></tr></tbody></table></div></div></div></div><div class=\"row\"><div id=\"map-container\"><ng-map center=\"{{ centerMap }}\" style=\"min-height: 100%; height: 750px\"><kml-layer ng-if=\"activeRoute.show_kml_to_customer || main.isAdmin()\" url=\"{{ activeRoute.kml_url }}\"></kml-layer><custom-marker ng-if=\"p.location.latitude\" id=\"{{ p.id }}\" ng-repeat=\"p in activeRoute.points track by $index\" position=\"{{ [p.location.latitude, p.location.longitude] }}\"><div ng-class=\"{\'label-primary\': p.status.id == \'v\' && p.efficiency, \'label-danger\' : p.status.id == \'v\' && !p.efficiency}\"><b>{{ $index + 1}}</b></div></custom-marker><marker title=\"Start\" ng-if=\"firstPointOnRoute[0] && main.isAdmin()\" position=\"{{ [ firstPointOnRoute[0], firstPointOnRoute[1] ] }}\" icon=\"{ url: \'assets/images/start_flag.png\', scaledSize:[30,30], origin: [0,0], anchor: [30,30] }\"></marker><marker opacity=\"0\" title=\"UserLocation\" ng-if=\"!activeRoute.work_end && lastPointOnRoute[0] && main.isAdmin()\" position=\"{{ [ lastPointOnRoute[0], lastPointOnRoute[1] ] }}\" icon=\"{ url: \'assets/images/user-point.png\', scaledSize:[30,30], origin: [0,0], anchor: [15,15] }\"></marker><marker title=\"Finish\" ng-if=\"activeRoute.work_end && lastPointOnRoute[0] && main.isAdmin()\" position=\"{{ [ lastPointOnRoute[0], lastPointOnRoute[1] ] }}\" icon=\"{ url: \'assets/images/finish_flag.png\', scaledSize:[30,30], origin: [0,0], anchor: [0,30] }\"></marker><shape ng-if=\"!main.isAdmin()\" name=\"polyline\" path=\"{{ filterPoints }}\" geodesic=\"true\" stroke-color=\"#0000FF\" stroke-opacity=\"0.69\" stroke-weight=\"3\"></shape><shape ng-repeat=\"Points in activeRoute.executorPaths\" ng-if=\"main.isAdmin()\" name=\"polyline\" path=\"{{ Points }}\" geodesic=\"true\" stroke-color=\"#0000FF\" stroke-opacity=\"0.69\" stroke-weight=\"3\"></shape></ng-map><div full-screen-toggle=\"\" class=\"custom-control\">Full Screen</div></div></div></div></div></div></div><style type=\"text/css\">\r\n  html, body {\r\n    width: 100%;\r\n    height: 100%;\r\n    margin: 0\r\n  }\r\n\r\n  div#map-container {\r\n    width: 100%;\r\n    height: 100%;\r\n    position: relative;\r\n    color: rgb(86, 86, 86);\r\n    font-family: Roboto, Arial, sans-serif;\r\n    -webkit-user-select: none;\r\n    font-size: 11px;\r\n  }\r\n\r\n  div#map-container div.custom-control {\r\n    z-index: 1;\r\n    direction: ltr;\r\n    overflow: hidden;\r\n    text-align: center;\r\n    padding: 1px 6px;\r\n    border-bottom-right-radius: 2px;\r\n    border-top-right-radius: 2px;\r\n    -webkit-background-clip: padding-box;\r\n    border-width: 1px 1px 1px 0px;\r\n    border-top-style: solid;\r\n    border-right-style: solid;\r\n    border-bottom-style: solid;\r\n    border-top-color: rgba(0, 0, 0, 0.14902);\r\n    border-right-color: rgba(0, 0, 0, 0.14902);\r\n    border-bottom-color: rgba(0, 0, 0, 0.14902);\r\n    -webkit-box-shadow: rgba(0, 0, 0, 0.298039) 0px 1px 4px -1px;\r\n    box-shadow: rgba(0, 0, 0, 0.298039) 0px 1px 4px -1px;\r\n    min-width: 41px;\r\n    background-color: rgb(255, 255, 255);\r\n    background-clip: padding-box;\r\n  }\r\n\r\n  div#map-container.full-screen {\r\n    position: absolute;\r\n    display: block;\r\n    width: 100%;\r\n    height: 100%;\r\n    top: 0;\r\n    left: 0\r\n  }\r\n\r\n  div#map-container div[full-screen-toggle] {\r\n    cursor: pointer;\r\n    position: absolute;\r\n    top: 10px;\r\n    left: 120px;\r\n  }\r\n\r\n  .pin-true {\r\n    background: rgb(125, 255, 186);\r\n  }\r\n\r\n  .pin-false {\r\n    background: rgb(255, 30, 33);\r\n  }\r\n\r\n  .pin {\r\n    width: 30px;\r\n    height: 30px;\r\n    border-radius: 50% 50% 50% 0;\r\n    position: absolute;\r\n    transform: rotate(-45deg);\r\n    left: 50%;\r\n    top: 50%;\r\n    margin: -20px 0 0 -20px;\r\n  }\r\n\r\n  .pin:after {\r\n    content: \"\";\r\n    width: 14px;\r\n    height: 14px;\r\n    margin: 8px 0 0 8px;\r\n    background: #e6e6e6;\r\n    position: absolute;\r\n    border-radius: 50%;\r\n  }\r\n\r\n  .bounce {\r\n    animation-name: bounce;\r\n    animation-fill-mode: both;\r\n    animation-duration: 1s;\r\n  }\r\n\r\n  .pulse {\r\n    background: #d6d4d4;\r\n    border-radius: 50%;\r\n    height: 14px;\r\n    width: 14px;\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 50%;\r\n    margin: 11px 0px 0px -12px;\r\n    transform: rotateX(55deg);\r\n    z-index: -2;\r\n  }\r\n\r\n  .pulse:after {\r\n    content: \"\";\r\n    border-radius: 50%;\r\n    height: 40px;\r\n    width: 40px;\r\n    position: absolute;\r\n    margin: -13px 0 0 -13px;\r\n    animation: pulsate 1s ease-out;\r\n    animation-iteration-count: infinite;\r\n    opacity: 0;\r\n    box-shadow: 0 0 1px 2px #00cae9;\r\n    animation-delay: 1.1s;\r\n  }\r\n\r\n  @keyframes pulsate {\r\n    0% {\r\n      transform: scale(0.1, 0.1);\r\n      opacity: 0;\r\n    }\r\n\r\n    50% {\r\n      opacity: 1;\r\n    }\r\n\r\n    100% {\r\n      transform: scale(1.2, 1.2);\r\n      opacity: 0;\r\n    }\r\n  }\r\n\r\n  @keyframes bounce {\r\n    0% {\r\n      opacity: 0;\r\n      transform: translateY(-2000px) rotate(-45deg);\r\n    }\r\n\r\n    60% {\r\n      opacity: 1;\r\n      transform: translateY(30px) rotate(-45deg);\r\n    }\r\n\r\n    80% {\r\n      transform: translateY(-10px) rotate(-45deg);\r\n    }\r\n\r\n    100% {\r\n      transform: translateY(0) rotate(-45deg);\r\n    }\r\n  }\r\n\r\n\r\n  ng-map {\r\n    display: block;\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n\r\n  .custom-marker {\r\n    font-size: 1.2em;\r\n    padding: 4px;\r\n    -webkit-border-radius: 4px;\r\n    -moz-border-radius: 4px;\r\n    border-radius: 4px;\r\n    text-align: center;\r\n  }\r\n\r\n  .custom-marker:after {\r\n    content: \'\';\r\n    position: absolute;\r\n    border-style: solid;\r\n    border-width: 7px 6px 0;\r\n    border-color: #fff transparent;\r\n    display: block;\r\n    width: 0;\r\n    z-index: 1;\r\n    margin-left: -6px;\r\n    bottom: -6px;\r\n    left: 50%;\r\n  }\r\n\r\n  div[title=\"UserLocation\"] {\r\n    opacity: 1 !important;\r\n    z-index: 1 !important;\r\n    -webkit-animation: breathing 7s ease-out infinite normal;\r\n    animation: breathing 7s ease-out infinite normal;\r\n  }\r\n\r\n  div[title=\"UserLocation\"] img {\r\n    opacity: 1 !important;\r\n    z-index: 1 !important;\r\n  }\r\n\r\n  @keyframes load {\r\n    0% {\r\n      opacity: 0.08;\r\n      /*         font-size: 10px; */\r\n      /* 				font-weight: 400; */\r\n      filter: blur(5px);\r\n      letter-spacing: 3px;\r\n    }\r\n    100% {\r\n      /*         opacity: 1; */\r\n      /*         font-size: 12px; */\r\n      /* 				font-weight:600; */\r\n      /* 				filter: blur(0); */\r\n    }\r\n  }\r\n\r\n  .animate {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100%;\r\n    margin: auto;\r\n    /* 	width: 350px; */\r\n    /* 	font-size:26px; */\r\n    font-family: Helvetica, sans-serif, Arial;\r\n    animation: load 1.2s infinite 0s ease-in-out;\r\n    animation-direction: alternate;\r\n    text-shadow: 0 0 1px white;\r\n  }\r\n\r\n  .loader {\r\n    width: 100%;\r\n    position: absolute;\r\n    height: 100vh;\r\n    z-index: 100000000;\r\n    background: rgba(0, 0, 0, 0.2);\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .custom-marker:before {\r\n    content: \'\';\r\n    position: absolute;\r\n    border-style: solid;\r\n    border-width: 7px 6px 0;\r\n    border-color: #7F7F7F transparent;\r\n    display: block;\r\n    width: 0;\r\n    z-index: 0;\r\n    margin-left: -6px;\r\n    bottom: -7px;\r\n    left: 50%;\r\n  }\r\n\r\n  .sk-fading-circle {\r\n    margin: 100px auto;\r\n    width: 40px;\r\n    height: 40px;\r\n    position: relative;\r\n  }\r\n\r\n  .sk-fading-circle .sk-circle {\r\n    width: 100%;\r\n    height: 100%;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n  }\r\n\r\n  .sk-fading-circle .sk-circle:before {\r\n    content: \'\';\r\n    display: block;\r\n    margin: 0 auto;\r\n    width: 15%;\r\n    height: 15%;\r\n    background-color: #333;\r\n    border-radius: 100%;\r\n    -webkit-animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;\r\n    animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;\r\n  }\r\n\r\n  .sk-fading-circle .sk-circle2 {\r\n    -webkit-transform: rotate(30deg);\r\n    -ms-transform: rotate(30deg);\r\n    transform: rotate(30deg);\r\n  }\r\n\r\n  .sk-fading-circle .sk-circle3 {\r\n    -webkit-transform: rotate(60deg);\r\n    -ms-transform: rotate(60deg);\r\n    transform: rotate(60deg);\r\n  }\r\n\r\n  .sk-fading-circle .sk-circle4 {\r\n    -webkit-transform: rotate(90deg);\r\n    -ms-transform: rotate(90deg);\r\n    transform: rotate(90deg);\r\n  }\r\n\r\n  .sk-fading-circle .sk-circle5 {\r\n    -webkit-transform: rotate(120deg);\r\n    -ms-transform: rotate(120deg);\r\n    transform: rotate(120deg);\r\n  }\r\n\r\n  .sk-fading-circle .sk-circle6 {\r\n    -webkit-transform: rotate(150deg);\r\n    -ms-transform: rotate(150deg);\r\n    transform: rotate(150deg);\r\n  }\r\n\r\n  .sk-fading-circle .sk-circle7 {\r\n    -webkit-transform: rotate(180deg);\r\n    -ms-transform: rotate(180deg);\r\n    transform: rotate(180deg);\r\n  }\r\n\r\n  .sk-fading-circle .sk-circle8 {\r\n    -webkit-transform: rotate(210deg);\r\n    -ms-transform: rotate(210deg);\r\n    transform: rotate(210deg);\r\n  }\r\n\r\n  .sk-fading-circle .sk-circle9 {\r\n    -webkit-transform: rotate(240deg);\r\n    -ms-transform: rotate(240deg);\r\n    transform: rotate(240deg);\r\n  }\r\n\r\n  .sk-fading-circle .sk-circle10 {\r\n    -webkit-transform: rotate(270deg);\r\n    -ms-transform: rotate(270deg);\r\n    transform: rotate(270deg);\r\n  }\r\n\r\n  .sk-fading-circle .sk-circle11 {\r\n    -webkit-transform: rotate(300deg);\r\n    -ms-transform: rotate(300deg);\r\n    transform: rotate(300deg);\r\n  }\r\n\r\n  .sk-fading-circle .sk-circle12 {\r\n    -webkit-transform: rotate(330deg);\r\n    -ms-transform: rotate(330deg);\r\n    transform: rotate(330deg);\r\n  }\r\n\r\n  .sk-fading-circle .sk-circle2:before {\r\n    -webkit-animation-delay: -1.1s;\r\n    animation-delay: -1.1s;\r\n  }\r\n\r\n  .sk-fading-circle .sk-circle3:before {\r\n    -webkit-animation-delay: -1s;\r\n    animation-delay: -1s;\r\n  }\r\n\r\n  .sk-fading-circle .sk-circle4:before {\r\n    -webkit-animation-delay: -0.9s;\r\n    animation-delay: -0.9s;\r\n  }\r\n\r\n  .sk-fading-circle .sk-circle5:before {\r\n    -webkit-animation-delay: -0.8s;\r\n    animation-delay: -0.8s;\r\n  }\r\n\r\n  .sk-fading-circle .sk-circle6:before {\r\n    -webkit-animation-delay: -0.7s;\r\n    animation-delay: -0.7s;\r\n  }\r\n\r\n  .sk-fading-circle .sk-circle7:before {\r\n    -webkit-animation-delay: -0.6s;\r\n    animation-delay: -0.6s;\r\n  }\r\n\r\n  .sk-fading-circle .sk-circle8:before {\r\n    -webkit-animation-delay: -0.5s;\r\n    animation-delay: -0.5s;\r\n  }\r\n\r\n  .sk-fading-circle .sk-circle9:before {\r\n    -webkit-animation-delay: -0.4s;\r\n    animation-delay: -0.4s;\r\n  }\r\n\r\n  .sk-fading-circle .sk-circle10:before {\r\n    -webkit-animation-delay: -0.3s;\r\n    animation-delay: -0.3s;\r\n  }\r\n\r\n  .sk-fading-circle .sk-circle11:before {\r\n    -webkit-animation-delay: -0.2s;\r\n    animation-delay: -0.2s;\r\n  }\r\n\r\n  .sk-fading-circle .sk-circle12:before {\r\n    -webkit-animation-delay: -0.1s;\r\n    animation-delay: -0.1s;\r\n  }\r\n\r\n  @-webkit-keyframes breathing {\r\n    0% {\r\n      -webkit-transform: scale(0.5);\r\n      transform: scale(0.5);\r\n    }\r\n\r\n    25% {\r\n      -webkit-transform: scale(1);\r\n      transform: scale(1);\r\n    }\r\n\r\n    60% {\r\n      -webkit-transform: scale(0.5);\r\n      transform: scale(0.5);\r\n    }\r\n\r\n    100% {\r\n      -webkit-transform: scale(0.5);\r\n      transform: scale(0.5);\r\n    }\r\n  }\r\n\r\n  @keyframes breathing {\r\n    0% {\r\n      -webkit-transform: scale(0.5);\r\n      -ms-transform: scale(0.5);\r\n      transform: scale(0.5);\r\n    }\r\n\r\n    25% {\r\n      -webkit-transform: scale(1);\r\n      -ms-transform: scale(1);\r\n      transform: scale(1);\r\n    }\r\n\r\n    60% {\r\n      -webkit-transform: scale(0.5);\r\n      -ms-transform: scale(0.5);\r\n      transform: scale(0.5);\r\n    }\r\n\r\n    100% {\r\n      -webkit-transform: scale(0.5);\r\n      -ms-transform: scale(0.5);\r\n      transform: scale(0.5);\r\n    }\r\n  }\r\n\r\n\r\n  @-webkit-keyframes sk-circleFadeDelay {\r\n    0%, 39%, 100% {\r\n      opacity: 0;\r\n    }\r\n    40% {\r\n      opacity: 1;\r\n    }\r\n  }\r\n\r\n  @keyframes sk-circleFadeDelay {\r\n    0%, 39%, 100% {\r\n      opacity: 0;\r\n    }\r\n    40% {\r\n      opacity: 1;\r\n    }\r\n  }\r\n\r\n  .pagination {\r\n    display: table;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .pagination a {\r\n    color: black;\r\n    float: left;\r\n    padding: 8px 16px;\r\n    text-decoration: none;\r\n  }\r\n\r\n  .pagination a.active {\r\n    background-color: #4CAF50;\r\n    color: white;\r\n    border-radius: 5px;\r\n  }\r\n\r\n  .pagination a:hover:not(.active) {\r\n    background-color: #ddd;\r\n    border-radius: 5px;\r\n  }\r\n\r\n  .buttons-pdf {\r\n    display: none;\r\n  }\r\n\r\n  .custom-pdf-button {\r\n    display: inline;\r\n    margin-left: auto;\r\n  }\r\n\r\n  audio {\r\n    display: none;\r\n  }\r\n</style>");
$templateCache.put("app/routes/routes-history.html","<div class=\"wrapper wrapper-content animated fadeInRight\" ng-controller=\"RoutesHistoryController as routesCtrl\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Audyty</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.main\">Historia</a></li></ol></div></div><div class=\"row\"><div class=\"col-lg-1\"><label class=\"col-sm-3 control-label\">Wykonawca</label></div><div class=\"col-lg-2\"><input type=\"text\" ng-model=\"routesCtrl.search_auditor\"></div><div class=\"col-lg-1\"><label class=\"col-sm-3 control-label\">Od</label></div><div class=\"col-lg-2\"><input type=\"date\" class=\"form-control\" ng-model=\"routesCtrl.search_start_date\" ng-required=\"false\"></div><div class=\"col-lg-1\"><label class=\"col-sm-3 control-label\">Do</label></div><div class=\"col-lg-2\"><input type=\"date\" class=\"form-control\" ng-model=\"routesCtrl.search_end_date\" ng-required=\"false\"></div><div class=\"col-lg-1\"><button ng-click=\"routesCtrl.search()\">Filtruj</button></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>Lista etapów</h5></div><div class=\"ibox-content\"><table datatable=\"ng\" dt-instance=\"routesCtrl.dtInstance\" dt-options=\"routesCtrl.dtOptions\" class=\"table table-sm table-striped table-bordered table-hover\"><thead><tr><th>Wykonawca</th><th>Miasto</th><th>Stan Licznika</th><th>Etap</th><th>Data</th><th>Audyt</th><th>Zdjęcie</th><th>Dystans</th></tr></thead><tbody><tr ng-repeat=\"r in routesCtrl.data.routes_history\"><td>{{ r.auditor.name }}</td><td>{{ r.city }}</td><td>{{ r.odometer }} <input id=\"new_odometer_value_{{r.id}}\" class=\"no-form\" ng-show=\"routesCtrl.odomoter_edits[r.id]\"> <i class=\"fa fa-check\" ng-show=\"routesCtrl.odomoter_edits[r.id]\" ng-click=\"routesCtrl.changeOdometerData(r.id)\"></i> <i class=\"fa fa-close\" ng-show=\"routesCtrl.odomoter_edits[r.id]\" ng-click=\"routesCtrl.odomoter_edits[r.id] = !routesCtrl.odomoter_edits[r.id]\"></i> <i class=\"fa fa-edit\" ng-show=\"!routesCtrl.odomoter_edits[r.id]\" ng-click=\"routesCtrl.odomoter_edits[r.id] = !routesCtrl.odomoter_edits[r.id]\" style=\"float: right;\"></i></td><td>{{ r.state }}</td><td>{{ r.active_date }}</td><td>{{ r.trace_id }}</td><td><a target=\"_blank\" href=\"https://apipam.audytymarketingowe.pl/files/{{ r.picture }}\">{{ r.picture }}</a></td><td><span ng-if=\"r.state == \'finished\'\">{{ routesCtrl.distancePoints[r.trace_id] }}</span></td></tr></tbody></table><br>Stawka za kilometr: <input ng-model=\"routesCtrl.km_rate\" ng-change=\"routesCtrl.kmRateChanged()\"><table datatable=\"ng\" dt-instance=\"routesCtrl.dtInstance\" dt-options=\"routesCtrl.dtOptions\" class=\"table table-sm table-striped table-bordered table-hover\"><thead><th>Nr kolejny wpisu</th><th>Data wyjazdu</th><th>Opis trasy wyjazdu (skąd-dokąd)</th><th>Cel wyjazdu</th><th></th><th>Liczba faktycznie przejechanych kilometrów</th><th>Stawka za 1km przebiegu</th><th>Wartość</th><th>Podpis podatnika</th><th>Uwagi</th></thead><tbody><tr ng-repeat=\"r in routesCtrl.data.routes_history\" ng-if=\"r.state == \'finished\'\"><td>{{$index + 1}}</td><td>{{ r.active_date }}</td><td style=\"text-align:center;\">{{ r.city }}</td><td style=\"text-align:center;\" id=\"route_type_{{ r.id}}\">audyt</td><td><select ng-model=\"routesCtrl.route_types[r.id]\" ng-change=\"routesCtrl.changeRouteType(r.id)\" data-route-id=\"{{ r.id }}\"><option selected=\"\">audyt</option><option>kontrola</option></select></td><td style=\"text-align:center;\">{{ routesCtrl.distancePoints[r.trace_id] }} km</td><td align=\"center\">{{ routesCtrl.km_rate }}</td><td>{{ (routesCtrl.km_rate * routesCtrl.distancePoints[r.trace_id]).toFixed(2) }}</td><td>.............</td><td>.............</td></tr><tr><td></td><td></td><td></td><td>Podsumowanie strony</td><td></td><td></td><td></td><td></td><td></td><td></td></tr><tr><td></td><td></td><td></td><td>Z przeniesienia</td><td></td><td></td><td></td><td></td><td></td><td></td></tr><tr><td></td><td></td><td></td><td>Razem</td><td></td><td>{{ routesCtrl.distancePointsTotal }}</td><td></td><td>{{ routesCtrl.distancePointsTotalPay.toFixed(2) }}</td><td></td><td></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/routes/routes-search.html","<div class=\"wrapper wrapper-content animated fadeInRight\" ng-controller=\"RoutesSearchController as routesCtrl\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Audyty</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.main\">Panel</a></li><li><a ui-sref=\"index.campaigns\">Kampanie</a></li><li class=\"active\"><strong>Audyty</strong></li></ol></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5><b>Wyszukiwanie:</b></h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"form-group col-sm-3\"><label class=\"col-sm-5 control-label\">Kampania</label><div class=\"col-sm-6\"><input type=\"text\" ng-model=\"routesCtrl.search_campaign\" class=\"form-control\" ng-required=\"false\"></div><div class=\"col-sm-1\"><button ng-click=\"routesCtrl.addFilter(\'campaign\', routesCtrl.search_campaign)\">+</button></div></div><div class=\"form-group col-sm-3\"><label class=\"col-sm-5 control-label\">Miasto</label><div class=\"col-sm-6\"><input type=\"text\" ng-model=\"routesCtrl.search_city\" class=\"form-control\" ng-required=\"false\"></div><div class=\"col-sm-1\"><button ng-click=\"routesCtrl.addFilter(\'city\', routesCtrl.search_city)\">+</button></div></div><div class=\"form-group col-sm-3\"><label class=\"col-sm-5 control-label\">Klient</label><div class=\"col-sm-6\"><input type=\"text\" ng-model=\"routesCtrl.search_customer\" class=\"form-control\" ng-required=\"false\"></div><div class=\"col-sm-1\"><button ng-click=\"routesCtrl.addFilter(\'customer\', routesCtrl.search_customer)\">+</button></div></div><div class=\"form-group col-sm-3\"><label class=\"col-sm-5 control-label\">Dystrybutor</label><div class=\"col-sm-6\"><input type=\"text\" class=\"form-control\" ng-model=\"routesCtrl.search_distributor\" ng-required=\"false\"></div><div class=\"col-sm-1\"><button ng-click=\"routesCtrl.addFilter(\'distributor\', routesCtrl.search_distributor)\">+</button></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"form-group col-sm-3\"><label class=\"col-sm-5 control-label\">Materiał</label><div class=\"col-sm-6\"><input type=\"text\" ng-model=\"routesCtrl.search_advertising_material\" class=\"form-control\" ng-required=\"false\"></div><div class=\"col-sm-1\"><button ng-click=\"routesCtrl.addFilter(\'advertising_material\', routesCtrl.search_advertising_material)\">+</button></div></div><div class=\"form-group col-sm-3\"><label class=\"col-sm-5 control-label\">Wykonawca</label><div class=\"col-sm-6\"><input type=\"text\" ng-model=\"routesCtrl.search_auditor\" class=\"form-control\" ng-required=\"false\"></div><div class=\"col-sm-1\"><button ng-click=\"routesCtrl.addFilter(\'auditor\', routesCtrl.search_auditor)\">+</button></div></div><div class=\"form-group col-sm-2\"><label class=\"col-sm-4 control-label\">Status</label><div class=\"col-sm-6\"><select ng-model=\"routesCtrl.search_status\" class=\"form-control\" ng-required=\"false\"><option value=\"s\">Nowy</option><option value=\"f\">Zakończony</option></select></div><div class=\"col-sm-1\"><button ng-click=\"routesCtrl.addFilter(\'status\', routesCtrl.search_status)\">+</button></div></div><div class=\"form-group col-sm-4\"><label class=\"col-sm-3 control-label\">Data realizacji</label><div class=\"col-sm-4\"><input type=\"date\" class=\"form-control\" ng-model=\"routesCtrl.search_start_date\" ng-required=\"false\"></div><div class=\"col-sm-4\"><input type=\"date\" class=\"form-control\" ng-model=\"routesCtrl.search_end_date\" ng-required=\"false\"></div><div class=\"col-sm-1\"><button ng-click=\"routesCtrl.addFilter(\'start_date\', routesCtrl.search_start_date, routesCtrl.search_end_date )\">+</button></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div ng-repeat=\"(key, value) in routesCtrl.currentFilters\">Filtry dla {{ key }}: <span ng-repeat=\"wartoscFiltra in value\">{{ wartoscFiltra }} <button class=\"btn btn-xs btn-danger\" ng-click=\"routesCtrl.removeFilter(key, wartoscFiltra)\"><i class=\"fa fa-trash-o\"></i></button> <span ng-if=\"!$last\">,</span></span></div><br><button ng-click=\"routesCtrl.search()\">Search</button></div></div></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>Lista Audytów</h5></div><div class=\"ibox-content\"><table datatable=\"ng\" dt-instance=\"routesCtrl.dtInstance\" dt-options=\"routesCtrl.dtOptions\" class=\"table table-sm table-striped table-bordered table-hover\"><thead><tr><th ng-hide=\"!main.isAdmin()\">ID</th><th>Kampania</th><th>Miasto</th><th ng-if=\"main.isAdmin()\">Klient</th><th ng-if=\"main.isAdmin()\">Dystrybutor</th><th ng-if=\"main.isAdmin()\">Materiał reklamowy</th><th>Wykonawca</th><th>Status</th><th>Data realizacji</th><th ng-hide=\"true\">Nagrywanie?</th><th>Odwiedzone punkty</th><th>Czy skuteczny?</th><th>Akcje</th></tr></thead><tbody><tr ng-repeat=\"r in routesCtrl.data.routes\"><td ng-hide=\"!main.isAdmin()\">{{ r.id }}</td><td>{{ r.campaign.id }} - {{ r.campaign.name }}</td><td>{{ r.city }}</td><td ng-if=\"main.isAdmin()\">{{ r.customer || \'---\' }}</td><td ng-if=\"main.isAdmin()\">{{ r.distributor || \'---\' }}</td><td ng-if=\"main.isAdmin()\">{{ r.advertising_material || \'---\' }}</td><td>{{ r.auditor.first_name }} {{ r.auditor.last_name }}</td><td>{{ r.status.name }}</td><td>{{ routesCtrl.moment(r.start_date).format(\'YYYY/MM/DD\') }}</td><td ng-hide=\"true\">{{ r.recording_enabled ? \"TAK\" : \"NIE\" }}</td><td>{{ r.visited_points_count }} / {{ r.points_count }}</td><td ng-class=\"{ \'bg-success\' : r.is_effective, \'bg-danger\' : !r.is_effective }\">{{ r.is_effective ? \"TAK\" : \"NIE\" }} | {{ r.percent_effectiveness }}%</td><td ng-if=\"r.parent == undefined\"><button ng-if=\"(r.status.id == \'n\' || r.status.id == \'s\') && main.isAdmin()\" title=\"Aktywuj Audyt\" class=\"btn btn-xs btn-primary\" ng-click=\"routesCtrl.changeStatus(r.id, \'a\', r.campaign.name)\"><i class=\"fa fa-check\"></i></button> <button ng-if=\"(r.status.id == \'a\') && main.isAdmin()\" title=\"Zawieś Audyt\" class=\"btn btn-xs btn-warning\" ng-click=\"routesCtrl.changeStatus(r.id, \'s\', r.campaign.name)\"><i class=\"fa fa-close\"></i></button> <a class=\"btn btn-xs btn-primary\" ng-click=\"routesCtrl.show(r)\"><i class=\"fa fa-eye\"></i></a> <button ng-if=\"(r.status.id == \'n\' && routesCtrl.campaign_id && main.isAdmin()) || main.isAdmin()\" class=\"btn btn-xs btn-primary\" ng-click=\"routesCtrl.edit(r)\"><i class=\"fa fa-edit\"></i></button> <button ng-if=\"main.isAdmin()\" class=\"btn btn-xs btn-danger\" data-toggle=\"modal\" data-target=\"#deleteModal\" ng-click=\"routesCtrl.sendParamsToDelModal(true, r)\"><i class=\"fa fa-trash-o\"></i></button> <button class=\"btn btn-xs btn-warning\" ng-if=\"r.note != undefined\" data-toggle=\"modal\" data-target=\"#noteModal\" ng-click=\"routesCtrl.showNoteBtn(true, r.note)\"><i class=\"fa fa-envelope-o\"></i></button> <button class=\"btn btn-xs btn-primary\" ng-if=\"r.status.id === \'f\'\" ng-click=\"routesCtrl.generateReport(r.id, r.city, routesCtrl.moment(r.start_date).format(\'YYYY/MM/DD\'))\"><i class=\"fa fa-file-excel-o\"></i></button></td><td ng-if=\"r.parent != undefined\"><a class=\"btn btn-xs btn-primary\" ui-sref=\"index.route-view({id: r.id})\"><i class=\"fa fa-eye\"></i></a> <button ng-if=\"main.isAdmin()\" class=\"btn btn-xs btn-danger\" data-toggle=\"modal\" data-target=\"#deleteModal\" ng-click=\"routesCtrl.sendParamsToDelModal(true, r)\"><i class=\"fa fa-trash-o\"></i></button> <button class=\"btn btn-xs btn-warning\" ng-if=\"r.note != undefined\" data-toggle=\"modal\" data-target=\"#noteModal\" ng-click=\"routesCtrl.showNoteBtn(true, r.note)\"><i class=\"fa fa-envelope-o\"></i></button> <button class=\"btn btn-xs btn-primary\" ng-if=\"r.status.id === \'f\'\" ng-click=\"routesCtrl.generateReport(r.id, r.city, routesCtrl.moment(r.start_date).format(\'YYYY/MM/DD\'))\"><i class=\"fa fa-file-excel-o\"></i></button></td></tr></tbody></table></div></div></div></div><div id=\"deleteModal\" class=\"modal inmodal fade in\" aria-hidden=\"true\" ng-show=\"routesCtrl.selectedRouteShowDeleteModal\" style=\"display: block; padding-right: 15px;\"><div class=\"modal-dialog modal-sm\"><div class=\"modal-content animated bounceInRight\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\">&times;</button> <b>Kasowanie</b></div><div class=\"modal-body\"><strong>Czy aby na pewno chcesz skasować Audyt dla Kampanii: {{routesCtrl.routeName}}?</strong></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" data-dismiss=\"modal\" ng-click=\"routesCtrl.showDelModal(false)\">Zamknij</button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"routesCtrl.deleteRoute(routesCtrl.routeId, routesCtrl.campaign[0].name)\">Skasuj audyt</button></div></div></div></div><div class=\"modal inmodal in\" id=\"noteModal\" aria-hidden=\"true\" role=\"dialog\" ng-show=\"routesCtrl.showNote\" style=\"display: block; z-index: 9999\"><div class=\"modal-dialog\"><div class=\"modal-content animated bounceInRight\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\">&times;</button> <b>Notatka</b></div><div class=\"modal-body\">{{ routesCtrl.note }}</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" data-dismiss=\"modal\">Zamknij</button></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><button class=\"btn btn-info\" ng-if=\"routesCtrl.campaign_id && main.isAdmin()\" ng-click=\"routesCtrl.addRoute()\">Dodaj</button></div></div></div>");
$templateCache.put("app/routes/routes.html","<div class=\"wrapper wrapper-content animated fadeInRight\" ng-controller=\"RoutesController as routesCtrl\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Audyty</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"index.main\">Panel</a></li><li><a ui-sref=\"index.campaigns\">Kampanie</a></li><li class=\"active\"><strong>Audyty</strong></li></ol></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5><b>Statystyki Kampanii:</b> {{ routesCtrl.campaign[0].name}}, <b>Klient:</b> {{ routesCtrl.campaign[0].customer.name}}</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-6\"><h5>Średni procent skuteczności zakończonych audytów</h5><h2>{{ routesCtrl.data.averageRoutesPercent }}%</h2><div class=\"progress progress-mini\"><div style=\"width: {{ routesCtrl.data.averageRoutesPercent }}%;\" class=\"progress-bar\"></div></div><div class=\"m-t-sm small\">Zakończono {{ routesCtrl.data.completeRoutes }}/{{ routesCtrl.data.routes.length }} Audytów</div></div><div class=\"col-lg-6\"><h5>Skuteczne Audyty</h5><h2>{{ routesCtrl.data.routeEffectivePercent }}%</h2><div class=\"progress progress-mini\"><div style=\"width: {{ routesCtrl.data.routeEffectivePercent }}%;\" class=\"progress-bar\" ng-class=\"{\'progress-bar-warning\': routesCtrl.data.routeEffectivePercent < 75, }\"></div></div><div class=\"m-t-sm small\">Skuteczność {{ routesCtrl.data.effectiveRoutes }} z {{ routesCtrl.data.routes.length }} Audytów</div></div></div></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>Lista Audytów</h5></div><div class=\"ibox-content\"><table datatable=\"ng\" dt-instance=\"routesCtrl.dtInstance\" dt-options=\"routesCtrl.dtOptions\" class=\"table table-sm table-striped table-bordered table-hover\"><thead><tr><th ng-hide=\"!main.isAdmin()\">ID</th><th>Kampania</th><th>Miasto</th><th ng-if=\"main.isAdmin()\">Klient</th><th ng-if=\"main.isAdmin()\">Dystrybutor</th><th ng-if=\"main.isAdmin()\">Materiał reklamowy</th><th>Wykonawca</th><th>Status</th><th>Data realizacji</th><th ng-hide=\"true\">Nagrywanie?</th><th>Odwiedzone punkty</th><th>Czy skuteczny?</th><th>Akcje</th></tr></thead><tbody><tr ng-repeat=\"r in routesCtrl.data.routes\"><td ng-hide=\"!main.isAdmin()\">{{ r.id }}</td><td>{{ r.campaign.name }}</td><td>{{ r.city }}</td><td ng-if=\"main.isAdmin()\">{{ r.customer || \'---\' }}</td><td ng-if=\"main.isAdmin()\">{{ r.distributor || \'---\' }}</td><td ng-if=\"main.isAdmin()\">{{ r.advertising_material || \'---\' }}</td><td>{{ r.auditor.first_name }} {{ r.auditor.last_name }}</td><td>{{ r.status.name }}</td><td>{{ routesCtrl.moment(r.start_date).format(\'YYYY/MM/DD\') }}</td><td ng-hide=\"true\">{{ r.recording_enabled ? \"TAK\" : \"NIE\" }}</td><td>{{ r.visited_points_count }} / {{ r.points_count }}</td><td ng-class=\"{ \'bg-success\' : r.is_effective, \'bg-danger\' : !r.is_effective }\">{{ r.is_effective ? \"TAK\" : \"NIE\" }} | {{ r.percent_effectiveness }}%</td><td ng-if=\"r.parent == undefined\"><button ng-if=\"(r.status.id == \'n\' || r.status.id == \'s\') && main.isAdmin()\" title=\"Aktywuj Audyt\" class=\"btn btn-xs btn-primary\" ng-click=\"routesCtrl.changeStatus(r.id, \'a\', r.campaign.name)\"><i class=\"fa fa-check\"></i></button> <button ng-if=\"(r.status.id == \'a\') && main.isAdmin()\" title=\"Zawieś Audyt\" class=\"btn btn-xs btn-warning\" ng-click=\"routesCtrl.changeStatus(r.id, \'s\', r.campaign.name)\"><i class=\"fa fa-close\"></i></button> <a class=\"btn btn-xs btn-primary\" ng-click=\"routesCtrl.show(r)\"><i class=\"fa fa-eye\"></i></a> <button ng-if=\"(r.status.id == \'n\' && routesCtrl.campaign_id && main.isAdmin()) || main.isAdmin()\" class=\"btn btn-xs btn-primary\" ng-click=\"routesCtrl.edit(r)\"><i class=\"fa fa-edit\"></i></button> <button ng-if=\"main.isAdmin()\" class=\"btn btn-xs btn-primary\" data-toggle=\"modal\" data-target=\"#cloneModal\" ng-click=\"routesCtrl.sendParamsToModal(true, r)\"><i class=\"fa fa-clone\"></i></button> <button ng-if=\"main.isAdmin()\" class=\"btn btn-xs btn-danger\" data-toggle=\"modal\" data-target=\"#deleteModal\" ng-click=\"routesCtrl.sendParamsToDelModal(true, r)\"><i class=\"fa fa-trash-o\"></i></button> <button class=\"btn btn-xs btn-warning\" ng-if=\"r.note != undefined\" data-toggle=\"modal\" data-target=\"#noteModal\" ng-click=\"routesCtrl.showNoteBtn(true, r.note)\"><i class=\"fa fa-envelope-o\"></i></button> <button class=\"btn btn-xs btn-primary\" ng-if=\"r.status.id === \'f\'\" ng-click=\"routesCtrl.generateReport(r.id, r.city, routesCtrl.moment(r.start_date).format(\'YYYY/MM/DD\'))\"><i class=\"fa fa-file-excel-o\"></i></button></td><td ng-if=\"r.parent != undefined\"><a class=\"btn btn-xs btn-primary\" ui-sref=\"index.route-view({id: r.id})\"><i class=\"fa fa-eye\"></i></a> <button ng-if=\"main.isAdmin()\" class=\"btn btn-xs btn-danger\" data-toggle=\"modal\" data-target=\"#deleteModal\" ng-click=\"routesCtrl.sendParamsToDelModal(true, r)\"><i class=\"fa fa-trash-o\"></i></button> <button class=\"btn btn-xs btn-warning\" ng-if=\"r.note != undefined\" data-toggle=\"modal\" data-target=\"#noteModal\" ng-click=\"routesCtrl.showNoteBtn(true, r.note)\"><i class=\"fa fa-envelope-o\"></i></button> <button class=\"btn btn-xs btn-primary\" ng-if=\"r.status.id === \'f\'\" ng-click=\"routesCtrl.generateReport(r.id, r.city, routesCtrl.moment(r.start_date).format(\'YYYY/MM/DD\'))\"><i class=\"fa fa-file-excel-o\"></i></button></td></tr></tbody></table></div></div></div></div><div id=\"deleteModal\" class=\"modal inmodal fade in\" aria-hidden=\"true\" ng-show=\"routesCtrl.showDeleteModal\" style=\"display: block; padding-right: 15px;\"><div class=\"modal-dialog modal-sm\"><div class=\"modal-content animated bounceInRight\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\">&times;</button> <b>Kasowanie</b></div><div class=\"modal-body\"><strong>Czy aby na pewno chcesz skasować Audyt dla Kampanii: {{routesCtrl.routeName}}?</strong></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" data-dismiss=\"modal\" ng-click=\"routesCtrl.showDelModal(false)\">Zamknij</button> <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" ng-click=\"routesCtrl.deleteRoute(routesCtrl.routeId, routesCtrl.campaign[0].name)\">Skasuj audyt</button></div></div></div></div><div class=\"modal inmodal fade in\" aria-hidden=\"true\" ng-show=\"routesCtrl.showModal\" id=\"cloneModal\" style=\"display: block; padding-right: 15px;\"><div class=\"modal-dialog modal-sm\"><div class=\"modal-content animated bounceInRight\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\">&times;</button> <b>Klonowanie</b></div><div class=\"modal-body\"><strong>Klonowany audyt: {{routesCtrl.routeName}}</strong> Dla jakiego klienta chcesz sklonować audyt?<div><h3>Klient:</h3></div><div class=\"col-sm-10\"><select class=\"form-control m-b\" ng-options=\"c.id as c.name for c in data.customers\" ng-required=\"true\" ng-model=\"routesCtrl.cloneId\"></select></div></div><div class=\"modal-footer\"><button type=\"button\" data-dismiss=\"modal\" class=\"btn btn-white\">Zamknij</button> <button type=\"button\" data-dismiss=\"modal\" class=\"btn btn-primary\" ng-click=\"routesCtrl.cloneCampaign(routesCtrl.routeId, routesCtrl.cloneId, routesCtrl.campaign[0].name)\">Sklonuj kampanie</button></div></div></div></div><div class=\"modal inmodal in\" id=\"noteModal\" aria-hidden=\"true\" role=\"dialog\" ng-show=\"routesCtrl.showNote\" style=\"display: block; z-index: 9999\"><div class=\"modal-dialog\"><div class=\"modal-content animated bounceInRight\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\">&times;</button> <b>Notatka</b></div><div class=\"modal-body\">{{ routesCtrl.note }}</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" data-dismiss=\"modal\">Zamknij</button></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><button class=\"btn btn-info\" ng-if=\"routesCtrl.campaign_id && main.isAdmin()\" ng-click=\"routesCtrl.addRoute()\">Dodaj</button></div></div></div>");
$templateCache.put("app/survey/survey.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><h1>Ankiety</h1><small>TEST BARDZO</small></div></div></div></div>");
$templateCache.put("app/surveys/surveys.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><h1>Ankiety</h1><small>TEST BARDZO</small></div></div></div></div>");
$templateCache.put("app/components/common/content.html","<div id=\"wrapper\"><div ng-include=\"\'app/components/common/navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ng-include=\"\'app/components/common/topnavbar.html\'\"></div><div ui-view=\"\"></div><div ng-include=\"\'app/components/common/footer.html\'\"></div></div></div>");
$templateCache.put("app/components/common/footer.html","<div class=\"footer\"><div class=\"pull-right\"><strong>PAM</strong></div><div><strong>Copyright</strong> Profesjonalne Audyty Marketingowe Sp.z o.o</div></div>");
$templateCache.put("app/components/common/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a uib-dropdown-toggle=\"\" href=\"\"><i class=\"fa fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("app/components/common/navigation.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"profile-element\" uib-dropdown=\"\"><a uib-dropdown-toggle=\"\" href=\"\"><span class=\"clear\"><span class=\"block m-t-xs\"><strong class=\"font-bold\">{{ username }}</strong></span> <span ng-if=\"main.isAdmin()\" class=\"text-muted text-xs block\">Administrator<b class=\"caret\"></b></span> <span ng-if=\"!main.isAdmin()\" class=\"text-muted text-xs block\">Użytkownik<b class=\"caret\"></b></span></span></a><ul uib-dropdown-menu=\"\" class=\"animated flipInX m-t-xs\"><li><a href=\"\" ng-click=\"main.logout()\">Wyloguj</a></li></ul></div><div class=\"logo-element\">PAM</div></li><li ui-sref-active=\"active\"><a ui-sref=\"index.panel\"><i class=\"fa fa-laptop\"></i> <span class=\"nav-label\">Panel</span></a></li><li ng-if=\"main.isAdmin()\" ui-sref-active=\"active\"><a ui-sref=\"index.auditors\"><i class=\"fa fa-users\"></i> <span class=\"nav-label\">Audytorzy</span></a></li><li ng-if=\"main.isAdmin()\" ui-sref-active=\"active\"><a ui-sref=\"index.customers\"><i class=\"fa fa-user\"></i> <span class=\"nav-label\">Klienci</span></a></li><li ng-if=\"main.isAdmin()\" ui-sref-active=\"active\"><a ui-sref=\"index.routes_search\"><i class=\"fa fa-user\"></i> <span class=\"nav-label\">Historia</span></a></li><li ng-if=\"main.isAdmin()\" ui-sref-active=\"active\"><a ui-sref=\"index.routes_history\"><i class=\"fa fa-user\"></i> <span class=\"nav-label\">Kilometry</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.campaigns\"><i class=\"fa fa-laptop\"></i> <span class=\"nav-label\">Kampanie</span></a></li></ul></div></nav>");
$templateCache.put("app/components/common/topnavbar.html","<div class=\"row border-bottom\"><nav class=\"navbar navbar-static-top white-bg\" role=\"navigation\" style=\"margin-bottom: 0\"><div class=\"navbar-header\"><span minimaliza-sidebar=\"\"></span></div><ul class=\"nav navbar-top-links navbar-right\"><li><a href=\"\" ng-click=\"main.logout()\"><i class=\"fa fa-sign-out\"></i> Wyloguj</a></li></ul></nav></div>");}]);